module.exports = {
  messages: {
    A11Y_LOGO: 'Zur XING Startseite',
    A11Y_SETTINGS_DROPDOWN_LABEL: 'Einstellungen verwalten',
    A11Y_XDS_CONNECTION_DEGREE_1: 'Kontakt 1. Grades',
    A11Y_XDS_CONNECTION_DEGREE_2: 'Kontakt 2. Grades',
    A11Y_XDS_CONNECTION_DEGREE_3: 'Kontakt 3. Grades',
    ABOUT_ME: 'Über mich',
    ACCOUNT: 'Nutzerkonto',
    ACTION_BLOCK_USER: 'Blockieren',
    ACTION_BLOCK_USER_DIALOG_DESCRIPTION:
      'Wenn Du {displayName} blockierst, kann Dich dieses Mitglied nicht mehr auf XING kontaktieren.',
    ACTION_BLOCK_USER_DIALOG_TITLE:
      'Möchtest Du Dein Profil für dieses Mitglied blockieren?',
    ACTION_BLOCK_USER_SUCCESS: 'Mitglied blockiert',
    ACTIVE_LANGUAGE: 'Deutsch',
    ADD_ADDRESS: 'Adresse hinzufügen',
    ADD_COMPANY_SIZE: 'Firmengröße hinzufügen',
    ADD_ENTRY: 'Eintrag hinzufügen',
    ADD_IM_ID: 'Chat-Dienst hinzufügen',
    ADD_PROFILE: 'Profil hinzufügen',
    ADD_SUBJECT: 'Fachrichtung hinzufügen',
    ADD_WEBSITE: 'Webseite hinzufügen',
    ADDRESS: 'Adresse',
    AMBASSADOR_ICON_LINK:
      'http://official-events.xing.com/ambassador.php?dpt=prd&ttp=plat&plf=amb&pid=20070712&lng=de',
    ARMSTRONG_DISCO_NAVIGATION_ICON_TEXT: 'Austausch',
    AWARD: 'Auszeichnung',
    AWARDS: 'Auszeichnungen',
    AWARDS_EMPTY:
      'Gib hier Auszeichnungen an, die Du erhalten hast, z. B. "Networker des Jahres 2010".',
    BASE_PROFILE: 'Basis-Profil',
    BILLING_ADDRESS_CHANGE_HINT:
      'Die Rechnungsadresse wird nicht automatisch geändert, wenn Du diese Adresse aktualisierst. Deine Rechnungsadresse kannst Du unter "<a href="{!BILLING_ADDRESS_URL}">{\'NAVI_ACCOUNTS}</a>" bearbeiten.',
    BILLING_ADDRESS_CHANGE_HINT_TITLE:
      'Sind Deine Zahlungsinformationen noch aktuell?',
    BIRTHDATE_EMPTY: 'Du hast noch kein Geburtsdatum angegeben.',
    BIRTHDATE_PROFILES_EMPTY: 'Du hast noch keinen Geburtstag angegeben.',
    BOTTOM_BAR_FIND_JOBS_LABEL: 'Jobs finden',
    BOTTOM_BAR_INSIGHTS_LABEL: 'Insights',
    BOTTOM_BAR_NETWORK_LABEL: 'Netzwerk',
    BOTTOM_BAR_NOTIFICATIONS_LABEL: 'Mitteilungen',
    BOTTOM_BAR_YOUR_JOBS_LABEL: 'Deine Jobs',
    BREWERY_NOCOOKIES_LINK_TARGET:
      'https://faq.xing.com/de/sicherheit/was-sind-cookies-und-warum-brauche-ich-sie-beim-einloggen',
    BREWERY_NOCOOKIES_LINK_TEXT: 'Cookies aktivieren',
    BREWERY_NOCOOKIES_PARAGRAPH:
      "Denn nur mit aktivierten Cookies funktioniert das Einloggen. Hier erfährst Du, wie's geht: ",
    BREWERY_NOCOOKIES_TITLE: 'Bitte aktiviere die Cookies.',
    BREWERY_NOJAVASCRIPT_LINK_TARGET:
      'https://faq.xing.com/de/einstellungen/javascript-meinem-browser-aktivieren',
    BREWERY_NOJAVASCRIPT_LINK_TEXT: 'JavaScript aktivieren',
    BREWERY_NOJAVASCRIPT_PARAGRAPH:
      "Aktivier bitte JavaScript, denn nur so siehst Du alle unsere Inhalte. Hier erfährst Du, wie's geht:",
    BREWERY_NOJAVASCRIPT_TITLE: 'Bitte aktiviere JavaScript.',
    BUSINESS: 'Geschäftlich',
    BUSINESS_ADDRESS_STUDENT_CHANGE_HINT:
      'Lass es die Welt wissen, wenn Du Dein Studium abgeschlossen und Deinen ersten richtigen Job gefunden hast: ändere Deinen Status!',
    BUSINESS_UNIVERSITY: 'Geschäftlich / Hochschule',
    BUTTON_ACCEPT: 'Akzeptieren',
    BUTTON_ADD: 'Hinzufügen',
    BUTTON_ADDCONTACT: 'Als Kontakt hinzufügen',
    BUTTON_BACK: 'Zurück',
    BUTTON_BACKTOP: 'zurück zur Übersicht',
    BUTTON_CANCEL: 'Abbrechen',
    BUTTON_CHANGE: 'Angaben ändern',
    BUTTON_CLEAR_FIELDS: 'Eingabe löschen',
    BUTTON_CLOSE: 'Schließen',
    BUTTON_CLOSEWINDOW: 'Fenster schließen',
    BUTTON_COMMENT: 'Kommentieren',
    BUTTON_CONFIRM: 'Bestätigen',
    BUTTON_CONTINUE: 'OK',
    BUTTON_CORRECTNEWS: 'Newseintrag korrigieren',
    BUTTON_CORRECTNEWSLETTER: 'Newsletter korrigieren',
    BUTTON_CREATE_FILE: 'Aktuelle Datei erzeugen',
    BUTTON_DELCONTACT: 'Kontakt löschen',
    BUTTON_DELETE: 'Löschen',
    BUTTON_DELETE_LANGUAGE: 'Sprache löschen',
    BUTTON_EDIT: 'Bearbeiten',
    BUTTON_FILTER: 'Filtern',
    BUTTON_FORWARD: 'Weiter',
    BUTTON_FURTHER_INVITATIONS: 'Weitere Personen einladen',
    BUTTON_GRANT_PERMISSIONS: 'Zugriffsrechte erteilen',
    BUTTON_JOIN: 'Mitglied werden',
    BUTTON_JOIN_NOW: 'Jetzt Mitglied werden',
    BUTTON_LESS: 'Weniger',
    BUTTON_LOAD_MORE: 'Mehr anzeigen',
    BUTTON_MORE: 'Mehr',
    BUTTON_NEW_LANGUAGE: 'Neue Sprache',
    BUTTON_NEXT_STEP: 'Nächster Schritt',
    BUTTON_OK: 'OK',
    BUTTON_POST: 'Veröffentlichen',
    BUTTON_POST_AND_TWEET: 'Veröffentlichen & tweeten',
    BUTTON_POST_STATUS: 'Aktualisieren',
    BUTTON_PREVIEW: 'Vorschau',
    BUTTON_PRINT: 'Drucken',
    BUTTON_PRINT_PROFILE: 'Profil ausdrucken',
    BUTTON_PUBLISH: 'Veröffentlichen',
    BUTTON_RELOAD_PAGE: 'Seite aktualisieren',
    BUTTON_SAVE: 'Speichern',
    BUTTON_SAVE_AND_CONTINUE: 'Speichern und fortsetzen',
    BUTTON_SAVENEWS: 'Newseintrag speichern',
    BUTTON_SEARCH: 'Suchen',
    BUTTON_SEND: 'Absenden',
    BUTTON_SENDMESSAGE: 'Nachricht schreiben',
    BUTTON_SENDNEWSLETTER: 'Newsletter senden',
    BUTTON_SHOW: 'Anzeigen',
    BUTTON_SHOW_ERRORS: 'Fehler anzeigen',
    BUTTON_SHOW_LESS: 'Weniger',
    BUTTON_SHOW_MORE: 'Mehr',
    BUTTON_SKIP_STEP: 'Schritt überspringen',
    BUTTON_SUBMIT: 'Bestätigen',
    BUTTON_SUGGEST: 'Kontakte vorschlagen',
    BUTTON_TEXT_RECOVERY: 'Text wiederherstellen',
    BUTTON_TRY_AGAIN: 'Noch einmal versuchen',
    BUTTON_UPDATE: 'Änderungen speichern',
    CAL_DATE_FORMAT: 'DD.MM.YYYY',
    CAL_DATE_FORMAT_HINT: 'TT.MM.JJJJ',
    CB_POSTING_ERROR:
      'Das hat leider nicht geklappt. Bitte versuch es noch einmal.',
    CELLPHONE: 'Handy',
    CERTIFICATE_ERROR_DOWNLOAD_FAILED:
      'Diese Datei konnte leider nicht heruntergeladen werden. Bitte versuche es erneut.',
    CERTIFICATE_ERROR_EMPTY_FILE: 'Bitte wähle eine Datei aus.',
    CERTIFICATE_ERROR_EMPTY_TITLE: 'Bitte gib einen Titel ein.',
    CERTIFICATE_ERROR_ERROR_FILE_TOO_BIG:
      'Bitte wähle eine Datei mit einer maximalen Größe von 2MB aus.',
    CERTIFICATE_ERROR_FILE_NOT_SAVED:
      'Die Datei konnte leider nicht hochgeladen werden. Bitte versuche es erneut.',
    CERTIFICATE_ERROR_FILE_TYPE_NOT_ALLOWED:
      'Bitte wähle eine Datei im Format PDF, JPG oder PNG aus.',
    CERTIFICATE_FILE: 'Datei',
    CERTIFICATE_MIMETYPE_APPLICATION_PDF: 'pdf',
    CERTIFICATE_MIMETYPE_IMAGE_JPEG: 'jpg',
    CERTIFICATE_MIMETYPE_IMAGE_PNG: 'png',
    CERTIFICATE_OPEN_OR_SAVE: 'Öffnen oder speichern',
    CERTIFICATE_PRIVACY: 'Datei sichtbar für:',
    CERTIFICATE_PRIVACY_ALL: 'Alle XING Mitglieder',
    CERTIFICATE_PRIVACY_CONTACTS_ONLY: 'Nur meine Kontakte',
    CERTIFICATE_TITLE: 'Dateibeschreibung',
    CERTIFICATE_UPLOAD_NEW_FILE: 'Datei ändern',
    CERTIFICATE_VISIBILITY_CONTACTS_ONLY: 'Nur für Kontakte sichtbar',
    CERTIFICATES: 'Dateianhänge',
    CERTIFICATES_EDIT_INFO: 'Du kannst bis zu 3 Dateien hochladen.',
    CERTIFICATES_EDIT_INFO_2:
      '(jeweils maximal 2MB in den Formaten PDF, JPG oder PNG).',
    CERTIFICATES_EMPTY:
      'Weitere Informationen über Dich (z.B. Arbeitsproben & Zeugnisse)',
    CERTIFICATES_NEW: 'NEU',
    CHANGE_PRIMARY_JOB_EXPL:
      'Du kannst die Anzeige Deiner Tätigkeit wechseln, indem Du das Häkchen bei einem anderen Beruf  setzt.',
    CHANGE_PRIMARY_SCHOOL_EXPL:
      'Du kannst die Anzeige Deiner Hochschule wechseln, indem Du das Häkchen bei einer anderen Hochschule setzt.',
    CHANGE_UN_PW: 'Ändere die Zugangsdaten Deines XING Benutzerkontos.',
    CHOOSE_LANG:
      'Wähle aus, in welcher Sprache Du {-SITENAME} verwenden möchtest.',
    CHOOSE_NOTIFICATION_TYPES:
      'Wähle aus, welche Benachrichtigungen Du von {-SITENAME} erhalten möchtest.',
    CHOOSE_PRIVACY: 'Wähle aus, wie öffentlich oder privat Du sein möchtest.',
    CITY: 'Ort',
    COMMBOX_ACTOR_SWITCH_CANCEL: 'Absender beibehalten',
    COMMBOX_ACTOR_SWITCH_CONFIRM: 'Absender ändern',
    COMMBOX_ACTOR_SWITCH_HEADLINE:
      'Wer soll der Absender dieses Beitrags sein?',
    COMMBOX_ACTOR_SWITCH_HINT:
      'Um den Absender dieses Beitrags zu ändern, tipp einfach oben auf den Namen.',
    COMMBOX_ACTOR_SWITCH_PROMPT_IMAGE:
      'Sicher, dass Du den Absender ändern möchtest? Dein bereits hochgeladenes Bild geht dabei verloren.',
    COMMBOX_ACTOR_SWITCH_PROMPT_VIDEO:
      'Sicher, dass Du den Absender ändern möchtest? Dein bereits hochgeladenes Video geht dabei verloren.',
    COMMBOX_ACTOR_SWITCH_TYPE_PAGE: 'Eine Seite',
    COMMBOX_ACTOR_SWITCH_TYPE_USER: 'Eine Person',
    COMMBOX_ALMOST_FULL_FILLED_DROPZONE_HEADER:
      '1 Bild kannst Du noch hinzufügen.',
    COMMBOX_AUDIENCE_CITY_CONTACTS:
      'Nur Kontakte in meinem Arbeitsort ({totalCount})',
    COMMBOX_AUDIENCE_FOLLOWERS: 'Nur Follower',
    COMMBOX_AUDIENCE_FOLLOWERS_AND_CONTACTS: 'Follower & Kontakte',
    COMMBOX_AUDIENCE_FOLLOWERS_AND_CONTACTS_DESC:
      'Dein Beitrag kann geteilt werden.',
    COMMBOX_AUDIENCE_FOLLOWERS_DESC: 'Dein Beitrag kann geteilt werden.',
    COMMBOX_AUDIENCE_HEADLINE: 'Wer darf das sehen?',
    COMMBOX_AUDIENCE_PRIVATE: 'Privat (nur XING Kontakte)',
    COMMBOX_AUDIENCE_PRIVATE_DESC: 'Dein Beitrag kann nicht geteilt werden.',
    COMMBOX_AUDIENCE_PRIVATE_SELECTED: 'Privat',
    COMMBOX_AUDIENCE_PUBLIC: 'Öffentlich',
    COMMBOX_AUDIENCE_PUBLIC_DESC: 'Jeder kann Deinen Beitrag sehen und teilen.',
    COMMBOX_BUTTON_ADD_VIDEO_LABEL: 'Video hinzufügen',
    COMMBOX_BUTTON_OPEN_FILES_LABEL: 'Dokument hinzufügen',
    COMMBOX_BUTTON_OPEN_POLL_LABEL: 'Umfrage starten',
    COMMBOX_CANCEL_POSTING_BUTTON_BACK: 'Weiter bearbeiten',
    COMMBOX_CANCEL_POSTING_BUTTON_CANCEL: 'Beitrag verwerfen',
    COMMBOX_CANCEL_POSTING_HEADLINE: 'Möchtest Du den Beitrag verwerfen?',
    COMMBOX_CANCEL_POSTING_TEXT_MESSAGE: 'Deine Eingaben gehen dann verloren.',
    COMMBOX_CHARACTERS_LEFT: 'übrig',
    COMMBOX_EMPTY_DROPZONE_BUTTON_TEXT: 'Bilder auswählen',
    COMMBOX_EMPTY_DROPZONE_TEXT:
      'JPG, BMG oder PNG (max. {max_size} MB pro Bild)',
    COMMBOX_EMPTY_DROPZONE_TITLE:
      'Du kannst bis zu {max_images} Bilder hierher ziehen oder auswählen.',
    COMMBOX_EMPTY_TEXT_FIELD: 'Teil ein Foto, einen Link oder schreib was …',
    COMMBOX_EMPTY_TEXT_FIELD_MENTIONS:
      'Teil ein Foto, einen Link oder einen Gedanken (mit "@" andere erwähnen) ...',
    COMMBOX_ENTRY_POINT_LABEL: 'Eingabefeld für Deinen Beitrag',
    COMMBOX_ENTRY_POINT_TEXT: 'Was gibt’s Neues?',
    COMMBOX_FILLED_DROPZONE_HEADER:
      '{pictures} Bilder kannst Du noch hinzufügen.',
    COMMBOX_FULL_FILLED_DROPZONE_HEADER:
      'Du hast jetzt die maximale Anzahl an Fotos hinzugefügt.',
    COMMBOX_IMAGE_BUTTON_LABEL: 'Bild hinzufügen',
    COMMBOX_IMAGE_SIZE_UPLOAD_ERROR:
      'Bitte wähle ein Bild, das max. 10 MB groß ist.',
    COMMBOX_IMAGE_TYPE_UPLOAD_ERROR:
      'Bitte wähle ein Bild im JPG- oder PNG-Format.',
    COMMBOX_POST: 'Teilen',
    COMMBOX_SUCCESS_ACTION: 'Beitrag ansehen',
    COMMBOX_SUCCESS_DESC: 'Dein Beitrag wurde auf XING geteilt.',
    COMMBOX_SUCCESS_HEADLINE: 'Und fertig!',
    COMMBOX_SUCCESS_SCHEDULED_DESC:
      'Dein Beitrag wird am {date} um {time} Uhr geteilt.',
    COMMBOX_UPDATE_BTN: 'Speichern',
    COMMBOX_UPLOADED_IMAGES_LIMIT_REACHED:
      'Du hast schon 10 Bilder hinzugefügt – mehr geht leider nicht.',
    COMMBOX_VIDEO_UPLOAD_ENCODING_TITLE:
      'Das Video wird gerade vorbereitet ... einen Moment Geduld bitte.',
    COMMBOX_VIDEO_UPLOAD_GENERIC_ERROR:
      'Das hat leider nicht geklappt – einfach gleich nochmal versuchen!',
    COMMBOX_VIEW_POST_BTN: 'Beitrag ansehen',
    COMMENT_BUTTON_LABEL: 'Kommentieren',
    COMPANY: 'Unternehmen',
    COMPANY_HP: 'Homepage des Unternehmens',
    COMPANY_SIZE: 'Unternehmensgröße',
    COMPANY_SIZE_1: 'Nur ich',
    COMPANY_SIZE_2: '1-10 Mitarbeitende',
    COMPANY_SIZE_3: '11-50 Mitarbeitende',
    COMPANY_SIZE_4: '51-200 Mitarbeitende',
    COMPANY_SIZE_5: '201-500 Mitarbeitende',
    COMPANY_SIZE_6: '501-1.000 Mitarbeitende',
    COMPANY_SIZE_7: '1.001-5.000 Mitarbeitende',
    COMPANY_SIZE_8: '5.001-10.000 Mitarbeitende',
    COMPANY_SIZE_9: '10.001 oder mehr Mitarbeitende',
    COMPANY_UPDATES_ADD_NEWS_TEXTAREA:
      'Hier ist Platz für den Beitragstext oder Link – bis zu 400 Zeichen lang darf alles insgesamt sein.',
    COMPANY_UPDATES_CONFIRM_LIGHTBOX_CLOSE_BODY:
      'Du hast die Neuigkeit noch nicht veröffentlicht. Wenn Du das Fenster jetzt schließt, wird der Inhalt nicht gespeichert. ',
    COMPANY_UPDATES_CONFIRM_LIGHTBOX_CLOSE_BUTTON_CANCEL: 'Nein',
    COMPANY_UPDATES_CONFIRM_LIGHTBOX_CLOSE_BUTTON_CONFIRM: 'Ja, verwerfen',
    COMPANY_UPDATES_CONFIRM_LIGHTBOX_CLOSE_HEADLINE:
      'Möchtest Du die Neuigkeit wirklich verwerfen?',
    COMPANY_UPDATES_CREATE_UPDATE_BUTTON_BODY:
      "Probier's einfach einmal aus und schreibe jetzt Deine erste Unternehmens-Neuigkeit.",
    COMPANY_UPDATES_CREATE_UPDATE_BUTTON_HEADLINE:
      'Hier sind Deine Unternehmens-Neuigkeiten zu sehen.',
    COMPANY_UPDATES_ERROR_CREATE_UPDATE:
      'Das hat leider nicht geklappt. Kannst Du es bitte noch einmal versuchen?',
    COMPANY_UPDATES_ERROR_CREATE_UPDATE_HEADLINE:
      'Die Neuigkeit konnte leider nicht veröffentlicht werden.',
    COMPANY_UPDATES_ERROR_PREVIEW_LINK:
      'Leider können wir keine Vorschau des Links generieren. Du kannst ihn trotzdem teilen, dann allerdings nur als einfachen Link.',
    COMPANY_UPDATES_ERROR_PREVIEW_LINK_HEADLINE: 'Keine Vorschau verfügbar',
    COMPANY_UPDATES_ERROR_UPLOADING_FILE:
      'Leider konnte die Datei nicht vollständig hochgeladen werden. Kannst Du es bitte noch einmal versuchen?',
    COMPANY_UPDATES_ERROR_UPLOADING_FILE_HEADLINE:
      'Die Datei konnte nicht hochgeladen werden.',
    COMPANY_UPDATES_PREVIEW_LOADING_LINK: 'Vorschau wird generiert ...',
    COMPLETE_BUSINESS_ADDRESS: 'Vervollständige bitte Deine Geschäftsadresse.',
    COMPLETENESS_HINT:
      'Beim Networking geht es um "finden" und "gefunden werden" – zum Beispiel für Jobs, Kollegen, Freunde und Geschäftspartner. Dein Foto und ausführliche Kontaktdaten helfen Dir dabei.',
    COMPLETION_LEVEL_WHATS_THIS: 'Was bedeutet das?',
    CONTACT_DETAILS: 'Kontaktdaten',
    CONTACTSHTML_LIST_DISABLED:
      'Dieses Mitglied hat seine Kontaktliste leider nicht zur Ansicht freigegeben.',
    CONTENT_ERROR_404_BUTTON: 'Zur XING Startseite',
    CONTENT_ERROR_404_HEADLINE:
      'Es tut uns leid: Diese Seite ist leider wie vom Winde verweht.',
    CONTENT_ERROR_404_SUBLINE:
      "Aber hier gibt's garantiert etwas zu entdecken:",
    CONTENT_ERROR_503_HEADLINE:
      'Sieht so aus, als hätten wir gerade ein kleines Problem.',
    CONTENT_ERROR_503_SUBLINE:
      'Bitte hab einen Moment Geduld. Wir arbeiten daran.',
    CONTENT_ERROR_OFFLINE:
      "Bitte prüfe Deine Internet-Verbindung. Versuch's dann einfach noch einmal.",
    CONTENT_FOLLOW: 'Folgen',
    CONTENT_FOLLOW_LIGHTBOX_HEADLINE: '{title} folgen',
    CONTENT_FOLLOW_LIGHTBOX_TEXT:
      'Möchtest Du regelmäßig Artikel von {title} auf XING lesen?',
    CONTENT_FOLLOWED: 'Folgst Du',
    CONTENT_SWITCHER_MORE: 'Mehr',
    CONTENT_TIMESTAMP_AN_HOUR_AGO_LONG:
      '{minutesCount, plural,\n   =1 {Eben gerade}\n   other {Vor # Minuten}\n}',
    CONTENT_TIMESTAMP_AN_HOUR_AGO_SHORT:
      '{minutesCount, plural,\n   =1 {Jetzt}\n   other {# Min.}\n}',
    CONTENT_TIMESTAMP_DAYS: 'Tage',
    CONTENT_TIMESTAMP_DAYS_AGO_LONG:
      '{daysCount, plural,\n    =0 {Heute}\n    one {Gestern}\n    other {Vor # Tagen}\n}',
    CONTENT_TIMESTAMP_DAYS_AGO_SHORT:
      '{daysCount, plural,\n    =0 {Heute}\n    one {Gestern}\n    other {# Tage}\n}',
    CONTENT_TIMESTAMP_LESS_THAN_A_MINUTE_AGO: 'Gerade eben',
    CONTENT_TIMESTAMP_SOME_HOUR_AGO_SHORT:
      '{hoursCount, plural,\n   =1 {1 Std.}\n   other {# Std.}\n}',
    CONTENT_TIMESTAMP_SOME_HOURS_AGO_LONG:
      '{hoursCount, plural,\n   =1 {Vor 1 Stunde}\n   other {Vor # Stunden}\n}',
    CONTENT_TIMESTAMP_TODAY: 'Heute',
    CONTENT_UNFOLLOW: 'Nicht mehr folgen',
    CONTENT_VIDEO_ARTICLE_HEADLINE_PLACEHOLDER:
      'Geben Sie hier den Titel Ihres Videos ein.',
    CONTENT_VIDEO_RECOS_REASON: 'Beliebte Videos auf XING',
    CONTROL_DISPLAY_NAME:
      'Hier kannst Du Deine Stammdaten ändern und Deinen akademischen Titel eintragen.',
    CONTROL_PROFILE_VISIBILITY:
      'Bestimme selbst, welche Bereiche in Deinem Profil sichtbar sind.',
    CORPORATE_PAGES_TEST_RESOURCE: 'test',
    CORRECT_END_DATE: 'Bitte gib ein korrektes Enddatum an.',
    CORRECT_START_DATE: 'Bitte gib ein korrektes Einstiegsdatum an.',
    COUNTRY: 'Land',
    CP_000_CUSTOMER_FEEDBACK_LEGAL_INFO_HEADLINE: 'Bitte beachten:',
    CP_000_CUSTOMER_FEEDBACK_LEGAL_INFO_TEXT:
      'XING möchte Deine Meinung wissen und Dein Feedback einholen – hierzu nutzt XING das \nPartner-Portal Uservoice.<br />\nDeine Ideen bestimmen die Zukunft des Produktes mit. Wenn Du auf "weiter" klickst, wirst Du zum Partnerforum geleitet und kannst dort für die Ideen \nanderer Mitglieder stimmen oder eigene Vorschläge einreichen.<br /><br />\nMit der Nutzung des Feedback-Forums stimmst Du zu, dass Dein vollständiger \nName und Deine E-Mail-Adresse verschlüsselt an unseren Partner Uservoice in den \nUSA übertragen \nwerden.',
    CP_000_FOLLOWED_COMPANIES_BOX_HEADLINE:
      'Abonnierte Unternehmens-Neuigkeiten',
    CP_000_FOLLOWED_COMPANIES_BOX_INFO: '({limit} von {absolute_number})',
    CP_000_FOLLOWED_COMPANIES_LINK_ALT:
      'Zum Unternehmensprofil von "{company_name}"',
    CP_000_RECOMMEND_SUBJECT_TEMPLATE:
      '{recommender_name} empfiehlt Dir das Unternehmen {company_name}',
    CP_000_RECOMMEND_TEXT_TEMPLATE:
      'Ich habe auf {SITENAME} das Unternehmensprofil "{company_name}" gefunden und glaube, dass es für Dich interessant sein könnte. Du findest es hier:\n\n{SSLURL}/companies/{+company_tag}\n\nViele Grüße\n{recommender_name}',
    CP_000_REQUIRED_INFORMATION: 'Notwendige Angaben',
    CP_100_ACTIVITY_STREAM: 'Das Neueste aus dem Bereich Unternehmen',
    CP_100_ADVANCED_SEARCH_LABEL: 'Erweiterte Suche',
    CP_100_ALL_OPTION_COUNTRY: '(alle)',
    CP_100_ALL_OPTION_INDUSTRY: '(alle)',
    CP_100_ALL_OPTION_SIZE: '(alle)',
    CP_100_BOOKMARK_JOB: 'Merken',
    CP_100_CHARACTERS_LEFT_COLON: 'Noch:',
    CP_100_CITY_LABEL: 'Ort',
    CP_100_COMPANY_COLHEADER: 'Name & Adresse',
    CP_100_COMPANY_DIRECTORY_ALL_LINK: 'Alle',
    CP_100_COMPANY_DIRECTORY_ALL_LINK_ALT: 'Alle Unternehmen anzeigen',
    CP_100_COMPANY_DIRECTORY_HEADLINE:
      'Unternehmen nach Firmenname alphabetisch',
    CP_100_COMPANY_DIRECTORY_LINK_ALT: 'zum Unternehmensprofil',
    CP_100_COMPANY_DIRECTORY_PAGINATION_CHAR_LINK_ALT:
      'Unternehmen mit diesem Anfangsbuchstaben anzeigen',
    CP_100_COMPANY_LABEL: 'Firmenname',
    CP_100_COUNTRY_LABEL: 'Land',
    CP_100_DESCRIBE_BRAND_MANAGER:
      'Verwalte Deine Arbeitgeberprofile direkt im BrandManager.',
    CP_100_DIRECTORY_DESCRIPTION:
      'Ob IT, Tourismus, Lebensmittel oder Bankwesen: Auf XING gibt es Unternehmen zu fast allen Branchen und Industrien.',
    CP_100_DIRECTORY_DESCRIPTION_INDUSTRY:
      'Arbeitgeber im Bereich {industry}: Sieh auf einen Blick Leistungen für Mitarbeitende, offene Stellenangebote und spezifische Ansprechpersonen.',
    CP_100_DIRECTORY_INTRO:
      'Mehr als nur ein Arbeitgeber-Branchenbuch: Auf XING kannst Du interessanten Unternehmen folgen und bleibst so stets auf dem Laufenden. Du siehst, welche XING Mitglieder bei einem Unternehmen arbeiten, welche Leistungen für Mitarbeitende es anbietet und ob es gerade offene Stellen ausschreibt.',
    CP_100_DIRECTORY_INTRO_INDUSTRY:
      'Arbeitgeber der {industry}-Branche auf einen Blick: Auf XING kannst Du interessanten {industry}-Unternehmen folgen und bleibst so stets auf dem Laufenden. Du siehst, welche XING Mitglieder bei {industry}-Firmen arbeiten, welche Leistungen für Mitarbeitende sie anbieten und ob sie gerade offene Stellen haben.',
    CP_100_DIRECTORY_TITLE: 'Unternehmen nach Branchen',
    CP_100_DIRECTORY_TITLE_INDUSTRY: 'Unternehmen aus der {industry}-Branche',
    CP_100_DIRECTORY_TITLE_NEW: 'Arbeitgeber nach Branchen',
    CP_100_DISPLAY_FILTER_LABEL: 'Filtern nach',
    CP_100_ERROR_CONNECTION:
      'Derzeit kann leider keine Verbindung hergestellt werden. Versuche es bitte später noch einmal.',
    CP_100_ERROR_MESSAGE_COMPANY_NAME:
      'Bitte gib einen Namen mit mindestens 3 und maximal 256 Zeichen an.',
    CP_100_ERROR_SEARCH_HIRING_COMPANIES:
      'Bitte verfeinere Deine Suchanfrage, indem Du ein Stichwort, \neinen Firmennamen oder eine Kombination aus Ort/Land eingeben.',
    CP_100_ERROR_UNKNOWN_OPERATION:
      'Die aufgerufene Operation ist nicht bekannt.',
    CP_100_FOUND_POSTINGS_COLHEADER: 'Anz. der Stellenangebote',
    CP_100_FOUND_PROFILES_COLHEADER: 'Anz. der Mitgliederprofile',
    CP_100_HIRING_LABEL: 'Unternehmen mit Stellenangeboten',
    CP_100_IMG_ALT_HEADER: '{company_name}: Header-Grafik',
    CP_100_IMG_ALT_LOGO: 'Logo von {company_name}',
    CP_100_INDUSTRY_COLHEADER: 'Branche',
    CP_100_INDUSTRY_DIRECTORY_ALL_LINK: 'Alle',
    CP_100_INDUSTRY_DIRECTORY_ALL_LINK_ALT: 'Weitere Branchen',
    CP_100_INDUSTRY_DIRECTORY_HEADLINE: 'Branchen',
    CP_100_INDUSTRY_DIRECTORY_LINK: 'Weitere Branchen',
    CP_100_INDUSTRY_DIRECTORY_LINK_ALT: 'Unternehmen in dieser Branche zeigen',
    CP_100_INDUSTRY_DIRECTORY_PAGINATION_CHAR_LINK_ALT:
      'Branchen mit diesem Anfangsbuchstaben anzeigen',
    CP_100_INDUSTRY_LABEL: 'Branche',
    CP_100_KEYWORD_SEARCH_DESCRIPTION:
      '<strong>Stichwortsuche</strong>: Die \nStichwortsuche durchsucht Unternehmensnamen, PLZ, Ort \nsowie die Informationen in „Mitarbeitende des Unternehmens \nbieten“.',
    CP_100_KEYWORDS_LABEL: 'Stichwörter',
    CP_100_LATELY_BOUGHT_CPS_HEADLINE: 'Neue Unternehmen auf XING',
    CP_100_LATELY_BOUGHT_CPS_HEADLINE_NEW: 'Neue Arbeitgeber auf XING',
    CP_100_LATELY_BOUGHT_CPS_TEXT:
      'Entdecke Unternehmen, die gerade erst ein neues Unternehmensprofil auf XING eingerichtet haben:',
    CP_100_LOCATION: 'Kartenansicht',
    CP_100_LOCATION_COLHEADER: 'Standort',
    CP_100_LOGGEDOUT_CREATE_HEADING:
      'Für Arbeitgeber: Stelle Dein eigenes Employer Branding-Profil ein.',
    CP_100_LOGGEDOUT_CREATE_TEXT:
      'Gestalte Deinen Ruf als Arbeitgeber aktiv mit, steigere Deine Bekanntheit & Sichtbarkeit und gewinne so Toptalente für Dein Unternehmen.',
    CP_100_LOGGEDOUT_EXISTING_PROFILES:
      'Diese und über 100.000 weitere Unternehmen sind bereits bei XING',
    CP_100_LOGGEDOUT_EXISTING_PROFILES_NEW:
      'Diese und über 100.000 weitere Arbeitgeber sind bereits bei XING:',
    CP_100_LOGGEDOUT_EXISTING_PROFILES_TEXT:
      'Unternehmen aller Größen und Branchen sowie Universitäten und Bildungseinrichtungen nutzen XING bereits für Employer Branding, Recruiting und um ihre Präsenz im Netz zu stärken.',
    CP_100_LOGGEDOUT_EXISTING_PROFILES_TEXT_NEW:
      'Arbeitgeber aller Größen und Branchen sowie Universitäten und Bildungseinrichtungen nutzen XING bereits für Employer Branding, Recruiting und zur Stärkung ihrer Online-Präsenz.',
    CP_100_LOGGEDOUT_INTRO_TEXT_1:
      'Auf XING lernst Du Arbeitgeber persönlich kennen und erfährst mehr über sie:\n<ul class="check-icon-list">\n<li class="foundation-icon-shape-tick"><strong>Infos & Neuigkeiten</strong> zu allen Vorteilen und Leistungen, die Arbeitgeber Dir zu bieten haben</li>\n<li class="foundation-icon-shape-tick"><strong>Bewertungen von Mitarbeitenden</strong> des Unternehmens: Sieh auf einen Blick, wie derzeitige und ehemalige Mitarbeitende ihren Arbeitgeber einschätzen.</li>\n<li class="foundation-icon-shape-tick"><strong>Karrierechancen:</strong> Auf Job-Suche? Wir zeigen Dir, welche Stellenangebote Dein Wunsch-Arbeitgeber gerade ausgeschrieben hat.</li>\n</ul>',
    CP_100_LOGGEDOUT_INTRO_TEXT_2:
      'Bist Du noch nicht bei XING? Dann kannst Du Dich gern <a href="/signup">kostenlos registrieren</a>.',
    CP_100_LOGGEDOUT_TITLE: 'Arbeite dort, wo Du Dich wohlfühlst.',
    CP_100_MAINHEADLINE:
      'Arbeitgeber stellen sich vor:<br>\nInfos, Neuigkeiten und Jobs',
    CP_100_MAP_HEADER: '{company_name} befindet sich hier:',
    CP_100_MERGE_TEASER_HEADER:
      'Qualitätsverbesserung von Unternehmensprofilen',
    CP_100_MERGE_TEASER_TEXT:
      'Die Qualität der Unternehmensprofile wurde weiter verbessert: Profile mit unterschiedlicher Schreibweise des Firmennamens wurden mit Hilfe von öffentlich zugänglichen Daten (z. B. Handelsregisterdaten) zu einem Unternehmensprofil zusammengefasst. {faq_merge_link}',
    CP_100_MERGE_TEASER_TEXT_LINK: 'Fragen und Antworten zu XING',
    CP_100_META_DESCRIPTION_ABOUT: '{company_short_description}',
    CP_100_META_DESCRIPTION_CONTACT:
      'Ansprechpersonen und Kontaktmöglichkeiten bei {company_name} auf einen Blick',
    CP_100_META_DESCRIPTION_DEFAULT:
      'Lerne Arbeitgeber persönlich kennen und erfahre, was Unternehmen ihren Mitarbeitenden zu bieten haben.',
    CP_100_META_DESCRIPTION_EMPLOYEES:
      'Übersicht aller Mitarbeitenden von {company_name} auf XING. {company_short_description}',
    CP_100_META_DESCRIPTION_FOLLOWERS:
      'Alle Follower von {company_name} auf einen Blick. {company_short_description}',
    CP_100_META_DESCRIPTION_HUBPAGE:
      'Lerne Arbeitgeber aus verschiedenen Branchen kennen und erfahre, was Unternehmen ihren Mitarbeitenden zu bieten haben.',
    CP_100_META_DESCRIPTION_INDUSTRIES:
      'Ein Branchenbuch, das mehr kann: Auf XING lernst Du Lieferanten, Dienstleister, Kunden und Auftraggeber persönlich kennen.',
    CP_100_META_DESCRIPTION_INDUSTRY_DETAIL:
      'Finde hier Arbeitgeber der Branche {industry} &ndash, erhalte die aktuellsten News und erfahre, was sie Dir als Mitarbeiter·in bieten. ',
    CP_100_META_DESCRIPTION_JOBS:
      'Entdecke aktuelle Jobs bei Deinem Wunsch-Arbeitgeber &ndash; und sieh, wie Du über Deine Kontakte mit dem Unternehmen verbunden bist!',
    CP_100_META_DESCRIPTION_MOST_VISITED:
      'Welche Firmen erfreuen sich derzeit besonders großer Popularität? Unsere Bestenliste, ständig aktualisiert.',
    CP_100_META_DESCRIPTION_NEW_COMPANIES:
      'Entdecke Unternehmen, die gerade erst ein neues Unternehmensprofil auf XING eingerichtet haben.',
    CP_100_META_DESCRIPTION_RATING:
      'Lies aktuelle Arbeitgeber-Bewertungen zu {company_name}. {company_short_description}',
    CP_100_META_DESCRIPTION_SALES:
      'Präsentiere Dich als attraktiver Arbeitgeber und erreiche unter mehr als 15 Millionen XING Mitgliedern Deine Wunschkandidaten.',
    CP_100_META_DESCRIPTION_UPDATES:
      'Aktuelle Neuigkeiten von {company_name} auf einen Blick: Jetzt folgen und keine wichtigen Informationen mehr verpassen!',
    CP_100_META_TITLE_COMPANY_DIRECTORY: 'Firmen im Bereich {industry}',
    CP_100_META_TITLE_COMPANY_EMPLOYEES: '{company_name}: Mitarbeitende',
    CP_100_META_TITLE_COMPANY_HOMEPAGE: '{company_name}',
    CP_100_META_TITLE_COMPANY_JOBS: 'Aktuelle Jobs bei {company_name}',
    CP_100_META_TITLE_COMPANY_PAGE: '{company_name}: {tab_label}',
    CP_100_META_TITLE_COMPANY_RATING:
      'Arbeitgeber-Bewertungen für {company_name}',
    CP_100_META_TITLE_HUBPAGE:
      'Arbeitgeber stellen sich vor: Infos, Neuigkeiten & Jobs',
    CP_100_META_TITLE_HUBPAGE_LI: 'Unternehmen | XING',
    CP_100_META_TITLE_INDUSTRIES: 'Arbeitgeber nach Branchen',
    CP_100_META_TITLE_INDUSTRY_DETAIL: 'Arbeitgeber im Bereich {industry}',
    CP_100_META_TITLE_MOST_VISITED: 'Die meistbesuchten Unternehmen',
    CP_100_META_TITLE_NEW_COMPANIES: 'Die neuesten Unternehmensprofile',
    CP_100_META_TITLE_SALES_PAGE:
      'Präsentieren Sie sich bei XING als Arbeitgeber.',
    CP_100_META_TITLE_SUFFIX: '| XING Unternehmen',
    CP_100_MOST_CLICKED_COMPANIES: 'Meistbesuchte Unternehmen',
    CP_100_MOST_CLICKED_COMPANIES_HEADLINE:
      'Meistbesuchte Arbeitgeber auf XING',
    CP_100_MOST_CLICKED_COMPANIES_NEW: 'Meistbesuchte Arbeitgeber',
    CP_100_MOST_CLICKED_COMPANIES_TEXT:
      'Diese Arbeitgeber wurden in den letzten 24 Stunden am häufigsten besucht.',
    CP_100_MY_CITY_LABEL: 'Geschäftsadresse',
    CP_100_MY_COMPANIES_LINK: 'Deine Unternehmen',
    CP_100_MY_COMPANIES_LINK_NEW: 'Deine Arbeitgeber',
    CP_100_MY_COMPANIES_TITLE: 'Unternehmen',
    CP_100_MY_EDITED_COMPANIES_TITLE: 'Von Dir verwaltet',
    CP_100_MY_SUBSCRIPTIONS_TITLE: 'Arbeitgeber-Neuigkeiten',
    CP_100_MYCP_FOLLOWED_COMPANIES_TITLE: 'Unternehmen, denen Du folgst',
    CP_100_MYCP_FOLLOWED_COMPANIES_TITLE_NEW: 'Unternehmen, denen Du folgst',
    CP_100_MYCP_IWORKHERE_TITLE: 'Deine Unternehmen',
    CP_100_MYCP_IWORKHERE_TITLE_NEW: 'Deine Arbeitgeber',
    CP_100_MYCP_SUBSCRIPTION_HINT:
      '<p>Du folgst derzeit keinem Unternehmen.</p>\n<p><strong>Tipp:</strong> <a href="{find_companies_link}">Entdecke interessante Unternehmen</a> und folge ihnen, um stets auf dem neuesten Stand zu bleiben!</p>',
    CP_100_MYXING_SUBSCRIPTIONS_TITLE:
      'Neuigkeiten der Unternehmen, denen Du folgst',
    CP_100_NO_RESULTS_FOUND_INFO:
      'Leider wurden keine Firmen gefunden, die zu Deiner Suche passen. Unser Tipp: Versuche es mit ähnlichen Stichwörtern oder lege weniger spezifische Kriterien fest.',
    CP_100_NO_SEARCH_TERM_ENTERED:
      'Bitte gib mindestens einen \nSuchbegriff ein.',
    CP_100_NOTICE_GENERAL_FEEDBACK: 'Die Aktion wurde erfolgreich ausgeführt.',
    CP_100_OPEN_BRAND_MANAGER: 'BrandManager öffnen',
    CP_100_RECENTLY_FOLLOWED_LINK: 'Weitere Unternehmen, denen Du folgst',
    CP_100_RECENTLY_FOLLOWED_LINK_NEW: 'Weitere Arbeitgeber, denen Du folgst',
    CP_100_RECENTLY_FOLLOWED_TITLE: 'Unternehmen, denen Du folgst',
    CP_100_RECENTLY_FOLLOWED_TITLE_NEW: 'Unternehmen, denen Du folgst',
    CP_100_RECOMMENDATION_REASON_CITY:
      '{company_name} befindet sich in Deinem Arbeitsort.',
    CP_100_RECOMMENDATION_REASON_COMPANY:
      '{company_name} könnte Dich aufgrund Deines derzeitigen Unternehmens interessieren.',
    CP_100_RECOMMENDATION_REASON_JOB_TITLE:
      '{company_name} könnte Dich aufgrund Deines Berufes interessieren.',
    CP_100_RECOMMENDATION_REASON_SCHOOL_NOTES:
      '{company_name} könnte Dich aufgrund Deiner Ausbildungsschwerpunkte interessieren.',
    CP_100_RECOMMENDATION_REASON_SHARED_CONTACTS:
      '{first_contact}, {second_contact} und weitere Kontakte folgen {company_name}.',
    CP_100_RECOMMENDATION_REASON_SHARED_CONTACTS_NONE:
      'Mehrere Deiner Kontakte folgen {company_name}.',
    CP_100_RECOMMENDATION_REASON_SHARED_CONTACTS_ONE:
      '{first_contact} und weitere Deiner Kontakte folgen {company_name}.',
    CP_100_RECOMMENDATION_REASON_UNIVERSITY:
      '{company_name} könnte Dich aufgrund Deiner Universität interessieren.',
    CP_100_RECOMMENDATION_REASON_WHI:
      '{company_name} könnte zu dem passen, was Du suchst, bietest oder was Dich interessiert.',
    CP_100_RECOMMENDATIONS_DELETE: 'Empfehlung löschen',
    CP_100_RECOMMENDATIONS_HEADING:
      'Diese Unternehmen könnten Dich interessieren',
    CP_100_RECOMMENDATIONS_HEADING_NEW:
      'Diese Arbeitgeber könnten Dich interessieren:',
    CP_100_RELATED_COMPANY_MERGED_MAIL_BODY:
      '<p>Das Unternehmen {slave_company} wurde kürzlich mit dem Unternehmensprofil von {master_company} zusammengeführt. Bitte prüfe, ob Deine Verbindung zu dem Unternehmen noch korrekt dargestellt wird und entferne den Eintrag ansonsten.</p>',
    CP_100_RELATED_COMPANY_MERGED_MAIL_SUBJECT:
      'Änderungen bei Deinen Verbindungen zu anderen Unternehmen',
    CP_100_SALES_PAGE_FREE_PROFILE_PHONE:
      'Fragen zum Gratis-Profil? Melde Dich gern unter +49 40 419 131-784 oder schaue Dir unsere Antworten zu den<a href="http://www.helpify.de/xing-unternehmensprofile" target="_blank"> häufigsten Fragen</a> an.',
    CP_100_SEARCH_COMPANIES_HEADLINE: 'Unternehmen suchen',
    CP_100_SEARCH_HIRING_COMPANIES_DESCRIPTION:
      '<strong>Suche nach Unternehmen mit Stellenangeboten:</strong> Wähle die Option "Unternehmen mit Stellenangeboten" und gib ein Stichwort, einen Unternehmensnamen oder eine Kombination aus Ort/Land ein.',
    CP_100_SEARCH_INLINE_HINT: 'z. B. GMG GmbH',
    CP_100_SEARCH_LABEL: 'Unternehmen suchen',
    CP_100_SEARCH_TIPS: 'Tipps für Deine Suche',
    CP_100_SEARCH_WITH_ASTERISK_DESCRIPTION:
      '<strong>Suche nach Wortanfängen:</strong> Du kannst in allen Eingabefeldern nach \nWortanfängen suchen. \nGib hierfür z. B. die ersten drei Buchstaben des gesuchten Stichworts ein und setzen ein Sternchen (*) dahinter. \nEine Suche nach <strong>"Hei*"</strong> im Eingabefeld "Ort" berücksichtigt sowohl <strong>Heidelberg</strong> als auch <strong>Heidenheim</strong>.\nDie Suche mit Sternchen (*) ist nicht mit der Ähnlichkeitssuche kombinierbar.',
    CP_100_SEARCH_WITH_QUOTATION_MARKS_DESCRIPTION:
      '<strong>Suche mit Anführungszeichen:</strong> Verwende Anführungszeichen, um mit Deinem Stichwort den exakten Ausdruck zu finden. Beispiel: "Weil am Rhein" findet nur Firmen, die in der Ortsangabe diese drei Wörter in genau dieser Reihenfolge enthalten.',
    CP_100_SHOW_GOOGLE_MAP: 'Route anzeigen',
    CP_100_SIMILAR_LABEL: 'ähnlich',
    CP_100_SIZE_COLHEADER: 'Firmengröße',
    CP_100_SIZE_LABEL: 'Firmengröße',
    CP_100_TAB_COMPANY_DIRECTORY_LINK: 'Unternehmen',
    CP_100_TAB_INDUSTRY_DIRECTORY_LINK: 'Branchen',
    CP_100_TEASER_CLAIME_COMPANY_HEADLINE:
      'Möchtest Du Dein Unternehmensprofil individuell gestalten?',
    CP_100_TEASER_CLAIME_COMPANY_LINK: 'Mehr Informationen',
    CP_100_TEASER_CLAIME_COMPANY_TEXT:
      'Setze Dein Unternehmen professionell in Szene!',
    CP_100_TEASER_GIVE_FEEDBACK_HEADLINE: 'Deine Meinung ist uns wichtig!',
    CP_100_TEASER_GIVE_FEEDBACK_ITEM_1:
      'Du hast Ideen oder Anregungen zur Verbesserung der Unternehmensprofile?',
    CP_100_TEASER_GIVE_FEEDBACK_LINK: 'Sende uns Dein Feedback!',
    CP_100_TEASER_HEADLINE_1: 'Unternehmensprofile auf XING',
    CP_100_TEASER_TEXT:
      '<p>Alle Informationen auf einen Blick: Ansprechpersonen, Statistiken, Updates und \nVerbindungspfade. Wie sehen Unternehmensprofile aus?</p>\n<p><a target="_blank" id="video-link" href="{video_link}">Video \nstarten</a> | <a href="https://www.xing.com/companies/about">Mehr Informationen</a></p>',
    CP_100_WARNING_NO_MY_COMPANY:
      'Dein Profil ist noch nicht mit einem Unternehmensprofil verbunden. Gib dazu in Deinem XING Profil ein Unternehmen an, für das Du aktuell tätig bist.',
    CP_100_WARNING_NOT_EXISTING_COMPANY:
      'Unternehmensprofile werden im Moment \nautomatisch erzeugt, wenn eine ausreichende \nAnzahl von XING-Mitgliedern das Unternehmen mit \nderselben Schreibweise in ihrem Profil \nangibt. Für den Unternehmensnamen, den Du in Deinem Profil \neingetragen hast, konnte kein \nUnternehmensprofil generiert werden.',
    CP_100_WARNING_PROFILE_NOT_CLAIMED_YET:
      'Dieses Unternehmensprofil wurde noch nicht aktiviert. Hier sind andere interessante Unternehmen:',
    CP_100_WARNING_PROFILE_NOT_VISIBLE_LOGGED_OUT:
      'Dieses Profil ist entweder nicht verfügbar oder nur sichtbar, nachdem Du Dich bei XING eingeloggt hast.',
    CP_100_WARNING_UNPUBLISHED_COMPANY:
      'Das Unternehmensprofil, das Du aufgerufen hast, ist derzeit nicht verfügbar.',
    CP_100_WIDGET_BUTTON1: 'Kolleg·innen treffen',
    CP_100_WIDGET_BUTTON2: 'Mitglied werden',
    CP_100_WIDGET_BUTTON3: 'Weiter zu XING',
    CP_100_WIDGET_FIND_OUT_WHO:
      'Finde heraus, ob Du einen der Mitarbeitenden kennst.',
    CP_100_WIDGET_HEADER_NUMBER_EMPLOYEES:
      '{number_employees} Mitarbeitende von {company_link} sind bereits bei XING.',
    CP_100_WIDGET_HEADER1: 'Zukünftige Kolleg·innen kennenlernen',
    CP_100_WIDGET_HEADER2: 'Entdecke alte und neue Kontakte.',
    CP_100_WIDGET_HEADLINE_CONTACTS:
      'Du hast {contacts_number} Kontakte bei {company_link}.',
    CP_100_WIDGET_HEADLINE_CONTACTS_INFO:
      '<a href="{contacts_url}" target="blank">{contacts_number} Deiner Kontakte</a> arbeiten bei {company_link}.',
    CP_100_WIDGET_HEADLINE_NO_CONTACTS:
      '{employees_count} Mitarbeitende von {company_link} sind bei XING, darunter auch:',
    CP_100_WIDGET_HEADLINE_NO_CONTENT: 'Jetzt XING-Mitglied werden',
    CP_100_WIDGET_HEADLINE_ONE_CONTACT:
      'Einer Deiner Kontakte ist bei {company_link}.',
    CP_100_WIDGET_HEADLINE_ONE_CONTACT_INFO:
      '<a href="{contacts_url}" target="blank">Einer Deiner Kontakte</a> arbeitet bei {company_link}.',
    CP_100_WIDGET_LOG_IN: 'Einloggen',
    CP_100_WIDGET_MORE_EMPLOYEES_LINK:
      '{number_employees} weitere Mitarbeitende auf XING',
    CP_100_WIDGET_NO_MEMBERSHIP: 'Noch nicht bei XING?',
    CP_100_WIDGET_PARAGRAPH_NO_COMPANY:
      'Werde jetzt kostenlos Mitglied bei XING! Über {xing_members_count} Mio. Mitglieder sind schon dabei.',
    CP_100_WIDGET_PARAGRAPH1:
      '{employees_count} XING-Mitglieder arbeiten bei {company_link}.',
    CP_100_ZIP_CODE_LABEL: 'PLZ',
    CP_200_ABOUT_HTML_FONT:
      'Der Text hat die Schriftgröße 18 und die Schriftfarbe Rot.',
    CP_200_ABOUT_HTML_H2: 'Ihre Überschrift',
    CP_200_ABOUT_HTML_INFO:
      'Zulässige HTML-Tags: {allowed_html}<br />Beispiel für die HTML-Auszeichnung einer Überschrift:<br />{example_headline}<br />Beispiel für farbig gestalteten Text:<br />{example_text}',
    CP_200_ABOUT_MAX_CHARS: 'Max. 6.000 Zeichen',
    CP_200_ABOUT_TEXT_DESCRIPTION:
      'Wir empfehlen, am Ende dieser Seite entweder einen Link zum Impressum Ihrer Website oder einen vollständigen Impressumstext einzufügen.',
    CP_200_ABOUT_TEXT_DESCRIPTION_2:
      'Anmerkung zur Darstellung des Textes: Zeilenumbrüche werden beibehalten, Links und Mailadressen werden klickbar dargestellt. Weitere Formatierungen sind durch Verwendung von HTML-Tags möglich.',
    CP_200_ABOUT_TEXT_DESCRIPTION_3:
      'Hinweis: Um ein einheitliches Erscheinungsbild der Inhalte auf XING zu gewährleisten, werden alle Texte in Schwarz dargestellt.',
    CP_200_ACTIONS_BOX_HEADING: 'Optionen',
    CP_200_ADD_ABOUT_TEXT_HEADLINE:
      'Präsentiere Dich hier als attraktiver Arbeitgeber.',
    CP_200_ADD_COMPANY_KEYWORDS_FIELD:
      'Gib bis zu {num_keywords} durch Kommas getrennte Wörter und max. {max_length} Zeichen ein.',
    CP_200_ADD_CONTACT_PERSON: 'Ansprechperson hinzufügen',
    CP_200_ADD_CONTACT_PERSON_LIMIT_REMOVE:
      'Um eine Ansprechperson hinzuzufügen, entferne zunächst eine bestehende, denn Du hast bereits die maximale Anzahl von Ansprechpersonen erreicht.',
    CP_200_ADD_CONTACT_PERSON_LIMIT_UPGRADE:
      'Du hast die maximale Anzahl von Ansprechpersonen erreicht. Wähle das Employer Branding-Profil, um weitere Ansprechpersonen hinzuzufügen.',
    CP_200_ADD_DESCRIPTION_FIELD: 'maximal {max_length} Zeichen',
    CP_200_ADD_DESCRIPTION_LABEL: 'Kurzbeschreibung',
    CP_200_ADD_HEADER_GRAPHIC_DEFAULT:
      'Präsentiere Dein Unternehmen an dieser Stelle mit einer ansprechenden Grafik. Du kannst diese Grafik übrigens beliebig oft austauschen und dadurch z. B. auf aktuell offene Stellenangebote oder Sonderaktionen aufmerksam machen.',
    CP_200_ADD_HEADER_GRAPHIC_DEFAULT_HEADLINE:
      'Platzhalter für Ihr persönliches Titelbild',
    CP_200_ADD_HEADER_GRAPHIC_EMPLOYEE:
      'Setze Dein Unternehmen als attraktiven Arbeitgeber in Szene und verstärke Deine Sichtbarkeit. Lade z. B. ein Logo hoch oder informieren Deine individuellen Zielgruppen über neue Produkte, Innovationen oder aktuelle Themen.',
    CP_200_ADD_HEADER_GRAPHIC_EMPLOYEE_HEADLINE:
      'Individualisiere Dein Firmenprofil',
    CP_200_ADD_HEADER_GRAPHIC_HEADLINE: 'Header-Grafik hochladen',
    CP_200_ADD_NEWS_HEADLINE: 'Neuigkeit schreiben',
    CP_200_ADD_NEWS_HEADLINE_FIELD:
      'Gib hier die Überschrift Deines Beitrags ein.',
    CP_200_ADD_NEWS_HEADLINE_LABEL: 'Überschrift',
    CP_200_ADD_NEWS_LINK_LABEL: 'Link hinzufügen (optional)',
    CP_200_ADD_NEWS_LINK_LINK: 'Link eintragen',
    CP_200_ADD_NEWS_NEW_COMMENT_FIELD:
      'Gib hier Deine Anmerkung zu dieser Link-Empfehlung ein.',
    CP_200_ADD_NEWS_SUBHEADLINE:
      'Teilen Sie hier Neuigkeiten aus Ihrem Unternehmen.',
    CP_200_ADD_NEWS_TEXT_FIELD:
      'Hier ist Platz für den Beitragstext – bis zu 1.200 Zeichen lang darf er sein.',
    CP_200_ADD_NEWS_TEXT_FIELD_HINT: 'maximal 1.200 Zeichen',
    CP_200_ADD_NEWS_TEXT_HTML_LABEL: 'Beitragstext',
    CP_200_ADD_NEWS_TEXT_LABEL: 'Beitragstext*',
    CP_200_ADD_RSS_FEED_LABEL:
      'RSS-Link hinzufügen (z. B. "http://www.unternehmens-blog.de/feed")',
    CP_200_ADD_TWITTER_FEED: 'Twitter-Feed bearbeiten',
    CP_200_ADD_TWITTER_FEED_LABEL:
      'Gib Deinen Twitter-Nutzernamen an (ohne "@"-Zeichen).',
    CP_200_ADD_TWITTER_FEED_TEXT_FIELD: 'Twitter-Nutzername hier eingeben',
    CP_200_ADD_UPDATE_HEADLINE_FIELD:
      'Gib hier die Überschrift Deines Beitrags ein.',
    CP_200_ADDRESS_CHANGE_CONFIRMATION:
      'Wir haben Deine Rechnungsadresse ebenfalls aktualisiert. Falls Du noch Fragen dazu hast oder die Änderung rückgängig machen möchtest, schreibe uns gerne an {email}.',
    CP_200_ADDRESS_CHANGE_ERROR:
      'Leider konnte das System die Adresse nicht aktualisieren. Kannst Du uns die Änderung bitte kurz per E-Mail schicken? Adresse: {email}',
    CP_200_ADDRESS_CHANGE_HEADING: 'Rechnungsanschrift auch aktualisieren?',
    CP_200_ADDRESS_CHANGE_TEXT:
      'Möchtest Du diese neue Adresse auch als neue Rechnungsanschrift verwenden?',
    CP_200_ADDRESS_CHANGE_WARNING:
      'Wie von Dir gewünscht, haben wir die Rechnungsadresse nicht mit aktualisiert. Wenn Du dazu noch Fragen hast oder die Rechnungsadresse doch ändern möchtest, schreibe uns gerne an {email}.',
    CP_200_ADDRESS_LABEL: 'Straße und Hausnr.',
    CP_200_AFFILIATES_ASSOCIATE_TYPE: 'Schwester',
    CP_200_AFFILIATES_CLIENT_TYPE: 'Kunde',
    CP_200_AFFILIATES_COMPANY_NAME_HINT:
      'Achte bitte auf die korrekte Schreibweise.',
    CP_200_AFFILIATES_EXISTS: 'Diese Verbindung hast Du bereits eingetragen.',
    CP_200_AFFILIATES_FORM_HEADLINE: 'Verbindungen bearbeiten',
    CP_200_AFFILIATES_FORM_INTRO_TEXT:
      'Du kannst hier Tochterfirmen, Kunden, Dienstleister, etc. angeben. Jedes dieser Unternehmen benötigt dazu ein Unternehmensprofil auf XING. Bitte gib nur Unternehmen an, die dieser Angabe zugestimmt haben.',
    CP_200_AFFILIATES_FRANCHISE_TYPE: 'Franchise',
    CP_200_AFFILIATES_HEADLINE: 'Verbindungen zu anderen Unternehmen',
    CP_200_AFFILIATES_INTRO_EDIT_TEXT:
      'Du kannst hier Tochterfirmen, Kunden, Dienstleister, etc. angeben. Jedes dieser Unternehmen benötigt ein Unternehmensprofil auf XING. Bitte gib nur Unternehmen an, die dieser Angabe zugestimmt haben.',
    CP_200_AFFILIATES_JOINT_VENTURE_TYPE: 'Beteiligung',
    CP_200_AFFILIATES_MAX_NUMBER:
      'Du kannst leider nicht mehr als 15 Verbindungen eintragen. Lösche bitte ggf. einen derzeitigen Eintrag, um einen neuen hinzuzufügen.',
    CP_200_AFFILIATES_NAME: 'Unternehmensname',
    CP_200_AFFILIATES_NOT_EXISTS:
      'Dieses Unternehmen konnten wir auf XING nicht finden.',
    CP_200_AFFILIATES_PARENT_TYPE: 'Mutter',
    CP_200_AFFILIATES_PARTNER_TYPE: 'Partner',
    CP_200_AFFILIATES_PLACEHOLDER:
      'Gib hier Deine Tochterfirmen, Kunden, Dienstleister etc. an.',
    CP_200_AFFILIATES_PLACEHOLDER_BUTTON: 'Unternehmen hinzufügen',
    CP_200_AFFILIATES_PLACEHOLDER_TITLE: 'Verbindung hinzufügen',
    CP_200_AFFILIATES_REGIONAL_BRANCH_TYPE: 'Niederlassung',
    CP_200_AFFILIATES_SELECT_CATEGORY: 'Bitte wähle die Art der Verbindung.',
    CP_200_AFFILIATES_SERVICE_PROVIDER_TYPE: 'Dienstleister',
    CP_200_AFFILIATES_SUBSIDIARY_TYPE: 'Tochter',
    CP_200_AFFILIATES_TYPE: 'Art der Verbindung',
    CP_200_AGE_GROUP_ABOVE_65: 'Über 65',
    CP_200_AGE_GROUP_FROM_20_TO_24: 'Von 20 bis 24',
    CP_200_AGE_GROUP_FROM_25_TO_34: 'Von 25 bis 34',
    CP_200_AGE_GROUP_FROM_35_TO_44: 'Von 35 bis 44',
    CP_200_AGE_GROUP_FROM_45_TO_54: 'Von 45 bis 54',
    CP_200_AGE_GROUP_FROM_55_TO_64: 'Von 55 bis 64',
    CP_200_AGE_GROUP_UNDER_20: 'Unter 20',
    CP_200_AGES: 'Altersgruppen',
    CP_200_ALL_OPTION_CONTACTS: 'Alle Mitarbeitenden',
    CP_200_ALL_OPTION_FOLLOWERS: 'Alle Follower',
    CP_200_ARTICLE_IS_BEING_PROCESSED:
      'Der Beitrag wurde erstellt und ist in Kürze für Ihre Follower sichtbar.',
    CP_200_AVAILABLE_TWITTER_FEEDS:
      'Du hast bereits Twitter-Feeds hinzugefügt.',
    CP_200_AVAILABLE_TWITTER_FEEDS_INFO:
      'Tweets werden alle 30 Minuten aktualisiert. Wenn Du einen neuen Twitter-Feed hinzufügst, kann der Import der ersten Tweets jedoch auch etwas länger in Anspruch nehmen.',
    CP_200_BACK_TO_CP_LINK: 'Zum Unternehmensprofil',
    CP_200_BASIC_DATA_HEADLINE: 'Zahlen & Daten',
    CP_200_BELONG_TO_COMPANY_CONFIRM_HEADLINE: 'Arbeitest Du hier?',
    CP_200_BELONG_TO_COMPANY_DESCRIPTION:
      '<p>Um hier als Mitarbeiter·in aufgeführt zu werden, kopiere bitte zunächst den vollständigen Namen dieses Unternehmens:</p>\n\n<p><strong>{company}</strong></p>\n\n<p>Trage diesen Namen dann in Deinem Profil unter "Berufserfahrung" als Dein derzeitiges Unternehmen ein. Du erscheinst kurz darauf hier als Mitarbeiter.</p>\n\n<p>Mit Klick auf "Weiter" wirst Du zu Deinem Profil weitergeleitet.</p>',
    CP_200_BELONG_TO_COMPANY_HEADLINE: 'Arbeitest Du hier?',
    CP_200_BELONG_TO_COMPANY_LINK: 'Arbeitest Du hier?',
    CP_200_BELONG_TO_COMPANY_MANUAL_UPDATE:
      'Um auf einem Unternehmensprofil zu erscheinen, \ngehe bitte zu Deinem Profil und aktiviere „Diese Tätigkeit neben meinem Namen und oben \nauf meiner Profilseite anzeigen“ für Deine aktuelle \nTätigkeit („bis heute“). Tätigkeit und Unternehmen \nerscheinen dann neben Deinem Profilfoto und Du wirst \nin das Unternehmensprofil aufgenommen.',
    CP_200_BELONG_TO_COMPANY_TEXT:
      'Du arbeitest bei diesem Unternehmens, erscheinst jedoch nicht unter den Mitarbeitenden? Dann weicht die Schreibweise des Unternehmensnamens in Deinem Profil von der Schreibweise des Unternehmens ab. Um dies zu ändern, bestätige hier bitte aktiv Deine Unternehmenszugehörigkeit. Die Schreibweise in Deinem Profil wird entsprechend aktualisiert und Du erscheinst 24 Stunden später unter den Mitarbeitenden.',
    CP_200_BEST_MONTH: 'Bestmarke',
    CP_200_BEST_WEEK: 'Bestmarke',
    CP_200_BEST_YEAR: 'Bestmarke',
    CP_200_BUSINESS_CARD_COLLAPSE: 'Unternehmensdetails',
    CP_200_BUSINESS_CARD_CONTACT_DETAILS: 'Kontaktdaten',
    CP_200_BUSINESS_CARD_CONTACT_US_LINK: 'Kontaktiere uns',
    CP_200_BUSINESS_CARD_EXPAND: 'Unternehmensdetails',
    CP_200_BUTTON_PREVIEW: 'Vorschau unten anzeigen',
    CP_200_CALL_COSTS_HINT:
      'Bitte gib hier bei kostenpflichtigen Hotlines die Kosten für Anrufe ein.',
    CP_200_CALL_COSTS_LABEL: 'Anrufkosten',
    CP_200_CALLOUT_CONTACT_TAB_REMOVED:
      '<span class="new-sign bold">NEU</span> Du findest Kontaktpersonen jetzt hier.',
    CP_200_CAREER_LEVEL_COLHEADER: 'Karriere-Stufe',
    CP_200_CAREER_LEVELS: 'Karriere-Stufen',
    CP_200_CHANGE_LOGO: 'Ändern',
    CP_200_CLAIM_YOUR_CP_HEADING: 'Stelle Dich als Arbeitgeber vor.',
    CP_200_CLAIM_YOUR_CP_LINK: 'Jetzt kostenlos aktivieren',
    CP_200_CLAIM_YOUR_CP_TEXT:
      'Erzähle potenziellen Kandidat·innen, warum es sich lohnt, bei Dir zu arbeiten. Finde so schneller passende Fachkräfte für Deine offenen Stellen.',
    CP_200_CLAIMING_TEASER_HEADLINE: 'Dies ist Ihr Unternehmensprofil!',
    CP_200_CLAIMING_TEASER_LINK: 'Unternehmensprofil anlegen',
    CP_200_CLAIMING_TEASER_LINK_TITLE: 'Weiter zur Produktauswahl',
    CP_200_CLAIMING_TEASER_TEXT:
      'Diese Seite haben wir für Dein Unternehmen {company_name} reserviert &ndash; Du musst das Profil nur noch anlegen.',
    CP_200_COMPANIES: 'Unternehmen',
    CP_200_COMPANIES_RECENTLY_ADDED_PAGE_TITLE: 'Neue Unternehmen auf XING',
    CP_200_COMPANIES_RECENTLY_ADDED_WARNING:
      'Dir werden hier maximal {num_companies} Unternehmen angezeigt. Möchtest Du gezielt ein bestimmtes Unternehmen finden? Verwende dafür bitte die <a href="/companies">Suche</a>.',
    CP_200_COMPANY_KEYWORDS_EDITOR_INFO:
      'Die Eingabe von Stichwörtern ist hier äußerst wichtig. Dein Unternehmensprofil kann darüber von XING-Mitgliedern gefunden werden. Gib die Begriffe ein, unter denen Du gefunden werden willst.',
    CP_200_COMPANY_KEYWORDS_EDITOR_INFO_BOX:
      'Geben Sie hier an, welche Produkte und Dienstleistungen Ihr Unternehmen bietet. Verwenden Sie dabei Schlagwörter. Sie helfen Nutzern, Ihr Unternehmen bei Suchanfragen zu finden. Sie können {num_keywords} durch Komma getrennte Schlagwörter angeben.',
    CP_200_COMPANY_KEYWORDS_HEADING: 'Produkte und Services',
    CP_200_COMPANY_KEYWORDS_INFO:
      'Die aufgeführten Schlagwörter bezeichnen die Dienstleistungen und Produkte des Unternehmens. Klicke auf ein Schlagwort und Du findest Unternehmen mit ähnlichen Angeboten.',
    CP_200_COMPANY_UPDATES_INFO:
      'Wenn Du Dich für Pressemeldungen oder Neuigkeiten über Produkte und Dienstleistungen dieses Unternehmens interessierst, folge dem Unternehmen. Du bekommst die Neuigkeiten dann direkt auf Deiner Startseite.',
    CP_200_COMPANY_UPDATES_TWEET: 'Tweet',
    CP_200_CONTACT_PERSON_DESC: 'Kurzbeschreibung',
    CP_200_CONTACT_PERSON_EDIT: 'Kontaktdaten bearbeiten',
    CP_200_CONTACT_PERSON_EDITORS_INTRO:
      '<strong>So fügen Sie Kontaktpersonen hinzu:</strong> Wählen Sie eine·n Mitarbeiter·in aus und beschreiben Sie kurz die Tätigkeit dieser Person. Diese Beschreibung wird allen Besuchern angezeigt.<br><br>\n<strong>Wichtig:</strong> Vergessen Sie bitte nicht, diese Person zu informieren, dass sie nun als Kontaktperson aufgeführt wird. Kontaktpersonen sollten zudem in den Einstellungen zur Privatsphäre den Empfang von XING Nachrichten so einstellen, dass jedes Mitglied sie anschreiben darf.',
    CP_200_CONTACT_PERSON_ERR_ALREADY_CONTACT:
      'Dieses Mitglied ist schon als Kontaktperson eingetragen.',
    CP_200_CONTACT_PERSON_ERR_CHAR_LIMIT: 'max. 300 Zeichen',
    CP_200_CONTACT_PERSON_ERR_NOT_IN_DATABASE:
      'Diese Person erscheint nicht unter Ihren Mitarbeitenden. Bitten Sie die Person ggf., ihr XING Profil zu aktualisieren.',
    CP_200_CONTACT_PERSON_INTRO:
      'In dieser Liste findest Du Mitarbeitende dieses Unternehmens, die sich explizit als Kontaktpersonen haben eintragen lassen. Nutze diese Chance, direkt mit der richtigen Ansprechperson in Kontakt zu treten.',
    CP_200_CONTACT_PERSON_INTRO_DIRECT_CONTACTS:
      'Ein Hinweis noch: Du hast bereits {num_contacts} direkte Kontakte in diesem Unternehmen. Möchtest Du zunächst diese {link_employee_tab} kontaktieren?',
    CP_200_CONTACT_PERSON_INTRO_DIRECT_CONTACTS_2:
      'Ein Hinweis noch: Du hast bereits {num_contacts} direkte Kontakte in diesem Unternehmen. Möchtest Du zunächst diese <a href="{link_employee_tab}">Mitglieder</a> kontaktieren?',
    CP_200_CONTACT_PERSON_MOVE_DOWN: 'Nach unten verschieben',
    CP_200_CONTACT_PERSON_MOVE_UP: 'Nach oben verschieben',
    CP_200_CONTACT_PERSON_NAME: 'Name der Ansprechperson',
    CP_200_CONTACT_PERSON_SELECT_LABEL: 'Position der Ansprechperson',
    CP_200_CONTACTS_WORK_HERE: 'Folgende Kontakte arbeiten hier:',
    CP_200_CP_COMMENTS_ENABLED_LABEL:
      'Unternehmens-Neuigkeiten können kommentiert werden.',
    CP_200_CP_EMPLOYEER_MODULE_ENABLED_LABEL:
      'Wunsch-Arbeitgeber-Modul anzeigen',
    CP_200_CP_EXECUTIVES_ENABLED_LABEL:
      'Top-Führungskräfte in der Rubrik "Mitarbeitende" hervorheben',
    CP_200_CP_LOGGED_OUT_TAB_TITLE:
      'Bitte logge Dich ein, um weitere Informationen zu sehen.',
    CP_200_CP_LOGGED_OUT_TEASER_BUTTON:
      'Mehr Infos zum Employer Branding-Profil',
    CP_200_CP_LOGGED_OUT_TEASER_INTRO:
      'Setze Dein Unternehmen auf XING professionell in Szene und stärke Deine Präsenz im Web.',
    CP_200_CP_LOGGED_OUT_TEASER_LIST:
      '<h5>Deine Vorteile:</h5>\n<ul class="bullet-list">\n  <li>Sicher Dir neue Kunden und Aufträge.</li>\n  <li>Gewinne und binde neue Mitarbeitende.</li>\n  <li>Halte die XING Gemeinschaft auf dem Laufenden.</li>\n</ul>',
    CP_200_CP_SETTINGS_HEADLINE: 'Einstellungen bearbeiten',
    CP_200_CP_SETTINGS_LABEL:
      'Dieses Unternehmensprofil soll für Suchmaschinen auffindbar und für XING Nicht-Mitglieder sichtbar sein.',
    CP_200_CP_SETTINGS_LINK: 'Bearbeiten',
    CP_200_CP_SETTINGS_SUCCESS:
      'Die Einstellungen für Ihr Unternehmensprofil wurden gespeichert.',
    CP_200_CP_UNDER_MAINTENANCE:
      'Der Bereich Unternehmensprofile wird im Moment von uns gewartet. Während dessen ist eine Bearbeitung des Profils leider nicht möglich. Wir danken für Ihr Verständnis.',
    CP_200_CREATE_COMPANY_LINK: 'Unternehmensprofil anlegen',
    CP_200_CREATE_COMPANY_LINK_NEW: 'Arbeitgeberprofil anlegen',
    CP_200_CREATE_JOB_AD: 'Stellenanzeige einstellen',
    CP_200_DATA_ORIGIN_INFO:
      'Diese Statistiken basieren auf XING Profildaten, sie wurden nicht vom Unternehmen selbst zur Verfügung gestellt. Die Daten stellen eine automatisch generierte Schätzung dar, basierend auf den freiwilligen Angaben der Mitglieder. Die Statistiken enthalten keine Informationen von Mitarbeitenden, die nicht bei XING registriert sind.',
    CP_200_DELETE_UPDATE_CONFIRM: 'Willst Du diesen Eintrag wirklich löschen?',
    CP_200_DETAILED_INFO:
      'Detaillierte Informationen zur Auto-Korrektur \nanzeigen',
    CP_200_DOWNLOAD_DOCUMENT: 'Dokument herunterladen',
    CP_200_EDIT_ADDITIONAL_DATA_HEADLINE: 'Weitere Infos',
    CP_200_EDIT_ADDRESS_DATA_HEADLINE: 'Adressdaten',
    CP_200_EDIT_DESCRIPTION_HEADLINE: 'Beschreibung',
    CP_200_EDIT_NEWS_HEADLINE: 'Update bearbeiten',
    CP_200_EDITOR_BAR_FOLLOWERS: 'Follower',
    CP_200_EDITOR_BAR_FREE: 'Editoren verwalten',
    CP_200_EDITOR_BAR_SETTINGS: 'Einstellungen',
    CP_200_EDITOR_BAR_SETTINGS_FREE: 'Einstellungen / Editoren verwalten',
    CP_200_EDITOR_BAR_STATISTICS: 'Statistiken',
    CP_200_EDITOR_BAR_SUPPORT: 'Hilfe',
    CP_200_EDITOR_BAR_VISITORS: 'Besucher',
    CP_200_EMAIL_LABEL: 'E-Mail-Adresse',
    CP_200_EMPLOYEE: 'Mitarbeitende·r',
    CP_200_EMPLOYEE_CONNECTIONS_DESCRIPTION:
      'Mitarbeitende dieses Unternehmens sind mit Mitarbeitenden der hier aufgelisteten Unternehmen verbunden. Klick auf einen Unternehmensnamen, um zu den jeweiligen Unternehmensprofilen zu gelangen. Die Zahl am Zeilenende zeigt, wie viele Mitarbeitende eine Verbindung zum entsprechenden Unternehmen haben.',
    CP_200_EMPLOYEE_CONNECTIONS_HEADER:
      'Mitarbeitende {from}-{to} von {total}, die mit dem Unternehmen {company_name} verbunden sind',
    CP_200_EMPLOYEE_CONNECTIONS_HEADLINE: 'Top-Vernetzungen',
    CP_200_EMPLOYEE_CONNECTIONS_PRIVACY_INFO:
      'Es werden maximal 10 Unternehmen angezeigt, zu denen Verbindungen bestehen. XING beachtet stets die Einstellungen zur Privatsphäre jeder Person, somit erscheinen die Personen nicht, die eine andere Einstellung als "Meine Kontaktliste ist sichtbar für \'alle Mitglieder\'" ausgewählt haben.',
    CP_200_EMPLOYEE_LIST_CONTACTS_INFO:
      '{number_of_employees} Mitarbeiter·in dieses Unternehmens ist ein direkter Kontakt von Dir.',
    CP_200_EMPLOYEE_LIST_CONTACTS_INFO_PLURAL:
      '{number_of_employees} Mitarbeitende dieses Unternehmens sind direkte Kontakte von Dir.',
    CP_200_EMPLOYEE_LIST_HEADER:
      'Mitarbeitende auf XING ({from}-{to} von {total})',
    CP_200_EMPLOYEE_LIST_SHOW_ALL_LINK:
      'Alle Mitarbeitenden dieses Unternehmens',
    CP_200_EMPLOYEE_STATISTICS_HEADLINE: 'Mitarbeitende: Zahlen & Daten',
    CP_200_EMPLOYEE_STATISTICS_HEADLINE_DESCRIPTION:
      'Die angezeigten statistischen Daten werden anhand der XING Profile einmal täglich automatisch erstellt. Die Daten wurden nicht vom Unternehmen selbst zur Verfügung gestellt. Solltest Du Fragen zu diesen Daten haben, <a href="{contact_link}">kontaktiere</a> uns bitte.',
    CP_200_EMPLOYEES_ACTIVITIES_HEADLINE:
      'Aktivitäten der Mitarbeitenden auf XING',
    CP_200_EMPLOYEES_HAVES_HEADLINE: 'Mitarbeitende dieses Unternehmens bieten',
    CP_200_EMPLOYEES_HAVES_LINK_ALT: 'Suche starten',
    CP_200_EMPLOYEES_HAVES_TOP_10_LINK: 'Top 10',
    CP_200_EMPLOYEES_HAVES_TOP_15_LINK: 'Top 15',
    CP_200_EMPLOYEES_HAVES_TOP_5_LINK: 'Top 5',
    CP_200_EMPLOYEES_LABEL: 'Mitarbeitende auf XING',
    CP_200_EMPLOYEES_LIST_DELETED_MEMBER: '(kein Mitglied bei XING)',
    CP_200_EMPLOYEES_LIST_HEADLINE: 'Diese Mitarbeitenden sind bei XING:',
    CP_200_EMPLOYEES_LIST_HEADLINE_DESCRIPTION:
      'Die Liste der Mitarbeitenden wird einmal täglich über den Firmennamen-Eintrag in den Mitgliederprofilen ermittelt.',
    CP_200_EMPLOYEES_LIST_PRIVACY_CHANGED:
      'Dieses Mitglied hat seine Sichtbarkeits-Einstellungen geändert.',
    CP_200_ERROR_ADD_NEWS_HEADLINE:
      'Deine Eingabe überschreitet die zulässige Anzahl von Zeichen. Bitte gib maximal 100 Zeichen ein.',
    CP_200_ERROR_ADD_NEWS_LINK: 'Die eingegebene URL ist nicht gültig.',
    CP_200_ERROR_ADD_NEWS_MISSING_COMMENT_LINK:
      'Bitte geben Sie hier noch Ihre Anmerkung zu diesem Link ein.',
    CP_200_ERROR_ADD_NEWS_MISSING_HEADLINE:
      'Bitte gib hier noch eine Überschrift ein.',
    CP_200_ERROR_ADD_NEWS_MISSING_INPUT:
      'Gib hier jetzt noch den Text des Beitrages ein.',
    CP_200_ERROR_ADD_NEWS_MISSING_URL:
      'Bitte gib hier den Link an, mit "https://" oder "http://" am Anfang.',
    CP_200_ERROR_ADD_NEWS_TEXT:
      'Deine Eingabe überschreitet die zulässige Zeichenzahl. Bitte gib maximal 1000 Zeichen ein.',
    CP_200_EVENTS_LINK: 'Events von Mitarbeitenden',
    CP_200_EVENTS_LINK_TITLE:
      'Alle öffentlichen Events, die von Mitarbeitenden dieses Unternehmens organisiert werden oder an denen Mitarbeitende dieses Unternehmens teilnehmen',
    CP_200_FAX_LABEL: 'Fax',
    CP_200_FEATURE_COMPANY_EMAIL_CONTENTS:
      "Liebes XING Team,\n{separator}\nIch habe Interesse an einer Platzierung meines Unternehmens in der Box 'Ausgewaehlte \nUnternehmensprofile'. \nBitte lasst mir weitere Informationen hierzu zukommen.\n{separator}\nVielen Dank!\n{separator}\n{separator}\nRef: {reference}",
    CP_200_FEATURE_COMPANY_EMAIL_SUBJECT: 'Ausgewaehlte Unternehmensprofile',
    CP_200_FEATURE_COMPANY_HEADING: 'Ihr Unternehmen hier!',
    CP_200_FEATURE_COMPANY_INFO:
      'Erscheine mit Deinem Unternehmensprofil an erster Stelle! Profitiere so von mehr \nAufmerksamkeit und höheren Besucherzahlen! Mehr Infos zur Buchung? Einfach eine E-Mail an <a \nhref="{email_link}">{email_address}</a> senden. <strong>(Voraussetzung für die Buchung ist ein bestehendes XING Unternehmensprofil)</strong>',
    CP_200_FOLLOW: 'Abonnieren',
    CP_200_FOLLOW_LINK: 'Folgen',
    CP_200_FOLLOW_LINK_ALT:
      'Abonnierte Neuigkeiten werden Dir auf Deiner XING-Startseite angezeigt. Hinweis: Wenn Du auf den Button klickst, wird diese Aktivität Deinen direkten Kontakten in den Neuigkeiten angezeigt.',
    CP_200_FOLLOW_LINK_BACK: 'Wieder folgen',
    CP_200_FOLLOW_LINK_SHORT: 'Abonnieren',
    CP_200_FOLLOW_NOT_POSSIBLE:
      'Leider veröffentlicht das Unternehmen, dem Du folgen möchtest, derzeit keine Neuigkeiten.',
    CP_200_FOLLOWER_LIST_CONTACTS_INFO:
      '{number_of_followers} Deiner Kontakte folgen diesem Unternehmen.',
    CP_200_FOLLOWER_LIST_CONTACTS_INFO_PLURAL:
      '{number_of_followers} Follower der Unternehmens-Neuigkeiten sind direkte Kontakte von Dir.',
    CP_200_FOLLOWER_LIST_HEADER: 'Follower {from}-{to} von {total}',
    CP_200_FOLLOWERS_INFO:
      'Hinweis: Diesem Unternehmen folgen mehr als {max_number} Mitglieder. Es werden nur die {max_number} zuletzt hinzugekommenen Follower angezeigt.',
    CP_200_FOLLOWERS_LIST_INFO:
      'Hier siehst Du alle XING Mitglieder, die diesem Unternehmen folgen. Klicke auf einen Namen, um zum entsprechenden Profil zu gelangen.',
    CP_200_FOLLOWERS_THIS_COMPANY:
      'Diese Kontakte folgen dem Unternehmen bereits.',
    CP_200_FOLLOWING: 'Abonniert',
    CP_200_FOLLOWING_SINCE_COLHEADER: 'seit',
    CP_200_FOUNDATION_YEAR_LABEL: 'Gründungsjahr',
    CP_200_FOUNDED_LABEL: 'Gründung',
    CP_200_HEADER_GRAPHIC_ALT_TEXT:
      'Unternehmensprofil von {company_name}: Header-Grafik',
    CP_200_HEADER_GRAPHIC_TEASER_BUTTON: 'Mehr Infos',
    CP_200_HEADER_GRAPHIC_TEASER_HEADING:
      'Gestalte Deinr Profil in nur 2 Schritten und setze Dein Unternehmen in Szene!',
    CP_200_HEADER_GRAPHIC_TEASER_LIST_ITEM_1:
      'Individuelles Design, inkl. Logo & Unternehmensbeschreibung',
    CP_200_HEADER_GRAPHIC_TEASER_LIST_ITEM_2:
      'Mehr Sichtbarkeit in und außerhalb von XING',
    CP_200_HELPIFY_HEADLINE: 'Noch Fragen?',
    CP_200_HELPIFY_LINK: 'Fragen und Antworten zu den Unternehmensprofilen',
    CP_200_HELPIFY_TEXT: 'Weitere Infos findest Du in den',
    CP_200_HOMEPAGE_LABEL: 'Unternehmenswebsite',
    CP_200_IMPORT_FEEDS_HEADLINE: 'Inhalte importieren',
    CP_200_IMPORT_FEEDS_SUBHEADLINE:
      'Importiere Deine Unternehmens-Tweets und -Blogbeiträge!',
    CP_200_IMPORT_UPDATES_FROM_EXTERNAL_SERVICES: 'Neuigkeiten importieren',
    CP_200_INACTIVE_TAB_ABOUT_TITLE:
      'Dieser Tab steht zur Verfügung, wenn das Unternehmen ein entsprechendes Profil eingerichtet hat.',
    CP_200_INACTIVE_TAB_TITLE:
      'Dieser Tab steht zur Verfügung, sobald das Unternehmen seine erste Neuigkeit veröffentlicht hat.',
    CP_200_INDUSTRIES: 'Branchen',
    CP_200_INDUSTRY_2ND_LEVEL_LABEL: 'Bereich',
    CP_200_INDUSTRY_DIRECTORY_LARGEST_INDUSTRIES: 'Top 40',
    CP_200_INDUSTRY_LABEL: 'Branche',
    CP_200_INVALID_HTML_WARNING:
      'Es wurden nicht erlaubte HTML-Tags gefunden! Die betreffenden Tags wurden automatisch entfernt.\n(Anmerkung: Um automatische Korrektur zu vermeiden, achten Sie bitte auf XHTML-Konformität, insbesondere darauf, einzeln zu verwendende Tags mit "/>" abzuschließen, wie bspw. das br-Tag, und schließende Tags nicht zu vergessen.)',
    CP_200_JOB_OFFERS_LINK: 'Stellenangebote dieses Unternehmens auf XING',
    CP_200_JOB_OFFERS_LINK_TITLE:
      'Alle Stellenangebote, die dieses Unternehmen auf XING eingestellt hat',
    CP_200_JOB_POSTINGS_CAREER_LEVEL: 'Karriere-Stufe',
    CP_200_JOB_POSTINGS_COMPANY: 'Unternehmen',
    CP_200_JOB_POSTINGS_CONTACT: 'Ansprechperson',
    CP_200_JOB_POSTINGS_HEADLINE: 'Neues Stellenangebot',
    CP_200_JOB_POSTINGS_JOB_TYPE: 'Beschäftigungsart',
    CP_200_JOB_POSTINGS_LOCATION: 'Standort',
    CP_200_JOB_STUDENT_LABEL: 'Studentenjob',
    CP_200_JOBS_EMPTY_TEXT:
      'Dieser Arbeitgeber hat gerade keine offenen Stellen bei XING ausgeschrieben ...<br>\naber schaue Dir gern unsere <a href="/jobs" alt="Job-Vorschläge">Job-Vorschläge</a> für Dich an.',
    CP_200_JOBS_LABEL: 'Stellenangebote',
    CP_200_JOBS_LOCATION_TITLE: 'Arbeitsort',
    CP_200_JOBS_PAGINATION_RESULTS_NUMBER:
      '{from} - {to} von {total} Ergebnissen',
    CP_200_JOBS_SECTION_LABEL: 'Aktuelle Jobs',
    CP_200_JOBS_TITLE: 'Position / Projekt',
    CP_200_LAST_MONTH: 'Letzter Monat',
    CP_200_LAST_TWITTER_UPDATE: 'am {date}',
    CP_200_LAST_TWITTER_UPDATE_A_DAY_AGO: 'Gestern',
    CP_200_LAST_TWITTER_UPDATE_ABOUT_AN_HOUR_AGO: 'Vor einer Stunde',
    CP_200_LAST_TWITTER_UPDATE_LESS_THAN_A_MINUTE: 'Gerade eben',
    CP_200_LAST_TWITTER_UPDATE_NEVER:
      'Zu diesem Nutzernamen liegen noch keine Updates vor.',
    CP_200_LAST_TWITTER_UPDATE_SOME_DAYS_AGO: 'Vor {days} Tagen',
    CP_200_LAST_TWITTER_UPDATE_SOME_HOURS_AGO: 'Vor {hours} Stunden',
    CP_200_LAST_TWITTER_UPDATE_SOME_MINUTES_AGO: 'Vor {minutes} Minuten',
    CP_200_LAST_WEEK: 'Letzte Woche',
    CP_200_LAST_YEAR: 'Letztes Jahr',
    CP_200_LINK: 'Link',
    CP_200_LOCAL_TIME_LABEL: 'Ortszeit',
    CP_200_LOGIN_TO_VIEW: 'Bitte logge Dich ein.',
    CP_200_LOGO_ALT_TEXT: 'Logo von {company_name}',
    CP_200_MAKE_FAVORITE: 'Merken',
    CP_200_MESSAGE: 'Nachricht',
    CP_200_MORE_FOLLOWERS_LINK: 'Weitere Follower',
    CP_200_MORE_VISITORS_LINK: 'Weitere Besucher',
    CP_200_NAME_COLHEADER: 'Name, Titel, Unternehmen',
    CP_200_NETWORKPATH_DIRECT_CONTACTS_LINK:
      '{number_of_contacts} Deiner Kontakte arbeiten hier.',
    CP_200_NETWORKPATH_HEADLINE:
      'Deine direkten Kontakte in diesem Unternehmen',
    CP_200_NEW_COMPANIES: 'Neue Unternehmen',
    CP_200_NEWS_LIST_HEADER: 'Unternehmens-Neuigkeiten {from}-{to} von {total}',
    CP_200_NEWS_UPDATE_VIA_TWITTER: 'via Twitter',
    CP_200_NEWS_UPDATE_VIA_TWITTER_LINK_TEXT: 'Tweet ansehen',
    CP_200_NO_ABOUT_TEXT: 'Die Seite wurde noch nicht angelegt.',
    CP_200_NO_DATA_INFO: 'keine Daten verfügbar',
    CP_200_NO_DESCRIPTION:
      'Es wurde noch keine Unternehmensbeschreibung hinterlegt.',
    CP_200_NO_HEADER_GRAPHIC: 'Kein Bild',
    CP_200_NO_LOGO: 'Kein Logo',
    CP_200_NO_NEWS_INFO: 'Es liegen noch keine Unternehmens-Neuigkeiten vor.',
    CP_200_NO_VISITORS:
      'Ihr Unternehmensprofil wurde in den letzten 30 Tagen nicht aufgerufen.',
    CP_200_NON_PUBLIC_PROFILE: 'Nur für XING-Mitglieder sichtbar',
    CP_200_NOTICE_ABOUT_TEXT_SAVED: 'Ihre Änderungen wurden übernommen.',
    CP_200_NOTICE_ALREADY_FOLLOWING:
      'Du folgst den Neuigkeiten dieses Unternehmens bereits. Sie werden Dir auf der Übersicht Deiner Startseite angezeigt.',
    CP_200_NOTICE_FOLLOW:
      'Du wurdest als Follower hinzugefügt. Neuigkeiten dieses Unternehmens werden Dir ab sofort auf der Startseite angezeigt.',
    CP_200_NOTICE_UNFOLLOW: 'Du folgst diesem Unternehmen nicht mehr.',
    CP_200_NOTIFICATIONS_TIME_AGO: 'Vor {time_ago}',
    CP_200_ONE_FOLLOWER_THIS_COMPANY: '{name} folgt diesem Unternehmen.',
    CP_200_OPTION_CONTACTS_OF_CONTACTS: 'Kontakte Deiner Kontakte',
    CP_200_OPTION_DIRECT_CONTACTS: 'Direkte Kontakte',
    CP_200_OPTION_NOT_CONTACTS: 'Nicht-Kontakte',
    CP_200_OPTIONS_COLHEADER: 'Optionen',
    CP_200_PHONE_LABEL: 'Telefon',
    CP_200_PRODUCT_OVERVIEW: 'Unternehmensprofile auf XING',
    CP_200_PROMOTE_CP_HEADLINE: 'Ihr Unternehmensprofil-Button',
    CP_200_PROMOTE_CP_HIDE_CODE_LINK: 'Quelltext ausblenden',
    CP_200_PROMOTE_CP_INSTRUCTIONS:
      'Der Button für Deine Website oder Deinen Blog: Wer auf ihn klickt, landet automatisch auf diesem Unternehmensprofil. Um ihn zu integrieren, musst Du lediglich den unten stehenden Quelltext in Deine Website einfügen.',
    CP_200_PROMOTE_CP_SHOW_CODE_LINK: 'Quelltext anzeigen',
    CP_200_QUICKINVITE_ADD_MESSAGE: 'Einladungstext hinzufügen',
    CP_200_QUICKINVITE_FIND_CONTACTS: 'Kontakte finden',
    CP_200_QUICKINVITE_HEADER: 'Kolleg·innen zu XING einladen',
    CP_200_QUICKINVITE_HEADER_2:
      'Kontakte aus Deinem E-Mail-Adressbuch einladen',
    CP_200_QUICKINVITE_INPUT_TITLE: 'E-Mail-Adressen bitte mit Kommas trennen',
    CP_200_QUICKINVITE_SEND: 'Einladung senden',
    CP_200_RATE_LINK: 'Arbeitgeber bewerten',
    CP_200_RATE_NPO_LINK: 'Organisation bewerten',
    CP_200_RECOMMEND_LINK: 'Unternehmen empfehlen',
    CP_200_RECOMMEND_LINK_ALT:
      'Mache Deine Kontakte auf dieses Unternehmen aufmerksam.',
    CP_200_RECOMMEND_NPO_LINK: 'Organisation empfehlen',
    CP_200_RECOMMEND_UPDATE_TOOLTIP: 'Teilen',
    CP_200_REMOVE_TWITTER_FEED_CONFIRM:
      'Bist Du sicher, dass Du alle Tweets dieses Zugangs aus den Unternehmens-Neuigkeiten löschen möchtest?',
    CP_200_REPORT_COMPANY_CONFIRM:
      'Herzlichen Dank für diese Meldung. Deine Nachricht ist bei uns eingegangen und wird baldmöglichst bearbeitet.',
    CP_200_REPORT_COMPANY_DESCRIPTION:
      'Du vermutest, dass die Angaben im Profil dieses Unternehmens nicht wahrheitsgemäß sind? Bitte gib hier möglichst detailliert Deine Gründe an. \n<br /><br />\nHinweis: Wir gehen allen begründeten Meldungen nach. Bitte habe Verständnis dafür, dass wir Dir zu dem aktuellen Status Deiner Meldung leider keine Rückmeldung geben können und Du keine Antwort-E-Mail auf Deinen Hinweis bekommst.',
    CP_200_REPORT_COMPANY_LINK: 'Als Spam melden',
    CP_200_REVENUE_LABEL: 'Erlöse',
    CP_200_RSS_FEED_INVALID: 'Dies ist leider kein gültiger RSS-Link.',
    CP_200_RSS_FEED_NOT_UNIQUE: 'Dieser RSS-Feed wurde bereits gespeichert.',
    CP_200_RSS_SERVICE_INFO:
      'Füge hier Deine RSS-Links ein. Alle neuen Beiträge werden dann innerhalb von 30 Minuten auf Deinem Unternehmensprofil automatisch als Neuigkeiten veröffentlicht.',
    CP_200_RSS_SUBHEADER: 'Aus Ihren Blogs & Websites per RSS',
    CP_200_SALES_CONSULTATION_BODY:
      'Als Kunde eines PLUS-Profils kannst Du bis zu 15 Tochterfirmen, Kunden, Dienstleister etc. auf Deinem Unternehmensprofil angeben.',
    CP_200_SALES_CONSULTATION_TITLE: 'Verbindung zu anderen Unternehmen',
    CP_200_SALES_PAGE_ALL_PRICES: 'Preisübersicht',
    CP_200_SALES_PAGE_ARGUMENT_ONE_HEADLINE:
      'Gestalte Deinen Ruf als Arbeitgeber aktiv mit.',
    CP_200_SALES_PAGE_ARGUMENT_ONE_POINT_A:
      'Nutze Bilder, Videos, Präsentationen etc., um Dein Unternehmen anschaulich darzustellen und um Interessenten umfassend zu informieren.',
    CP_200_SALES_PAGE_ARGUMENT_ONE_TEXT:
      'Was zeichnet Dich als Arbeitgeber aus? Moderne Büroräume? Flexible Arbeitszeiten? Kinderbetreuung? Zeige Deine Vorteile auf Deinem Employer Branding-Profil und präsentiere Dich so als Wunsch-Arbeitgeber!',
    CP_200_SALES_PAGE_ARGUMENT_THREE_HEADLINE:
      'Gewinne und halte gute Mitarbeitende.',
    CP_200_SALES_PAGE_ARGUMENT_THREE_POINT_A:
      'Mit einem guten Ruf als attraktiver Arbeitgeber und erhöhter Sichtbarkeit im Netz kannst Du Dauer und Kosten für die Rekrutierung passender Kandidaten senken.',
    CP_200_SALES_PAGE_ARGUMENT_THREE_POINT_B:
      'Auch Deine Stellenanzeigen werden noch präsenter: Wenn Du eine Stelle auf XING ausschreiben, erscheint diese automatisch auch auf Deinem Employer Branding-Profil.',
    CP_200_SALES_PAGE_ARGUMENT_THREE_TEXT:
      'Mit Deinem Employer Branding-Profil bekommst Du einen professionellen und glaubwürdigen Auftritt als attraktiver Arbeitgeber. Nutze diesen Wettbewerbsvorteil jetzt konsequent:',
    CP_200_SALES_PAGE_ARGUMENT_TWO_HEADLINE:
      'Steigere Deine Bekanntheit & Sichtbarkeit.',
    CP_200_SALES_PAGE_ARGUMENT_TWO_POINT_B:
      'Werbung inklusive: Wir blenden Ihr Unternehmen auf Seiten von Mitbewerbern ein, die noch kein Employer Branding-Profil eingerichtet haben. So erzielen Sie eine noch höhere Reichweite bei der Zielgruppe aus Ihrer Branche.',
    CP_200_SALES_PAGE_ARGUMENT_TWO_TEXT:
      'Die beste Werbung für Sie als Arbeitgeber ist die Empfehlung durch die eigenen Mitarbeiter. Gewinnen Sie Ihre Mitarbeiter deshalb als Botschafter! So nutzen Sie Ihr Employer Branding-Profil dafür:',
    CP_200_SALES_PAGE_CALL_TO_ACTION_HEADLINE:
      'Ergreifen Sie jetzt die Initiative.',
    CP_200_SALES_PAGE_CALL_TO_ACTION_PHONE: '&nbsp;',
    CP_200_SALES_PAGE_EXAMPLE_COMPANY_TEXT:
      'Beispielhaft: Diese Unternehmen sind schon dabei.',
    CP_200_SALES_PAGE_EXAMPLE_LINK_TEXT: '{company_name} bei:',
    CP_200_SALES_PAGE_FEATURE_DROPDOWN: 'Alle Vorteile auf einen Blick',
    CP_200_SALES_PAGE_FREE_BUBBLE: 'Gratis',
    CP_200_SALES_PAGE_FREE_HEADLINE: 'Für Minimalisten: Das Gratisprofil',
    CP_200_SALES_PAGE_FREE_LINK: 'Gratisprofil anlegen',
    CP_200_SALES_PAGE_FREE_TEXT:
      'Steht Ihnen derzeit kein Budget für Employer Branding zur Verfügung? Dann können Sie auf XING zunächst ein Gratisprofil anlegen, das einige der Grundfunktionen des Employer Branding-Profils bietet.',
    CP_200_SALES_PAGE_MAIN_BUTTON:
      'Informationen zum Employer Branding Profil anfordern',
    CP_200_SALES_PAGE_OVERALL_SUBLINE:
      'Top-Talente gewinnen &ndash; und langfristig binden',
    CP_200_SALES_PAGE_PRO_BUBBLE: 'Ab<br><strong>395</strong>€<br>/ Monat',
    CP_200_SALES_PAGE_SECUNDARY_BUTTON: 'Gratisprofil anlegen',
    CP_200_SELF_AFFILIATION: 'Sie können nicht das eigene Unternehmen angeben.',
    CP_200_SENDING_SALES_REQUEST_ADDRESS: 'PLZ & Ort des Firmensitzes',
    CP_200_SENDING_SALES_REQUEST_COMMENT: 'Ihre Nachricht',
    CP_200_SENDING_SALES_REQUEST_COMPANY_NAME: 'Name des Unternehmens',
    CP_200_SENDING_SALES_REQUEST_COMPANY_SIZE: 'Mitarbeitende',
    CP_200_SENDING_SALES_REQUEST_EMAIL: 'E-Mail',
    CP_200_SENDING_SALES_REQUEST_EMAIL_HINT: 'Ihre E-Mail-Adresse',
    CP_200_SENDING_SALES_REQUEST_FAMILY_NAME: 'Nachname',
    CP_200_SENDING_SALES_REQUEST_GENDER_ERROR:
      'Bitte wählen Sie eine Anrede aus.',
    CP_200_SENDING_SALES_REQUEST_MADAM: 'Frau',
    CP_200_SENDING_SALES_REQUEST_NAME: 'Vorname',
    CP_200_SENDING_SALES_REQUEST_PHONE: 'Rückrufnummer',
    CP_200_SENDING_SALES_REQUEST_PHONE_HINT: 'Ihre Telefonnr.',
    CP_200_SENDING_SALES_REQUEST_SEND: 'Anfrage senden',
    CP_200_SENDING_SALES_REQUEST_SIR: 'Herr',
    CP_200_SENDING_SALES_REQUEST_SUBLINE:
      'Bitte schilder uns Dein Anliegen so exakt wie möglich, damit wir Dir schnell und gezielt helfen können.',
    CP_200_SENDING_SALES_REQUEST_SUCCESS_HEADLINE:
      'Vielen Dank für Ihre Anfrage!',
    CP_200_SENDING_SALES_REQUEST_SUCESS_TEXT:
      'Wir melden uns innerhalb eines Werktages bei Dir.',
    CP_200_SENDING_SALES_REQUEST_TITLE: 'Anrede',
    CP_200_SHARE_NEWS_LABEL: 'Teilen',
    CP_200_SHOW_ABOUT_TEXT_HINT:
      'Ihre Seite "{about_page}" ist nicht freigeschaltet. Bitte klicken Sie auf "{publish}", um die Seite allen Mitgliedern zugänglich zu machen.',
    CP_200_SHOW_ABOUT_TEXT_LABEL: 'Die Seite ist freigeschaltet.',
    CP_200_SHOW_ALL_INDUSTRIES: 'Alle Branchen im Überblick',
    CP_200_SHOW_ALL_MOST_VISITED_COMPANIES: 'Weitere oft besuchte Unternehmen',
    CP_200_SHOW_ALL_MOST_VISITED_COMPANIES_NEW:
      'Weitere oft besuchte Arbeitgeber',
    CP_200_SHOW_ALL_RECENTLY_ADDED_COMPANIES: 'Weitere neue Unternehmen',
    CP_200_SHOW_ALL_RECENTLY_ADDED_COMPANIES_NEW: 'Weitere neue Arbeitgeber',
    CP_200_SHOW_ALL_RECOMMENDED_COMPANIES: 'Weitere interessante Unternehmen',
    CP_200_SHOW_ALL_RECOMMENDED_COMPANIES_NEW:
      'Weitere interessante Arbeitgeber',
    CP_200_SHOW_COMPANY_UPDATE_HINT:
      'Um das von Ihnen geschriebene Update für alle Mitglieder sichtbar zu schalten, klicken Sie {publish}.',
    CP_200_SHOW_GOOGLE_MAP: 'In Google Maps öffnen',
    CP_200_SHOW_LABEL: 'Anzeigen',
    CP_200_SHOW_USERS_FILTER: 'Ansicht:',
    CP_200_SIZE_LABEL: 'Unternehmensgröße',
    CP_200_STATISTICS_AGE_STRUCTURE_HIGH_RANGE: 'über {age} Jahre',
    CP_200_STATISTICS_AGE_STRUCTURE_LABEL_YEARS: 'Jahre',
    CP_200_STATISTICS_AGE_STRUCTURE_LABEL_YEARS_ABBR: 'J.',
    CP_200_STATISTICS_AGE_STRUCTURE_LOW_RANGE: 'unter {age} Jahren',
    CP_200_STATISTICS_AGE_STRUCTURE_MEDIUM_RANGE:
      'zwischen {from_age} und {to_age} Jahren',
    CP_200_STATISTICS_BEST_MONTH_TAG: 'Bestmarke',
    CP_200_STATISTICS_CAREER_LEVEL_ENTRY_LEVEL: 'Berufseinsteiger·in',
    CP_200_STATISTICS_CAREER_LEVEL_EXECUTIVE: 'Geschäftsführung',
    CP_200_STATISTICS_CAREER_LEVEL_MANAGER: 'Manager',
    CP_200_STATISTICS_CAREER_LEVEL_PROFESSIONAL: 'Mit Berufserfahrung',
    CP_200_STATISTICS_CAREER_LEVEL_SENIOR_EXECUTIVE: 'Geschäftsführer·in',
    CP_200_STATISTICS_CAREER_LEVEL_STUDENT: 'Student·in / Praktikant·in',
    CP_200_STATISTICS_CATEGORY_AGE_STRUCTURE: 'Altersstruktur',
    CP_200_STATISTICS_CATEGORY_CAREER_LEVEL: 'Karriere-Stufe',
    CP_200_STATISTICS_CATEGORY_EMPLOYEE_SINCE: 'Firmenzugehörigkeit',
    CP_200_STATISTICS_CATEGORY_LANGUAGE_SKILLS:
      'Sprachkenntnisse der Mitarbeitenden',
    CP_200_STATISTICS_EMPLOYEE_SINCE_LESS_THAN_A_YEAR: 'weniger als 1 Jahr',
    CP_200_STATISTICS_EMPLOYEE_SINCE_ONE_TO_THREE_YEARS: '1 bis 3 Jahre',
    CP_200_STATISTICS_EMPLOYEE_SINCE_OVER_FIVE_YEARS: 'länger als 5 Jahre',
    CP_200_STATISTICS_EMPLOYEE_SINCE_THREE_TO_FIVE_YEARS: '3 bis 5 Jahre',
    CP_200_STATISTICS_FOLLOWERS_TAB: 'Follower',
    CP_200_STATISTICS_LANGUAGES_OTHER: 'Andere Sprachen',
    CP_200_STATISTICS_LAST_MONTH_TAG: 'Letzter Monat',
    CP_200_STATISTICS_LAST_QUARTER_TAG: 'Letztes Quartal',
    CP_200_STATISTICS_LAST_WEEK_TAG: 'Letzte Woche',
    CP_200_STATISTICS_LAST_YEAR_TAG: 'Letztes Jahr',
    CP_200_STATISTICS_NO_INFO: 'Keine Information verfügbar',
    CP_200_STATISTICS_PAGE_HEADER:
      'Zahlen & Daten:<br>\nFür wen sind Sie als Arbeitgeber interessant?',
    CP_200_STATISTICS_PAGE_TITLE: '{company_name}: Statistiken',
    CP_200_STATISTICS_POPULARITY_CHANGE_INFO_MONTH: 'Im Vergleich zum Vormonat',
    CP_200_STATISTICS_POPULARITY_CHANGE_INFO_WEEK: 'Im Vergleich zur Vorwoche',
    CP_200_STATISTICS_POPULARITY_CHANGE_INFO_YEAR: 'Im Vergleich zum Vorjahr',
    CP_200_STATISTICS_POPULARITY_HEADER:
      'Besucherzahlen: Wie populär sind Sie bei Kandidaten?',
    CP_200_STATISTICS_POPULARITY_HEADER_INFO_HTML:
      '<p>Bei den Besucherzahlen Ihres Unternehmensprofils werden Mehrfach-Besuche von ein und derselben Person innerhalb einer Stunde nicht mitgezählt.</p>\n<p>Die Daten für Besucherzahlen wurden seit August 2011 erhoben.</p>\n<p>Bei der Anzahl der Follower werden nur Follower gezählt, die neu hinzugekommen und nicht bei Ihrem Unternehmen beschäftigt sind.</p>',
    CP_200_STATISTICS_PROFILE_HEADER:
      'Profilanalyse: Wer sind Ihre Besucher & Follower?',
    CP_200_STATISTICS_PROFILE_HEADER_INFO_HTML:
      'Berücksichtigt werden Besucher und neu hinzugekommenen Follower der letzten 30 Tage, letztere abzüglich der im Unternehmen beschäftigten Mitarbeiter.',
    CP_200_STATISTICS_SUBTAB_DAY: 'Tag',
    CP_200_STATISTICS_SUBTAB_MONTH: 'Monat',
    CP_200_STATISTICS_SUBTAB_QUARTER: 'Quartal',
    CP_200_STATISTICS_SUBTAB_WEEK: 'Woche',
    CP_200_STATISTICS_SUBTAB_YEAR: 'Jahr',
    CP_200_STATISTICS_THIS_MONTH_TAG: 'Dieser Monat',
    CP_200_STATISTICS_THIS_QUARTER_TAG: 'Dieses Quartal',
    CP_200_STATISTICS_THIS_WEEK_TAG: 'Diese Woche',
    CP_200_STATISTICS_THIS_YEAR_TAG: 'Dieses Jahr',
    CP_200_STATISTICS_TODAY_TAG: 'Heute',
    CP_200_STATISTICS_TRAFFIC_BESTOFFERS: 'Vorteilsangebote',
    CP_200_STATISTICS_TRAFFIC_BROWSE: 'Browse',
    CP_200_STATISTICS_TRAFFIC_COMPANIES: 'Unternehmen',
    CP_200_STATISTICS_TRAFFIC_EVENTS: 'Events',
    CP_200_STATISTICS_TRAFFIC_GROUPS: 'Gruppen',
    CP_200_STATISTICS_TRAFFIC_HEADER:
      'Traffic-Analyse: Wo werden Besucher auf Sie aufmerksam?',
    CP_200_STATISTICS_TRAFFIC_HEADER_INFO_HTML:
      '<p>Die Traffic-Analyse zeigt, woher die Besucher Ihres Unternehmensprofils gekommen sind (letzte 30 Tage) &ndash; und mehr:</p>\n\n<p><strong>Suchmaschinen:</strong> Mit welchen Suchbegriffen wurde Ihr Unternehmensprofil auf Google, Bing, Yahoo! etc. gefunden?</p>\n\n<p><strong>XING:</strong> Auf welchen XING-Bereichen sind Besucher auf Ihr Unternehmen aufmerksam geworden?</p>\n\n<p><strong>Website-Links:</strong> Von welchen Websites, die Ihr Unternehmensprofil verlinkt haben, kommen die meisten Besucher?</p>\n\n<p><strong>Soziale Netzwerke:</strong> Wie hoch ist der Rücklauf von Facebook, Twitter etc.?</p>',
    CP_200_STATISTICS_TRAFFIC_JOBS: 'Jobs & Karriere',
    CP_200_STATISTICS_TRAFFIC_PROFILE: 'Mitgliederprofile',
    CP_200_STATISTICS_TRAFFIC_RECOMMENDATIONS: 'Empfohlene Unternehmen',
    CP_200_STATISTICS_TRAFFIC_SEARCH: 'Suche',
    CP_200_STATISTICS_TRAFFIC_STARTPAGE: 'Startseite',
    CP_200_STATISTICS_VISITORS_TAB: 'Besucher',
    CP_200_STATISTICS_VOLUNTEERS_TAB: 'Freiwillige',
    CP_200_STATISTICS_YESTERDAY_TAG: 'Gestern',
    CP_200_STATS_ENTIRE_OVERVIEW: 'Zur Gesamtstatistik',
    CP_200_STATS_MONTHLY_FOLLOWERS: 'Neue Follower diesen Monat:',
    CP_200_STATS_MONTHLY_VISITORS: 'Besucher diesen Monat:',
    CP_200_STATS_PAGE_HEADLINE: 'Statistik für diese Seite',
    CP_200_SUBNAV_ABOUT_US_LINK: 'Über uns',
    CP_200_TAB_ABOUT: 'Über uns',
    CP_200_TAB_ABOUT_LINK: 'Über uns',
    CP_200_TAB_COMPANY_REVIEWS: 'Bewertungen',
    CP_200_TAB_COMPANY_UPDATES: 'Neuigkeiten',
    CP_200_TAB_COMPANY_UPDATES_LINK:
      'Unternehmens-Neuigkeiten ({number_of_articles})',
    CP_200_TAB_CONTACT_US_LINK: 'Kontakt',
    CP_200_TAB_CORPORATION_DETAILS_LINK: 'Überblick',
    CP_200_TAB_EMPLOYEES_LINK: 'Mitarbeitende ({number_of_employees})',
    CP_200_TAB_FOLLOWERS: 'Follower',
    CP_200_TAB_FOLLOWERS_LINK: 'Follower ({number_of_followers})',
    CP_200_TAB_JOBS_LINK: 'Jobs',
    CP_200_TAB_JOBS_LINK_WITH_COUNTER: 'Stellenangebote ({number_of_jobs})',
    CP_200_TAB_OVERVIEW_LINK: 'Übersicht',
    CP_200_TAB_PRODUCTS_AND_SERVICES: 'Produkte und Services',
    CP_200_TAB_VISITORS:
      'Besucher Ihres Unternehmensprofils in den letzten 30 Tagen',
    CP_200_TEASER_ABOUT_COMPANY_PAGES_1:
      '<h4>Über Unternehmensprofile</h4>\n<p>Entdecke  Unternehmen auf XING!<br /><br />\nJetzt kannst Du schnell und einfach nach Unternehmen suchen, Statistiken der \nMitarbeiter einsehen und die passende Ansprechperson finden.<br /><br />\nDie angezeigten Informationen stellen eine automatisch generierte Schätzung dar, \nbasierend auf den freiwilligen Angaben der Mitglieder. Die Daten wurden \nnicht von dem entsprechenden Unternehmen bereitgestellt. Daher  \nenthält die Schätzung keine Informationen von Mitarbeitern, die nicht bei XING \nregistriert sind.<br />\nXING Unternehmensprofile werden kontinuierlich weiterentwickelt - basierend \nauf Deinen Ideen und Deinem Feedback.<br /><br />\n<a href="/help/hilfe-und-faq-2/die-funktionen-von-xing-53/unternehmensprofile-420">Fragen und Antworten zu Unternehmensprofilen</a>\n</p>',
    CP_200_TEASER_ABOUT_COMPANY_PAGES_2:
      '<p>XING Unternehmensprofile werden kontinuierlich \nweiterentwickelt - basierend auf Ihren Ideen und \nIhrem Feedback.<br /><br />\n<a href="/app/help?op=explanations;category_id=411">Fragen und Antworten zu XING \nUnternehmensprofilen</a></p>',
    CP_200_TEASER_ABOUT_COMPANY_PAGES_SHOW_ALL_LINK_TITLE:
      'Klick hier, um mehr über Unternehmensprofile zu erfahren.',
    CP_200_TEASER_CUSTOMER_FEEDBACK: 'alttext ',
    CP_200_TEXTUPDATE_NOT_POSSIBLE:
      'Es ist ein Fehler aufgetreten: Ihr Unternehmensprofil kann derzeit nicht editiert werden, da die Laufzeit zur Nutzung Ihres Firmenprofils abgelaufen ist. Bitte wenden Sie sich für Rückfragen an unseren <a href="/app/help?\ncategories=4&op=start&subject=44&tab=contact" \ntitle="Kundenservice">Kundenservice</a>.',
    CP_200_THIS_MONTH: 'Dieser Monat',
    CP_200_THIS_WEEK: 'Diese Woche',
    CP_200_THIS_YEAR: 'Dieses Jahr',
    CP_200_TITLE_COLHEADER: 'Titel',
    CP_200_TWITTER_FEED: 'Letztes Update: {last_update}',
    CP_200_TWITTER_SERVICE_INFO:
      'Wir überprüfen Ihre Twitter-Benutzerkonten alle 30 Minuten nach neuen Tweets und veröffentlichen diese dann hier automatisch als Neuigkeiten. Beim ersten Import kann es allerdings ein wenig länger dauern.',
    CP_200_TWITTER_SUBHEADER: 'Aus Ihren Twitter-Zugängen',
    CP_200_TWITTER_VALIDATION_ERROR:
      'Ein wirklich schöner Name, aber ... für Twitter-Namen sind leider nur Buchstaben, Ziffern und Unterstriche erlaubt.',
    CP_200_TYPE_LABEL: 'Organisationstyp',
    CP_200_UNFOLLOW_LINK: 'Nicht mehr folgen',
    CP_200_UNFOLLOW_LINK_ALT: 'Nicht mehr folgen',
    CP_200_UNFOLLOW_LINK_SHORT: 'Nicht mehr folgen',
    CP_200_UNKNOWN_AGE: 'Alter unbekannt',
    CP_200_UPLOAD_HEADER_GRAPHIC_LINK: 'Header-Grafik hochladen',
    CP_200_UPLOAD_LOGO: 'Unternehmenslogo hochladen',
    CP_200_USER_VIEW_TEXT_LIGHTBOX:
      'So sehen andere Dein Profil. Um es zu bearbeiten, wechsel bitte zur Editor-Ansicht.',
    CP_200_USER_VIEW_TITLE_LIGHTBOX:
      'So sehen Besucher das Unternehmensprofil.',
    CP_200_VALIDATION_ERROR_KEYWORD_LIMIT_EXCEEDED:
      'Bitte gib maximal %d Stichwörter ein.',
    CP_200_VISITORS_TO_YOUR_COMPANY: 'Besucher',
    CP_200_VOUCHER_HEADLINE: 'XING Premium-Gutscheine',
    CP_200_VOUCHER_TEXT:
      'Zum Jubiläum, als Incentive oder kleines Dankeschön. Die XING Premium-Mitgliedschaft jetzt als <a href="http://voucher.xing.com/?dpt=mcmhh&ttp=teaser&plf=own&pid=cpts&xtr=36" >Gutschein verschenken</a>.',
    CP_200_WARNING_STATISTICS_NOT_ENABLED:
      'Statistikfunktionen bekommst Du mit dem Employer Branding-Profil. Wende Dich gerne an <a href="mailto:employer-brandig@xing.com">employer-branding@xing.com</a>.',
    CP_200_WARNING_UNFOLLOW_UNCLAIMED:
      'Bitte beachte: Du bekommst keine Neuigkeiten mehr von diesem Unternehmen.<br /> \nZurzeit werden keine Neuigkeiten von diesem Unternehmen eingestellt.',
    CP_202_SHOW_EVENTS_FILTER: 'Anzeigen:',
    CP_204_LIKE_LIGHTBOX_HEADLINE: 'Diesen Mitgliedern gefällt das Update:',
    CP_204_LIKE_LINK_ALT:
      'Markier dieses Update mit "Gefällt mir" und lass es auch Dein Netzwerk wissen.',
    CP_204_LIKE_LINK_TEXT: 'Gefällt mir',
    CP_204_LIKE_TOOLTIP: '{number} Mitglied gefällt dieses Update.',
    CP_204_LIKE_TOOLTIP_PLURAL: '{number} Mitgliedern gefällt dieses Update.',
    CP_204_UNLIKE_LINK_ALT:
      'Du hast dieses Update mit "Gefällt mir" markiert und kannst Deine Entscheidung hier zurücknehmen.',
    CP_204_UNLIKE_LINK_TEXT: 'Gefällt mir nicht mehr',
    CP_205_EMPLOYEES_LINK_PLURAL: 'Mitarbeitende',
    CP_205_FOLLOWERS_LINK: 'Follower',
    CP_205_FOLLOWERS_LINK_PLURAL: 'Follower',
    CP_205_UPDATES_LINK: 'Update',
    CP_205_UPDATES_LINK_PLURAL: 'Updates',
    CP_300_ABOUT_CP_BASIC_DESCRIPTION:
      'XING erstellt Unternehmensprofile automatisch anhand der XING Mitgliederprofile von Mitarbeitern. Das eigene Unternehmensprofil kann von der jeweiligen Firma kostenlos bearbeitet, ergänzt und dadurch zu einem BASIS-Profil aufgewertet werden. Diese Unternehmensprofile bieten Dir:\n<ul class="bullet-list">\n<li>einen Überblick über wichtige Unternehmensdaten, z. B. Unternehmensgröße oder Mitarbeiterstatistiken</li>\n<li>alle Mitarbeiter auf einen Blick &ndash; per Klick können diese kontaktiert werden</li>\n<li>eine Übersicht über offene Stellen des Unternehmens auf XING Jobs</li>\n</ul>',
    CP_300_ABOUT_CP_BASIC_H2:
      'Automatisch erstellte und BASIS-Unternehmensprofile',
    CP_300_ABOUT_CP_H1: 'Entdecke Unternehmen auf XING',
    CP_300_ABOUT_CP_INFOBOX_H3:
      'Verbinde Dich mit Unternehmen und bleibe auf dem Laufenden',
    CP_300_ABOUT_CP_INTRO:
      'Über Unternehmensprofile findest Du schnell die richtige Ansprechperson und für Dich relevante Informationen auf einen Blick: Kontaktpersonen, Unternehmens-Neuigkeiten und -statistiken. Vernetze Dich mit Firmen und bleibe automatisch auf dem Laufenden!',
    CP_300_ABOUT_CP_LINK_TO_PDF:
      'Weitere Informationen zu Unternehmensprofilen',
    CP_300_ABOUT_CP_LINK_TO_VIDEO: 'Video ansehen',
    CP_300_ABOUT_CP_PLUS_DESCRIPTION:
      'Unternehmen aktualisieren Ihre Unternehmensprofile PLUS und informieren Mitglieder über  Unternehmens-Neuigkeiten. Ihre Vorteile: \n<ul class="bullet-list">\n<li>Sie können Unternehmens-Neuigkeiten für Ihre XING Startseite abonnieren &ndash; z. B. von Ihrem Dienstleister oder Unternehmen aus Ihrer Branche</li>\n<li>Sie können sich mit interessanten Unternehmen oder Ihren Wunsch-Arbeitgebern verbinden</li>\n<li>Sie profitieren von Sonderaktionen, Produktneuheiten, Karriere-Events oder Unternehmens-News</li>\n</ul>',
    CP_300_ABOUT_CP_PLUS_H2: 'Unternehmensprofil PLUS',
    CP_300_ABOUT_CP_STANDARD_DESCRIPTION:
      'Unternehmen pflegen Ihre Unternehmensprofile STANDARD regelmäßig. Auf diesen Profilen können Sie: \n<ul class="bullet-list">\n<li>sich ausführlich über ein Unternehmen informieren, z. B. über Produkte, Dienstleistungen oder die Firmenkultur</li>\n<li>direkt die richtige Ansprechperson für Ihr Business finden</li>\n<li>Ihre direkten Verbindungspfade zu einem Unternehmen sehen</li>\n</ul>',
    CP_300_ABOUT_CP_STANDARD_H2: 'Unternehmensprofil STANDARD',
    CP_300_ABOUT_CP_TEASER_HEADING: 'Unternehmen auf XING',
    CP_300_ABOUT_CP_TEASER_LINK: 'Zu Unternehmensprofilen',
    CP_300_ABOUT_CP_TEASER_NO_CP_HEADING: 'Das Profil für Ihr Business',
    CP_300_ABOUT_CP_TEASER_NO_CP_LINK: 'Jetzt Unternehmensprofil anlegen',
    CP_300_ABOUT_CP_TEASER_NO_CP_TEXT:
      'Sie haben noch kein Unternehmensprofil? Kein Problem! Erstellen Sie jetzt <strong>kostenlos</strong> Ihr Unternehmensprofil auf XING und setzen Sie Ihre Referenzen und Angebote professionell in Szene.  <a href="/companies/contract/select_package">Mehr Informationen</a>',
    CP_300_ABOUT_CP_TEASER_PAID_CP_HEADING: 'Ihr Unternehmen auf XING',
    CP_300_ABOUT_CP_TEASER_PAID_CP_LINK: 'Zu Ihrem Unternehmensprofil',
    CP_300_ABOUT_CP_TEASER_PAID_CP_TEXT:
      'Ihr Unternehmen ist bereits mit einem Unternehmensprofil auf XING vertreten.',
    CP_300_ABOUT_CP_TEASER_TEXT:
      'Sie suchen einen Geschäftspartner oder Dienstleister? \nBrauchen Sie Informationen zu einem bestimmten \nUnternehmen?',
    CP_300_ABOUT_CP_TEASER_UNBOUGHT_CP_HEADING:
      'Setzen Sie Ihr Unternehmen professionell in Szene!',
    CP_300_ABOUT_CP_TEASER_UNBOUGHT_CP_LINK: 'Mehr Informationen anzeigen',
    CP_300_ABOUT_CP_TEASER_UNBOUGHT_CP_TEXT:
      'Gestalten Sie Ihr Unternehmensprofil individuell - als Marketing- und Vertriebskanal oder zur Darstellung als attraktiver Arbeitgeber und kommunizieren Sie mit Interessenten, Kunden, Alumni und Bewerbern.',
    CP_300_BUTTON_SUBMIT_FILE: 'Datei hochladen',
    CP_300_CALLOUT_BASIC_BODY:
      'Sie können bis zu 30 Module nutzen, wenn Sie das Employer Branding-Profil buchen. Melden Sie sich dazu gern bei uns unter <a href="mailto:employer-branding@xing.com">employer-branding@xing.com</a>.',
    CP_300_CALLOUT_BASIC_HEADER:
      'Sie verwenden jetzt alle 2 verfügbaren Module für Ihre Bilder und PDFs.',
    CP_300_CALLOUT_EMPLOYER_BRANDING_BODY:
      '<strong>Tipp:</strong> Sie können die Inhalte in diesen Modulen jederzeit aktualisieren bzw. durch neue Inhalte ersetzen.',
    CP_300_CALLOUT_EMPLOYER_BRANDING_HEADER:
      'Sie verwenden jetzt alle 30 verfügbaren Module für Ihre Bilder, PDFs, Videos und Präsentationen.',
    CP_300_CALLOUT_IMPORT_FEEDS:
      '<span class="new-sign bold">NEU</span> Importieren Sie automatisch Neuigkeiten aus Ihren Blogs!',
    CP_300_CALLOUT_PLUS_BODY:
      'Tipp: Sie können die Inhalte in diesen Modulen jederzeit aktualisieren bzw. durch neue Inhalte ersetzen.',
    CP_300_CALLOUT_PLUS_HEADER:
      'Sie verwenden jetzt alle 30 verfügbaren Module für Ihre Bilder, PDFs, Videos und Präsentationen.',
    CP_300_CALLOUT_PRO_BODY:
      '<strong>Tipp:</strong> Sie können die Inhalte in diesen Modulen jederzeit aktualisieren bzw. durch neue Inhalte ersetzen.',
    CP_300_CALLOUT_PRO_HEADER:
      'Sie verwenden jetzt alle 30 verfügbaren Module für Ihre Bilder, PDFs, Videos und Präsentationen.',
    CP_300_CALLOUT_STANDARD_BODY:
      'Sie können bis zu 30 Module nutzen und hier auch Videos einbinden, wenn Sie das Employer Branding-Profil buchen. Melden Sie sich dazu gern bei uns unter <a href="mailto:employer-branding@xing.com">employer-branding@xing.com</a>.',
    CP_300_CALLOUT_STANDARD_HEADER:
      'Sie verwenden jetzt alle 10 verfügbaren Module für Ihre Bilder und PDFs.',
    CP_300_COMPANIES_EXIST:
      'Für die auf Deinem Profil eingetragenen Arbeitgeber gibt es bereits Unternehmensprofile. Bitte passe ggf. Deinen Arbeitgeber an oder ändere den Namen des Unternehmens auf <a href="{profile_url}">Deinem Profil</a>.',
    CP_300_CONTACT_PERSON_HR_CHECKBOX:
      'Als Ansprechperson im Jobs-Tab anzeigen',
    CP_300_CONTACT_PERSON_PLACEHOLDER_DESCRIPTION:
      'Sprechen Sie mich gern an, wenn Sie Interesse an einer unserer offenen Stellen haben.',
    CP_300_CONTACT_PERSON_PLACEHOLDER_FIRST_NAME: 'Martina',
    CP_300_CONTACT_PERSON_PLACEHOLDER_LAST_NAME: 'Mustermann',
    CP_300_CONTACT_PERSON_PLACEHOLDER_TITLE: 'Personalreferentin',
    CP_300_CONTACTS_HR_INFO:
      'Du kannst zusätzliche Ansprechpersonen für den Jobs-Tab markieren. Alle Ansprechpersonen werden im Mitarbeiter-Tab angezeigt.',
    CP_300_CONTACTS_PLACEHOLDER_TEXT:
      'Fügen Sie hier die Ansprechperson des Unternehmens hinzu. Sie können diese dann optional auch im Jobs-Tab anzeigen.',
    CP_300_CREATE_MINIMAL_VERSION_BUTTON: 'Jetzt Unternehmensprofil anfordern',
    CP_300_CREATE_MINIMAL_VERSION_H2:
      'Welche Vorteile bietet Ihnen ein Unternehmensprofil?',
    CP_300_CREATE_MINIMAL_VERSION_HEADLINE:
      'Für "{company_name}" liegt kein Unternehmensprofil vor',
    CP_300_CREATE_MINIMAL_VERSION_INFO_1_HEADING:
      'Überprüfen Sie die Schreibweise Ihres Unternehmensnamens.',
    CP_300_CREATE_MINIMAL_VERSION_INFO_1_TEXT:
      'Möglicherweise existiert für Ihr Unternehmen bereits ein Unternehmensprofil mit ähnlicher Schreibweise (z. B. „Mustermann AG“ statt „Mustermann“). Überprüfen Sie, ob bereits ein Unternehmensprofil existiert, indem Sie die <a href="/companies">Unternehmenssuche</a> durchführen. Passen Sie dann ggf. die Schreibweise des Unternehmensnamens in Ihrem <a href="{userprofile}">Mitglieder-Profil</a> an oder bitten Sie Ihre Kollegen, dies zu tun.',
    CP_300_CREATE_MINIMAL_VERSION_INFO_2_HEADING:
      'Laden Sie Ihre Kolleg·innen zu XING ein',
    CP_300_CREATE_MINIMAL_VERSION_INFO_2_TEXT:
      'Sobald 5 XING-Mitgliederprofile mit identischer Schreibweise des Unternehmensnamens vorliegen, wird automatisch ein Unternehmensprofil angelegt. <a href="/app/invite">Jetzt Kollegen einladen</a>',
    CP_300_CREATE_MINIMAL_VERSION_INFO_3_HEADING:
      'Fordern Sie ein Unternehmensprofil an',
    CP_300_CREATE_MINIMAL_VERSION_INFO_3_LIST_ITEM_1:
      'Mindestens zwei XING-Mitglieder müssen eine identische Firmenschreibweise im Profil haben, um \nein Unternehmensprofil beantragen zu können.',
    CP_300_CREATE_MINIMAL_VERSION_INFO_3_LIST_ITEM_2:
      'Automatisch erstellte Unternehmensprofile sind nicht editierbar. Um Ihr Unternehmensprofil individuell zu gestalten, können Sie nach der Erstellung ein Upgrade auswählen.',
    CP_300_CREATE_MINIMAL_VERSION_INFO_3_TEXT:
      'Haben die ersten beiden Maßnahmen nicht zum Erfolg geführt, können Sie hier Ihr Unternehmensprofil beantragen. Bitte beachten Sie dabei:',
    CP_300_CREATE_MINIMAL_VERSION_LIST_ITEM_1:
      'Sie haben eine Unternehmenspräsenz auf XING',
    CP_300_CREATE_MINIMAL_VERSION_LIST_ITEM_2:
      'Mit aktueller Liste Ihrer Mitarbeitenden, sodass Interessierte direkt die richtige Ansprechperson finden',
    CP_300_CREATE_MINIMAL_VERSION_TEXT:
      '<p>Für den Firmennamen "{company_name}", den Du in Deinem Profil eingetragen hast, ist bisher kein Unternehmensprofil  hinterlegt. Unternehmensprofile werden automatisch erstellt, sobald  5 XING-Mitgliederprofile mit identischer Schreibweise des Firmennamens vorliegen. </p>',
    CP_300_DELETE_CONFIRMATION: 'Wirklich löschen?',
    CP_300_DELETE_ERROR:
      'Das hat leider nicht geklappt. Bitte versuch es noch einmal.',
    CP_300_EDIT_COMPANY_PROMPT:
      'Sie können den Namen Ihres Unternehmens in <a href="{profile_url}">Ihrem Profil</a> ändern. Als Freiberufler können Sie hier Ihren Namen und Ihr Service-Angebot eintragen, z. B. "Max Mustermann - Web Design".',
    CP_300_ERROR_EMPTY_URL:
      'Bitte fügen Sie noch den Link für das Video / die Präsentation ein.',
    CP_300_ERROR_INVALID_URL:
      'Dieser Link ist leider ungültig ... vielleicht ein Tippfehler?',
    CP_300_ERROR_SOMETHING_WENT_WRONG:
      'Da ist leider etwas schiefgelaufen. Probieren Sie es bitte später nochmal.',
    CP_300_FILE_DESCRIPTION_LABEL:
      'Geben Sie optional eine Beschreibung des Bildes / PDFs ein (max. 200 Zeichen).',
    CP_300_GALLERY_ADD_ITEM_INFO:
      'Machen Sie Ihr Unternehmensprofil noch ansprechender!',
    CP_300_JOBS_PLACEHOLDER_CITY: 'Hamburg',
    CP_300_JOBS_PLACEHOLDER_COMPANY: 'Surface* Media',
    CP_300_JOBS_PLACEHOLDER_TEXT: 'Auf Personalsuche? Dann suchen Sie hier:',
    CP_300_JOBS_PLACEHOLDER_TITLE_1: 'Auszubildende im Personalwesen',
    CP_300_JOBS_PLACEHOLDER_TITLE_2: 'Marketing-Manager',
    CP_300_NOTICE_CREATE_MINIMAL_VERSION:
      'Das Unternehmensprofil wurde erfolgreich vorgemerkt und wird, sobald 2 XING-Mitgliederprofile zu diesem Unternehmen vorliegen, innerhalb von 24 Stunden zur Verfügung gestellt.',
    CP_300_PENDING_FUNCTION_NOT_AVAILABLE:
      'Diese Funktion ist nach Freischaltung Ihres Unternehmensprofils verfügbar.',
    CP_300_REMOTE_DESCRIPTION_LABEL:
      'Geben Sie optional eine Beschreibung ein (max. 200 Zeichen).',
    CP_300_SALES_PAGE_FEATURE_1:
      'Ausführliche Arbeitgeber-Infos mit Unternehmenslogo',
    CP_300_SALES_PAGE_FEATURE_10: 'Reporting- und Statistikfunktionen',
    CP_300_SALES_PAGE_FEATURE_11:
      'Automatische Liste Ihrer Mitarbeitenden auf XING',
    CP_300_SALES_PAGE_FEATURE_13:
      'Veröffentlichung von Neuigkeiten des Unternehmens',
    CP_300_SALES_PAGE_FEATURE_14:
      'Frei definierbare Schlagwörter für bessere Auffindbarkeit auf XING',
    CP_300_SALES_PAGE_FEATURE_15:
      'Eine Ansprechperson für beide Plattformen (inkl. Datenpflege-Service, Reporting, Beratung etc.)',
    CP_300_SALES_PAGE_FEATURE_2:
      'Authentische Arbeitgeberbewertungen und -leistungen',
    CP_300_SALES_PAGE_FEATURE_3:
      'Einbindung von Videos, Bildern, Präsentationen etc.',
    CP_300_SALES_PAGE_FEATURE_4: 'Ansprechpersonen und Infos für Bewerber',
    CP_300_SALES_PAGE_FEATURE_5:
      'Werbung für Ihr Unternehmen auf Mitbewerber-Profilen (Branchen-Targeting)',
    CP_300_SALES_PAGE_FEATURE_7: 'Einbindung Arbeitgeber-Gütesiegel',
    CP_300_SALES_PAGE_FEATURE_8:
      'Einblendung von gebuchten Stellenanzeigen auf dem eigenen Employer Branding-Profil',
    CP_300_SALES_PAGE_FEATURE_9:
      'Darstellung von Töchtern und Partnern des Unternehmens auf XING',
    CP_300_SALES_PAGE_FEATURE_FREE: 'Gratisprofil',
    CP_300_SALES_PAGE_FEATURE_FREE_1:
      'Kostenlose Präsenz als Arbeitgeber auf XING',
    CP_300_SALES_PAGE_FEATURE_FREE_2: '"Über uns"-Seite und eigenes Logo',
    CP_300_SALES_PAGE_FEATURE_FREE_3:
      'Anzeige Ihrer aktuellen XING-Stellenangebote',
    CP_300_SALES_PAGE_FEATURE_FREE_4:
      'Automatische Liste Ihrer Mitarbeitenden auf XING',
    CP_300_SALES_PAGE_FEATURE_FREE_5: 'Unternehmens-Neuigkeiten schreiben',
    CP_300_SALES_PAGE_FEATURE_FUNCTIONS: 'Die Vorteile im Überblick',
    CP_300_SALES_PAGE_FEATURE_PROFILE: 'Employer Branding-Profil',
    CP_300_SALES_PAGE_PRICES_EMPLOYEES_HEADLINE: 'Unternehmensgröße',
    CP_300_SALES_PAGE_PRICES_NUMBER_1: '1 - 199',
    CP_300_SALES_PAGE_PRICES_NUMBER_2: '200 - 499',
    CP_300_SALES_PAGE_PRICES_NUMBER_3: '500 - 999',
    CP_300_SALES_PAGE_PRICES_NUMBER_4: '1.000 - 4.999',
    CP_300_SALES_PAGE_PRICES_NUMBER_5: '> 5.000',
    CP_300_SALES_PAGE_PRICES_PRICE_1: '395 €',
    CP_300_SALES_PAGE_PRICES_PRICE_2: '495 €',
    CP_300_SALES_PAGE_PRICES_PRICE_3: '695 €',
    CP_300_SALES_PAGE_PRICES_PRICE_4: '895 €',
    CP_300_SALES_PAGE_PRICES_PRICE_5: '1.095 €',
    CP_300_SALES_PAGE_PRICES_TABLE: 'Preis pro Monat',
    CP_300_SALES_VANITY_URL:
      'Individueller Link (z.B. "www.xing.com/company/ihr-unternehmen")',
    CP_300_SETTINGS_CHANGE_EDITOR: 'Editor ändern',
    CP_300_SETTINGS_CONTACT_CHOOSER_INTRO_INFO:
      'Geben Sie hier einen Namen ein.',
    CP_300_SETTINGS_CONTACT_CHOOSER_NOT_FOUND:
      'Wir haben keine Mitarbeitenden mit diesem Namen gefunden &ndash; vielleicht vertippt?',
    CP_300_SETTINGS_EDITOR_HEADING: 'Editorenverwaltung',
    CP_300_SETTINGS_EDITOR_INFO:
      'Für Ihr BASIS-Unternehmensprofil können Sie nur einen Editor eintragen.',
    CP_300_SETTINGS_EDITOR_PROMPT_HEADING:
      'Möchten Sie den Editor wirklich ändern?',
    CP_300_SETTINGS_EDITOR_PROMPT_TEXT:
      '<strong>Wichtig</strong>: Wenn Sie den Haupt-Editor jetzt neu zuweisen, können Sie dies nicht mehr rückgängig machen, weil Sie die entsprechenden Rechte damit abgegeben haben.',
    CP_300_SETTINGS_EDITOR_SIDEINFO:
      '<strong>Wichtig</strong>: Wenn Sie den Haupt-Editor jetzt neu zuweisen, können Sie dies nicht mehr rückgängig machen, weil Sie die entsprechenden Rechte damit abgegeben haben.',
    CP_300_SETTINGS_ERROR_PERMITTED:
      'Erlaubt sind Kleinbuchstaben, Ziffern und Bindestriche.',
    CP_300_SETTINGS_ERROR_UNIQUE:
      'Diese URL ist leider bereits vergeben. Versuchen Sie es mit einer anderen.',
    CP_300_SETTINGS_GENERAL_HEADER: 'Allgemeine Einstellungen',
    CP_300_SETTINGS_LEGAL:
      '<strong>Wichtig:</strong> Mit der Änderung Ihres Links stimmen Sie <a href="{link}">unseren AGB</a> zu und versichern insbesondere, dass Sie Ihren eigenen Firmennamen verwenden und keine Markenrechte anderer verletzen.',
    CP_300_SETTINGS_PAGE_HEADER: 'Einstellungen für Ihr Unternehmensprofil',
    CP_300_SETTINGS_PERMITTED_INFO:
      'Sie können Kleinbuchstaben (ohne Umlaute), Ziffern und Bindestriche verwenden.',
    CP_300_SETTINGS_URL_CALLOUT:
      '<strong>Tipp:</strong> Ab sofort können Sie den Link zu Ihrem Unternehmensprofil ändern!',
    CP_300_SETTINGS_URL_CHANGE:
      'Um den Link zu Ihrem Unternehmensprofil erneut zu ändern, wenden Sie sich bitte per E-Mail an <a href="mailto:unternehmensprofile@xing.com">unternehmensprofile@xing.com</a>.',
    CP_300_SETTINGS_URL_CONFIRM_HEADER: 'Bitte überprüfen Sie Ihre Eingabe.',
    CP_300_SETTINGS_URL_CONFIRM_TEXT:
      '<p>Sobald Sie auf &quot;Speichern&quot; klicken, wird Ihr Link auf XING wie folgt lauten:</p>\n\n<p><strong>{new_url}</strong></p>\n\n<p>Bitte stellen Sie daher sicher, dass es keine Tippfehler etc. gibt.</p>',
    CP_300_SETTINGS_URL_CURRENT:
      'Dies ist der Link zu Ihrem XING Unternehmensprofil:<br>\n<strong>{company_url}</strong>',
    CP_300_SETTINGS_URL_EDIT: 'Ändern',
    CP_300_SETTINGS_URL_HEADER: 'Ihr XING-Link',
    CP_300_SETTINGS_URL_INFO:
      'Dies ist der Link zu Ihrem XING Unternehmensprofil:<br>\n<strong>{company_url}</strong><br><br>\nSie können ihn, wenn Sie möchten, einmalig ändern.',
    CP_300_SETTINGS_URL_PENDING:
      'Ihr Unternehmensprofil ist noch nicht aktiviert. Wenn es freigegeben wird, können Sie Ihren persönlichen Link anfordern.',
    CP_300_SETTINGS_URL_RESET: 'URL zurücksetzen',
    CP_300_UPGRADE_TEASER_BENEFITS:
      '<h4>Ihre Vorteile:</h4>\n<ul class="bullet-list">\n  <li><span>Individuelles Design</span></li>\n  <li><span>Einbindung von Unternehmenslogo und -beschreibung</span></li>\n  <li><span>Einstellen von Unternehmens-Neuigkeiten</span></li>\n  <li><span>Liste der Follower einsehbar</span></li>\n</ul>',
    CP_300_UPGRADE_TEASER_HEADLINE:
      'Setzen Sie Ihr Unternehmen auf XING professionell in Szene.',
    CP_300_UPGRADE_TEASER_LINK_TO_PDF: 'Weitere Informationen',
    CP_300_UPGRADE_TEASER_LIST:
      '<p>In nur 3 Schritten zum professionell gestalteten Unternehmensprofil:</p>\n<ol>\n  <li>Unternehmensprofil anfordern</li>\n  <li>Unternehmensprofil upgraden</li>\n  <li>Unternehmensprofil professionell gestalten</li>\n</ol>',
    CP_300_UPLOAD_DISABLED_LOCAL_TIP:
      'Diese Funktion ist nach Freischaltung Ihres Profils verfügbar.',
    CP_300_UPLOAD_DISABLED_REMOTE_TIP:
      'Mit einem Employer Branding-Profil können Sie auch Videos und Präsentationen einbinden.',
    CP_300_UPLOAD_FILE_BUTTON: 'Durchsuchen',
    CP_300_UPLOAD_FILE_ERROR_FORMAT:
      'Bitte wählen Sie ein PDF oder ein Bild im Format JPG, PNG, BMP oder GIF.',
    CP_300_UPLOAD_FILE_LABEL: 'Datei auswählen',
    CP_300_UPLOAD_FILE_NOTE:
      'Sie können PDFs oder Bilder (JPG, PNG, BMP, GIF) mit einer Größe bis 5 MB hochladen.',
    CP_300_UPLOAD_FILE_TAB: 'Bild / PDF hochladen',
    CP_300_UPLOAD_IMAGE_ERROR_FORMAT:
      'Bitte wählen Sie Bild im Format JPG, PNG, BMP oder GIF.',
    CP_300_UPLOAD_LINK_TAB: 'Video oder Präsentation einbinden',
    CP_300_UPLOAD_PDF_ERROR_FORMAT: 'Bitte wählen Sie ein PDF-Dokument.',
    CP_300_UPLOAD_URL_NOTE: 'Sie können Inhalte folgender Anbieter einbinden:',
    CP_300_URL_DESCRIPTION_LABEL:
      'Fügen Sie hier den Link zum Video / zur Präsentation ein.',
    CP_300_VAT_NUMBER_LABEL: 'Ihre Umsatzsteuer-ID',
    CP_3562_THIS_FUNCTION_WILL_BE_OPTIMIZED_DIALOG_BODY:
      'Deshalb kannst Du hier momentan leider keine Bilder bearbeiten. In der Rubrik "Über uns" ist dies dagegen problemlos möglich.',
    CP_3562_THIS_FUNCTION_WILL_BE_OPTIMIZED_DIALOG_CANCEL: 'Abbrechen',
    CP_3562_THIS_FUNCTION_WILL_BE_OPTIMIZED_DIALOG_GO_TO_ABOUT_US:
      'Zur Rubrik "Über uns"',
    CP_3562_THIS_FUNCTION_WILL_BE_OPTIMIZED_DIALOG_HEADLINE:
      'Diese Rubrik wird gerade überarbeitet.',
    CP_3562_UPLOAD_RESTRICTIONS_IDEAL_SIZE:
      'Farbmodell: RGB (kein CMYK), Idealgröße: ',
    CP_3582_ALL_COMPANIES_ARE_CLAIMED_ERROR_BODY:
      'Schau mal hier: {company_link}\n',
    CP_3582_ALL_COMPANIES_ARE_CLAIMED_ERROR_BODY_LINK:
      '{company} als Arbeitgeber\n',
    CP_3582_ALL_COMPANIES_ARE_CLAIMED_ERROR_TITLE:
      'Dieses Arbeitgeberprofil gibt es schon.',
    CP_3582_USER_HAS_NO_CURRENT_POSITION_ERROR_BODY:
      'Falls ja, trag Deine derzeitige Tätigkeit bitte erst {profile_link} ein. Falls nein, kannst Du für {company} leider kein Arbeitgeberprofil erstellen.',
    CP_3582_USER_HAS_NO_CURRENT_POSITION_ERROR_BODY_LINK: 'in Ihrem Profil',
    CP_3582_USER_HAS_NO_CURRENT_POSITION_ERROR_TITLE:
      'Arbeitest Du bei diesem Unternehmen?',
    CP_3582_USER_IS_STUDENT_ERROR_BODY:
      'Falls ja, kannst Du leider kein Arbeitgeberprofil erstellen. Falls nein, {profile_link}.',
    CP_3582_USER_IS_STUDENT_ERROR_BODY_LINK:
      'aktualisier bitte erst Deinen beruflichen Status',
    CP_3582_USER_IS_STUDENT_ERROR_TITLE: 'Studierst Du noch?',
    CP_400_ADV_1_DESCRIPTION:
      'Setzen Sie Ihr Unternehmen professionell in Szene! Positionieren Sie Ihr Unternehmen auf XING und erreichen Sie über 21 Millionen Mitglieder.',
    CP_400_ADV_1_HEADLINE:
      '<strong>Ihr Marketing- & PR-Instrument</strong> - das XING Profil für Ihr Unternehmen',
    CP_400_ADV_2_DESCRIPTION:
      'XING bringt Ihr Unternehmensprofil mit den passenden Menschen zusammen. Über 21 Mio. Mitglieder bedeuten über 21 Mio. Chancen auf Neugeschäft, Vertiefung von Kooperationen, Aufträge u.v.m.',
    CP_400_ADV_2_HEADLINE:
      '<strong>Vertriebskanal 2.0</strong> – reichweitenstark und innovativ',
    CP_400_ADV_3_DESCRIPTION:
      'Glänzen Sie als attraktiver Arbeitgeber und gewinnen Sie den Wettstreit um qualifizierte Fach- und Führungskräfte. Informieren Sie potenzielle Bewerber und Job-Suchende über Karrierechancen in Ihrem Unternehmen.',
    CP_400_ADV_3_HEADLINE:
      '<strong>Recruitingtool & Employer Branding</strong> – gewinnen und binden Sie Talente',
    CP_400_ADV_4_DESCRIPTION:
      'Informieren Sie über neue Produkte, Innovationen oder aktuelle Themen. Follower Ihrer Unternehmens-Neuigkeiten erhalten diese automatisch und bleiben so stets auf dem Laufenden.',
    CP_400_ADV_4_HEADLINE:
      '<strong>Langfristige Kundenbindung</strong> – halten Sie Ihre Interessenten up to date',
    CP_400_ADV_HEADLINE: 'Die Vorteile eines Unternehmensprofils auf XING',
    CP_400_ALL_COMPANIES_CLAIMED_MESSAGE:
      'Für die auf Deinem XING Profil eingetragenen Arbeitgeber wurden bereits Unternehmensprofile angelegt.',
    CP_400_AVAILABLE_CPS: 'Verfügbare Profile für Ihr Unternehmen:',
    CP_400_BASIC_PACKAGE_UPSELL_MESSAGE:
      '{company_name} hat das Paket BASIS gewählt. Möchten Sie auf das STANDARD- oder PLUS-Paket upgraden? Dann kontaktieren Sie {email_address}',
    CP_400_BENEFITS:
      '<dt>Marketing & PR:</dt> \n<dd>Ihr Unternehmensprofil ist Ihr Schaufenster auf XING. Leer und schmucklos zieht es natürlich keine Laufkundschaft an. Ist es dagegen attraktiv gestaltet, klingelt es umso öfter …</dd>\n<dt>Recruiting & Employer Branding:</dt> \n<dd>Präsentieren Sie sich als Wunsch-Arbeitgeber und informieren Sie hier XING Mitglieder über Karrierechancen in Ihrem Unternehmen.</dd>\n<dt>Vertrieb & Akquise:</dt> \n<dd>Über 21 Mio. Mitglieder bedeuten über 21 Mio. Chancen auf Neugeschäft, Kooperationen, Aufträge, u.v.m.</dd>\n<dt>Langfristige Kundenbindung:</dt> \n<dd>Mit Ihren Unternehmens-Neuigkeiten gewinnen Sie Follower, die Sie regelmäßig über Produkte und Innovationen informieren und so an sich binden können.</dd>',
    CP_400_BENEFITS_HEADER:
      'Warum Sie ein Unternehmensprofil anlegen sollten? Darum:',
    CP_400_BILLING_ADDRESS_LEGEND: 'Rechnungsempfänger',
    CP_400_BTN_CHOOSE: 'Auswählen',
    CP_400_CANCELLATION_EMAIL_BODY:
      '<p>Sehr geehrte(r) Frau/Herr {lastname},</p>\n\n<p>vielen Dank für Ihre Nachricht.</p>\n\n<p>Wir bedauern sehr, dass Sie sich entschieden haben, Ihr Unternehmensprofil zu kündigen.</p>\n\n<p>Wir haben Ihren Kündigungswunsch vorgemerkt, sodass nach der gegenwärtigen Laufzeit keine Verlängerung vorgenommen wird. Ab dem {end_date} wird das Unternehmensprofil auf "BASIS" zurückgesetzt. Alle Infos unter "Über uns", die Mitarbeiterliste, das Logo sowie eventuell eingestellte Neuigkeiten und die Abonnentenliste bleiben dabei erhalten.</p>\n\n<p>Selbstverständlich können Sie jederzeit Ihre Kündigung zurückziehen. Dafür genügt eine Mail an {cp_support_email}.</p>\n\n<p>Mit freundlichen Grüßen\n<br />Ihr XING Team</p>',
    CP_400_CANCELLATION_EMAIL_SUBJECT: 'Wir haben Ihre Kündigung vorgemerkt',
    CP_400_CHANGE_COMPANY_LINK: 'Unternehmen ändern',
    CP_400_CLAIMING_FORM_ADD_ADDRESS_TEXT:
      'Geben Sie hier Ihre Adressdaten ein. Bitte achten Sie darauf, dass Sie auch die Rechtsform Ihres Unternehmens angeben.',
    CP_400_CLAIMING_FORM_BILLING_ADDRESS: 'Rechnungsdaten',
    CP_400_CLAIMING_FORM_CHANGE_COMPANY_LABEL: 'Unternehmen',
    CP_400_CLAIMING_FORM_CHOOSE_COMPANY:
      'Folgende Unternehmen sind in Ihrem Nutzerprofil als Arbeitgeber aufgeführt. Wählen Sie das Unternehmen, für das Sie ein Unternehmensprofil anlegen möchten.',
    CP_400_CLAIMING_FORM_CHOSEN_PACKAGE: 'Gewähltes Produkt',
    CP_400_CLAIMING_FORM_CONTACT_ADDRESS: 'Kontaktdaten eingeben',
    CP_400_CLAIMING_FORM_DESCRIPTION:
      '{company_profile}, {duration} - {package_name}',
    CP_400_CLAIMING_FORM_HEADLINE: 'Unternehmensprofil anlegen',
    CP_400_CLAIMING_FORM_HINT_1:
      'Hinweis: Nicht Sie, sondern Ihr Unternehmen ist Adressat der Rechnung. Ihr Name wird aber im Rechnungstext genannt. <strong>Bitte geben Sie den vollständigen Unternehmensnamen mit Rechtsform (AG, GmbH ...) an. </strong>',
    CP_400_CLAIMING_FORM_HINT_2: '&nbsp;',
    CP_400_CLAIMING_FORM_PAYMENT_COMMENT:
      'Der Gesamtbetrag wird Ihnen in Rechnung gestellt, und diese wird an Ihre oben genannte Adresse gesendet.',
    CP_400_CLAIMING_FORM_PRICE: 'Nettopreis',
    CP_400_CLAIMING_FORM_PRICE_FREE: 'Preis',
    CP_400_CLAIMING_FORM_STEP1_TEXT: 'Rechnungsinformationen eingeben',
    CP_400_CLAIMING_FORM_STEP2_TEXT: 'Eingaben überprüfen',
    CP_400_CLAIMING_FORM_TANC:
      'Hiermit erkläre ich, {full_user_name}, dass ich autorisiert bin, das Unternehmensprofil der {company_name} zu bearbeiten. Ich nehme zur Kenntnis, dass für den Erwerb dieser Rechte sowie für das Einstellen von Inhalten die AGB von XING sowie die AGB für XING-Unternehmensprofile zu berücksichtigen sind.',
    CP_400_CLAIMING_HEADLINE:
      'Ihre professionelle Unternehmenspräsenz auf XING',
    CP_400_CLAIMING_PENDING_MESSAGE:
      'Ihre Anfrage liegt XING nun zur Autorisierung vor. Wir überprüfen, ob Sie zur Pflege dieses Unternehmensprofils berechtigt sind. Sie erhalten i.d.R. sehr schnell, an Werktagen spätestens innerhalb von 48 Stunden, eine Benachrichtigung von XING per E-Mail.',
    CP_400_COMPANY_ALREADY_CLAIMED_MESSAGE:
      'Der Vorgang kann nicht abgeschlossen werden. Ein anderes Mitglied hat dieses Firmenprofil kürzlich gekauft. In wenigen Tagen können Sie an dieser Stelle sehen, wer die Bearbeitungsrechte erworben hat.',
    CP_400_COMPANY_INVOICE_CONTACT_NAME: 'Kontaktperson',
    CP_400_COMPANY_LABEL: 'Unternehmen',
    CP_400_COMPANY_NAME: 'Unternehmen (Name des Profils)',
    CP_400_COMPANY_PROFILE: 'Unternehmensprofil',
    CP_400_CONFIRM_NAME_GO_TO_PROFILE: 'Im Profil ändern',
    CP_400_CONFIRM_NAME_PROCEED: 'Unternehmensnamen bestätigen',
    CP_400_CONFIRM_NAME_TEXT_1:
      'Verwenden Sie bitte den kompletten Namen mit Firmierung, z. B. "Musterfirma GmbH".<br>\nAls Freiberufler können Sie Ihre Tätigkeit mit Ihrem Namen verbinden, z. B. "SAP-Beratung Max Mustermann".',
    CP_400_CONFIRM_NAME_TEXT_2: 'Ihr Unternehmen heißt laut Ihrem Profil:',
    CP_400_CONFIRM_NAME_TIPS: '&nbsp;',
    CP_400_CONFIRM_NAME_TITLE: 'Ist Ihr Unternehmen korrekt angegeben?',
    CP_400_CONTACT_ADDRESS_LEGEND: 'Kontaktdaten',
    CP_400_CONTACT_EMAIL: 'E-Mail',
    CP_400_CONTACT_HEADLINE: 'Haben Sie Fragen?',
    CP_400_CONTACT_LABEL: 'Ihr Vor- und Nachname',
    CP_400_CONTACT_LINK: 'Kontaktieren Sie uns!',
    CP_400_CONTACT_TEL: 'Tel:',
    CP_400_CONTACT_WEB: 'Web:',
    CP_400_CP_BASIC_TITLE: 'Basis',
    CP_400_CP_EXAMPLES_HEADLINE: 'Beispiele für Unternehmensprofile',
    CP_400_CP_EXAMPLES_TEXT:
      'Lassen Sie sich inspirieren: Sehen Sie, wie andere Unternehmen sich präsentieren.',
    CP_400_CP_PLUS_TITLE: 'Plus',
    CP_400_CP_STANDARD_TITLE: 'Standard',
    CP_400_CP_TITLE: 'Unternehmensprofil',
    CP_400_CREATE_CP_COMPANY_NAME_ERROR_MESSAGE:
      'Aus Sicherheitsgründen können Sie keine Internetseite als Unternehmensnamen wählen. Bitte geben Sie einen anderen Namen ein.',
    CP_400_CREATE_CP_WELCOME_MESSAGE_BASIC_WARNING:
      'Bitte beachten Sie: Schließt ein Kollege ein höherwertiges Paket für dieses Unternehmensprofil ab, wird dieser als Editor eingesetzt. Sie können sich dann von dem neuen Editor als Co-Editor einsetzen lassen.',
    CP_400_CREATE_CP_WELCOME_MESSAGE_CUSTOMIZE_LINK:
      'Unternehmensprofil jetzt anpassen',
    CP_400_CREATE_CP_WELCOME_MESSAGE_HEADING:
      'Willkommen auf Ihrem Unternehmensprofil!',
    CP_400_CREATE_CP_WELCOME_MESSAGE_PDF_LINK:
      'Zur Kurzanleitung für Unternehmensprofile',
    CP_400_CREATE_CP_WELCOME_MESSAGE_TEXT:
      'Sie haben Ihr Unternehmensprofil soeben erfolgreich beantragt. Bis es freigeschaltet und für alle XING Mitglieder sichtbar ist, dauert es ca. 48 Stunden, weil jeder Antrag von uns individuell überprüft wird.',
    CP_400_CREATE_CP_WELCOME_MESSAGE_TIPS:
      '<h4>Erste Schritte zur Anpassung Ihres Profils:</h4>\n<ul class="bullet-list"><li>Laden Sie Ihr Unternehmenslogo hoch.</li>\n<li>Legen Sie eine Kurzbeschreibung für Ihr Unternehmen an.</li>\n<li>Überprüfen Sie die vorhandenen Daten auf Richtigkeit.</li>\n</ul>',
    CP_400_DETAILS_PDF_LINK: 'Detailinformationen zu den Angebotspaketen',
    CP_400_ERROR_ACCEPT_TANDC:
      'Um fortzufahren, akzeptieren Sie bitte die Allgemeinen Geschäftsbedingungen.',
    CP_400_ERROR_DURING_UPLOAD: 'Fehler beim Upload.',
    CP_400_FEATURED_COMPANIES_HEADLINE: 'Arbeitgeber stellen sich vor',
    CP_400_HEADLINE: 'Ihre professionelle Unternehmenspräsenz auf XING',
    CP_400_INTRO:
      'Mit einem gestalteten Unternehmensprofil auf XING erreichen Sie Business Professionals dort, wo sie täglich netzwerken. Kommunizieren Sie mit Interessenten, Kunden, Alumni und Bewerbern und positionieren Sie sich bei über 12 Millionen Mitgliedern.',
    CP_400_LINK_FAQ: 'Unternehmensprofile: Fragen und Antworten',
    CP_400_LINK_FAQ_HREF:
      '/help/hilfe-und-faq-2/die-funktionen-von-xing-53/unternehmensprofile-420',
    CP_400_LINK_TANDC: 'AGB für XING Unternehmensprofile',
    CP_400_MEDIADATA_PDF_LINK: 'XING Nutzerstruktur',
    CP_400_MONTHLY: 'mtl.',
    CP_400_MORE_INFO: 'Mehr Infos zu den Unternehmensprofilen',
    CP_400_MORE_INFO_HEADLINE: 'Weitere Informationen',
    CP_400_MORE_INFO_PDF:
      'Alle Vorteile und Details haben wir Ihnen auch als PDF-Dokument zusammengefasst.',
    CP_400_MORE_INFO_PDF_LINK: 'XING-Unternehmensprofile: Produktübersicht',
    CP_400_MORE_INFO_TEXT:
      'Möchten Sie Ihr Unternehmensprofil mit einer Werbeanzeige auf XING kombinieren?<br/>\nBrauchen Sie ein individuelles Angebot?<br/>\nHaben Sie weitere Fragen?',
    CP_400_MORE_INFO_VIDEO:
      'Ansehnlich: Die Unternehmensprofile als bewegte Bilder',
    CP_400_MORE_INFO_VIDEO_LINK: 'XING-Unternehmensprofile: Das Video',
    CP_400_NO_COMPANY_MESSAGE:
      'Du bist im Moment keinem Unternehmen zugeordnet. Aktualisiere Dein <a href="{profile_link}">Profil</a> und trag im Bereich “Werdegang” Deinen aktuellen Arbeitgeber ein.',
    CP_400_OFFER_HEADLINE: 'XING März Special',
    CP_400_OTHER_PRODUCTS_HEADLINE:
      'Kunden mit Unternehmensprofilen nutzen auch folgende Produkte',
    CP_400_PACKAGE_BASIC_ADVANTAGES:
      '<ul class="bullet-list">\n<li>"Über uns"-Seite und eigenes Logo</li>\n<li>Bilder und PDFs hochladen</li>\n<li>Unternehmens-Neuigkeiten schreiben</li>\n</ul>',
    CP_400_PACKAGE_BASIC_CLAIM: 'Die kostenlose Version zum Kennenlernen',
    CP_400_PACKAGE_BASIC_SHOW_EXAMPLE: 'Beispiel BASIS',
    CP_400_PACKAGE_BASIC_TITLE: 'BASIS',
    CP_400_PACKAGE_BUY_CP: 'Bestellen',
    CP_400_PACKAGE_COMPARISION_AD_FREE: 'Keine Werbung',
    CP_400_PACKAGE_COMPARISON_BENEFITS_1: 'Sichtbarkeit',
    CP_400_PACKAGE_COMPARISON_BENEFITS_2: 'Interaktivität',
    CP_400_PACKAGE_COMPARISON_BENEFITS_3: 'Kontaktoptionen',
    CP_400_PACKAGE_COMPARISON_BENEFITS_4: 'Gestaltungsmöglichkeiten',
    CP_400_PACKAGE_COMPARISON_BENEFITS_HEADING: 'Vorteile',
    CP_400_PACKAGE_COMPARISON_COMPANY_UPDATES:
      'Unternehmens-Neuigkeiten schreiben',
    CP_400_PACKAGE_COMPARISON_FEATURE_1: '"Über uns"-Seite und eigenes Logo',
    CP_400_PACKAGE_COMPARISON_FEATURE_10: 'Liste der Follower einsehbar',
    CP_400_PACKAGE_COMPARISON_FEATURE_11:
      'Max. Zugänge für den Bearbeitungsbereich',
    CP_400_PACKAGE_COMPARISON_FEATURE_12: 'Unternehmens-Neuigkeiten schreiben',
    CP_400_PACKAGE_COMPARISON_FEATURE_14:
      'Einbindung von Videos und Präsentationen',
    CP_400_PACKAGE_COMPARISON_FEATURE_2:
      'Anzeige Ihrer aktuellen XING-Stellenangebote',
    CP_400_PACKAGE_COMPARISON_FEATURE_3:
      'Automatische Liste Ihrer Mitarbeitenden auf XING',
    CP_400_PACKAGE_COMPARISON_FEATURE_4:
      'Auffindbarkeit bei Google, Bing etc. (optional)',
    CP_400_PACKAGE_COMPARISON_FEATURE_5: 'Max. Einträge im Kontaktbereich',
    CP_400_PACKAGE_COMPARISON_FEATURE_6:
      'Max. Schlagwörter für bessere Auffindbarkeit',
    CP_400_PACKAGE_COMPARISON_FEATURE_7: 'Verlinkbare Header-Grafik',
    CP_400_PACKAGE_COMPARISON_FEATURE_8: 'Besucher- und Follower-Statistik',
    CP_400_PACKAGE_COMPARISON_FEATURE_9:
      'Max. Anzahl hochladbarer Bilder / PDFs',
    CP_400_PACKAGE_COMPARISON_FEATURE_CROSS: 'Nein',
    CP_400_PACKAGE_COMPARISON_FEATURE_TICK: 'Ja',
    CP_400_PACKAGE_COMPARISON_FEATURES_HEADING: 'Leistungen',
    CP_400_PACKAGE_COMPARISON_HEADING:
      'Das passende Profil für Ihr Unternehmen',
    CP_400_PACKAGE_COMPARISON_NUM_CHARS: '{num} Zeichen',
    CP_400_PACKAGE_COMPARISON_PROFILE_VISITORS:
      'Besucher des Unternehmensprofils sehen',
    CP_400_PACKAGE_COMPARISON_STATISTICS: 'Besucher- und Follower-Statistik',
    CP_400_PACKAGE_COMPARISON_SUBHEADING:
      'Die Vorteile der drei Angebotspakete im Überblick:',
    CP_400_PACKAGE_COMPARISON_TWEETS_IMPORT:
      'Automatischer Import von Unternehmens-Tweets',
    CP_400_PACKAGE_COMPARISON_XING_SEARCH_RESULTS_VISIBILITY:
      'Prominente Darstellung in den XING Suchergebnissen',
    CP_400_PACKAGE_CREATE_CP: 'Bestellen',
    CP_400_PACKAGE_DETAILS_LINK: 'Details vergleichen',
    CP_400_PACKAGE_FREE: 'Kostenlos',
    CP_400_PACKAGE_HEADER_HEADING:
      'Ihr Arbeitgeberprofil auf XING:<br>\nZeigen Sie hier, was Sie als Arbeitgeber auszeichnet.',
    CP_400_PACKAGE_HEADER_INTRO:
      '<p>Mit Ihrem XING Arbeitgeberprofil präsentieren Sie Ihr Unternehmen den über 21 Millionen XING Mitgliedern. Nutzen Sie dieses Potenzial und zeigen Sie sich von Ihrer besten Seite, egal ob Sie Mittelständler sind oder ein internationaler Konzern.</p>\n\n<p><a href="{pdf_link}">Mehr Informationen über Arbeitgeberprofile (PDF)</a></p>',
    CP_400_PACKAGE_HEADER_INTRO_SHORT:
      'Mit Ihrem XING Arbeitgeberprofil präsentieren Sie Ihr Unternehmen den über 21 Millionen XING Mitgliedern. Nutzen Sie dieses Potenzial und zeigen Sie sich von Ihrer besten Seite, egal ob Sie Mittelständler sind oder ein internationaler Konzern.',
    CP_400_PACKAGE_INVOICE_INFORMATION:
      'Sie erhalten die Rechnung für den Jahresbetrag per Post.',
    CP_400_PACKAGE_M: 'Plus',
    CP_400_PACKAGE_M_ADV_1: 'Inkl. aller Funktionen des STANDARD-Pakets',
    CP_400_PACKAGE_M_ADV_2: 'Individuelles Design',
    CP_400_PACKAGE_M_ADV_3:
      'Unbegrenztes Einstellen aktueller Unternehmens-Neuigkeiten',
    CP_400_PACKAGE_M_ADV_4: 'Arbeitgeber-Neuigkeiten',
    CP_400_PACKAGE_M_ADV_5: 'Liste der Follower einsehbar',
    CP_400_PACKAGE_M_CLAIM: 'Ihre innovative Präsenz',
    CP_400_PACKAGE_PLUS: 'Plus',
    CP_400_PACKAGE_PLUS_ADVANTAGES:
      '<ul class="bullet-list">\n<li>Alle STANDARD-Vorteile</li>\n<li>Verlinkbare und beliebig oft austauschbare Header-Grafik</li>\n<li>Übersicht der Besucher Ihres Unternehmensprofils</li>\n<li>Besucher- und Follower-Statistik inkl. Traffic-Analyse und Profilanalyse</li>\n<li>Einbindung von Videos und Präsentationen</li>\n</ul>',
    CP_400_PACKAGE_PLUS_CLAIM:
      'Mit exklusiven Besucher- und Follower-Statistiken',
    CP_400_PACKAGE_PLUS_SHOW_EXAMPLE: 'Beispiel PLUS',
    CP_400_PACKAGE_PLUS_TITLE: 'PLUS',
    CP_400_PACKAGE_S: 'Standard',
    CP_400_PACKAGE_S_ADV_1:
      'Mit detaillierter Unternehmensbeschreibung und –logo',
    CP_400_PACKAGE_S_ADV_2: 'Verlinkung zu Ihren Anzeigen auf XING Jobs',
    CP_400_PACKAGE_S_ADV_3: 'Aktuelle Mitarbeitende',
    CP_400_PACKAGE_S_ADV_4:
      'Große Reichweite auch außerhalb von XING - Profil ist in Suchmaschinen auffindbar',
    CP_400_PACKAGE_S_CLAIM: 'Ihre individuelle Präsenz',
    CP_400_PACKAGE_STANDARD: 'Standard',
    CP_400_PACKAGE_STANDARD_ADVANTAGES:
      '<ul class="bullet-list">\n<li>Alle BASIS-Vorteile</li>\n<li>Bessere Auffindbarkeit durch frei definierbare Schlagwörter</li>\n<li>"Kontakt"-Seite für die Angabe von Ansprechpersonen</li>\n<li>Bis zu 5 Zugänge für den Bearbeitungsbereich</li>\n</ul>',
    CP_400_PACKAGE_STANDARD_CLAIM: 'Für mehr Präsenz auf XING und im Web',
    CP_400_PACKAGE_STANDARD_SHOW_EXAMPLE: 'Beispiel STANDARD',
    CP_400_PACKAGE_STANDARD_TITLE: 'STANDARD',
    CP_400_PACKAGE_UPSELL_CP: 'Jetzt upgraden',
    CP_400_PACKAGE_UPSELL_HEADING:
      'Das Business-Upgrade für Ihr Unternehmensprofil',
    CP_400_PACKAGE_UPSELL_INTRO:
      '<p>Setzen Sie Ihr Unternehmen noch professioneller in Szene und steigern Sie Ihre Sichtbarkeit bei über 20 Mio. potenziellen Kunden, Geschäftspartnern und Job-Kandidaten - mit einem Unternehmensprofil <strong>STANDARD</strong> oder <strong>PLUS</strong>!</p>\n<ul class="bullet-list">\n<li>Mehr Sichtbarkeit</li>\n<li>Mehr Kommunikationsmöglichkeiten</li>\n<li>Mehr Gestaltungsoptionen</li>\n</ul>\n<p><a href="{pdf_link}">Mehr Informationen zu Unternehmensprofilen (PDF)</a></p>',
    CP_400_PACKAGES_FOOTNOTE:
      'Die Mindestlaufzeit beträgt 12 Monate und verlängert sich um jeweils dieselbe Laufzeit.',
    CP_400_PACKAGES_FOOTNOTE_2:
      'Die hier angezeigten Preise sind Netto-Preise.',
    CP_400_PACKAGES_FOOTNOTE_3:
      'Die Suchmaschinen-Sichtbarkeit des Profils kann auch deaktiviert werden.',
    CP_400_PACKAGES_FOOTNOTE_4:
      'Rechnungen werden über den vollen Betrag und ausschließlich in Euro ausgestellt.',
    CP_400_PACKAGES_FOOTNOTE_SPECIAL_OFFER:
      '<b>Bzgl. des Spezialangebotes:</b> Der ermäßigte Preis gilt für die Mindestlaufzeit von 12 Monaten. Das Produkt verlängert sich automatisch jeweils um weitere 12 Monate zum Preis von 24,90 € monatlich.',
    CP_400_PACKAGES_FOOTNOTE_UPSELL:
      'Die Mindestlaufzeit beträgt 12 Monate und verlängert sich nach Ablauf um weitere 12 Monate zum Preis von 24,90 € bzw. 129,00 € im Monat.',
    CP_400_PACKAGES_UPSELL_VALID_UNTIL: 'Angebot gültig bis zum 15.11.2010',
    CP_400_PAYING_EDITOR_LINK:
      'Dieses Unternehmensprofil wird gepflegt von <a href="{userprofile}">{full_user_name}</a>',
    CP_400_PAYMENT_METHOD_LEGEND: 'Zahlungsmethode',
    CP_400_PLEASE_CHECK_YOUR_DATA: 'Bitte überprüfen Sie Ihre Daten.',
    CP_400_PLUS_PACKAGE_UPSELL_MESSAGE:
      '{company_name} hat bereits das Paket PLUS.',
    CP_400_PRICE: '{price} {currency}',
    CP_400_PRICE_MONTHLY: '{price} mtl.',
    CP_400_PRICE_YEARLY: '{price} p.a.',
    CP_400_QUICK_GUIDE_PDF_LINK: 'XING-Unternehmensprofile: Kurzanleitung',
    CP_400_REJECTION_EDITOR_LEFT_COMPANY_EMAIL_SUBJECT:
      'Bitte beantragen Sie Ihr Unternehmensprofil erneut',
    CP_400_SPRING_SPECIAL_OFFER_TEXT: 'alttext',
    CP_400_STANDARD_PACKAGE_UPSELL_MESSAGE:
      '{company_name} hat das Paket STANDARD gewählt. Möchten Sie auf das PLUS-Paket upgraden? Dann kontaktieren Sie {email_address}',
    CP_400_START_VIDEO: 'Video starten',
    CP_400_SUPPORT_DETAILS:
      'Wir haben <a href="https://xing.force.com/success/s/topic/0TOb000000058WgGAI/employer-branding-profil" target="_blank">die wichtigsten Antworten zu Unternehmensprofilen</a> für Sie zusammengestellt. Darüber hinaus helfen wir Ihnen auch gerne persönlich weiter, telefonisch unter +49 40 419 131-784 oder per Mail unter <a href="mailto:unternehmensprofile@xing.com">unternehmensprofile@xing.com</a>.',
    CP_400_SUPPORT_HEADER: 'Noch Fragen?',
    CP_400_TESTIMONIAL_HEADLINE: 'Mein Unternehmen zeigt Profil',
    CP_400_TESTIMONIAL_QUOTE:
      'Das Unternehmensprofil auf XING unterstützt uns dabei, unser Image als attraktiver Arbeitgeber zu stärken und mit potenziellen Kandidaten in Kontakt zu treten.',
    CP_400_UPSELL_CONFIRM_LINK1: 'Weitere Angebote für Unternehmen',
    CP_400_UPSELL_CONFIRM_LINK2: 'Zurück zur XING-Startseite',
    CP_400_UPSELL_CONFIRM_TEXT:
      'Vielen Dank für Ihre Bestellung! Wir werden das Upgrade Ihres Unternehmensprofils innerhalb von 24 Stunden für Sie vornehmen und  \nIhnen per E-Mail eine Bestätigung zusenden.',
    CP_400_UPSELL_FOOTNOTE:
      'Der Haupt-Editor des Unternehmensprofils erhält bei Buchung eines Unternehmensprofils bis zum 30.9.2010 sechs (bei Upgrade auf das STANDARD-Profil) bzw. zwölf (bei Upgrade auf das PLUS-Profil) Premium-Monate gratis freigeschaltet.',
    CP_400_UPSELL_FORM_HEADLINE: 'Unternehmensprofil upgraden',
    CP_400_UPSELL_FORM_STEP2_TEXT: 'Bestätigung',
    CP_400_UPSELL_PLUS_SPECIAL_OFFER_TEXT:
      '+ 12 Monate Premium-Mitgliedschaft gratis',
    CP_400_UPSELL_REFERENCE_COMPANIES:
      'Diese Unternehmen besitzen bereits ein Standard- oder Plus-Profil auf XING.',
    CP_400_UPSELL_STANDARD_SPECIAL_OFFER_TEXT:
      '+ 6 Monate Premium-Mitgliedschaft gratis',
    CP_400_VIDEO_HEADLINE: 'Video zu Unternehmensprofilen',
    CP_400_WARNING_REVOKED_CONTRACT:
      'Das Bearbeiten des Unternehmensprofils ist zurzeit leider nicht möglich. Bitte versuchen Sie es zu einem späteren Zeitpunkt noch einmal.',
    CP_400_WHO_CAN_DESCRIPTION:
      'Alle auf XING registrierten Mitarbeiter eines Unternehmens haben die Möglichkeit, das Nutzungsrecht für ihr Unternehmensprofil zu erwerben. Vor dem Kauf muss bestätigt werden, dass die Person berechtigt ist, im Namen des Unternehmens zu handeln. Das Unternehmensprofil kann nach Autorisierung durch XING (innerhalb von 2 Werktagen) bearbeitet werden.',
    CP_400_WHO_CAN_HEADLINE: 'Hinweise zum Kauf',
    CP_401_PACKAGE_DURATION: '{number}-Monats-Abonnement',
    CP_401_PACKAGE_M: 'Unternehmensprofil PLUS',
    CP_401_PACKAGE_S: 'Unternehmensprofil STANDARD',
    CP_401_PACKAGE_XS: 'Unternehmensprofil BASIS',
    CP_401_TANDC_LABEL:
      'Ich bin zur Buchung des Unternehmensprofils berechtigt und akzeptiere die <a id="tandc-link" href="/legal/api/pages/terms_and_conditions/employer-branding-profil.html" target="_blank">{link_text}</a>.',
    CP_405_ADDITIONAL_ADDRESS_LABEL: 'Adresszusatz',
    CP_405_FOR_QUERIES_ONLY_INFO: '(nur für Rückfragen)',
    CP_405_NO_VAT_NUMBER_LABEL: 'Ich habe keine USt-Id-Nummer.',
    CP_405_PERSON_OF_CONTACT_LABEL: 'Ansprechperson',
    CP_405_SELECTED_PRODUCT_LABEL: 'Gewähltes Produkt',
    CP_405_VAT_NUMBER_LABEL: 'USt-IdNr.',
    CP_410_ACCEPTED_EDITOR_MAIL_SUBJECT:
      'Aktivierung Ihres Unternehmensprofils',
    CP_410_CONTRACT_REJECTED_EDITOR_LEFT_COMPANY_MAIL_TEXT:
      '<p>{salutation},</p>\n\n<p>Sie haben kürzlich ein Unternehmensprofil für {company_name} beantragt. Leider müssen wir Ihren Antrag ablehnen, da Sie den Unternehmensnamen in der Zwischenzeit in Ihrem persönlichen Profil geändert haben. Bitte beantragen Sie das Unternehmensprofil erneut mit dem neuen Unternehmensnamen:</p>\n\n<p><a href="https://www.xing.com/companies/contract/select_package">https://www.xing.com/companies/contract/select_package</a></p>\n\n<p>Bei Fragen helfen wir Ihnen gerne weiter, telefonisch unter +49 40 419 131-784 oder per Mail unter {cp_support_email}.</p>\n\n<p>Vielen Dank für Ihr Verständnis.</p>\n\n<p>Mit freundlichen Grüßen\n<br />Ihr XING-Team\n</p>',
    CP_410_NEW_WORKFLOW_CONTRACT_MAIL_SUBJECT:
      'Fast geschafft: Aktivieren Sie jetzt Ihr XING Arbeitgeberprofil',
    CP_410_NEW_WORKFLOW_SUCCESS_PUBLICATION_SUBJECT:
      'Ihr XING Arbeitgeberprofil wurde veröffentlicht!',
    CP_ABOUT_APPLICATION_PROCESS: 'Infos zum Bewerbungsprozess',
    CP_ABOUT_US_PLACEHOLDER:
      'Hier beschreiben Sie Ihr Unternehmen: Was bieten Sie Ihren Kunden? Welche Unternehmensvision und -mission haben Sie? Warum arbeiten Mitarbeiter gerne bei Ihnen?',
    CP_ABOUT_US_PLACEHOLDER_TITLE: 'Stellen Sie sich vor!',
    CP_ABOUT_US_TITLE: 'Über uns',
    CP_ACTION_PUBLISH: 'Veröffentlichen',
    CP_ADD_IDEAL_EMPLOYER_FAILURE:
      'Das hat leider nicht geklappt ... können Sie es bitte noch einmal versuchen?',
    CP_ADD_IDEAL_EMPLOYER_SUCCESS: 'Wunsch-Arbeitgeber hinzugefügt',
    CP_ANDROID_EMPTY_SEARCH_DESCRIPTION:
      "Gibt's dieses Unternehmen vielleicht auch mit anderer Schreibweise?",
    CP_ANDROID_EMPTY_SEARCH_HEADLINE: 'Leider nichts gefunden',
    'CP_APPLICANTS_RATED_APPLICATION_PROCESS_INNER.one': 'ein Bewerber',
    'CP_APPLICANTS_RATED_APPLICATION_PROCESS_INNER.other': '{count} Bewerber',
    'CP_APPLICANTS_RATED_APPLICATION_PROCESS_INNER.zero': 'Nobody',
    CP_APPLICATION_PROCESS_LEARN_MORE: 'Weitere Infos zum Bewerbungsprozess',
    CP_APPLICATION_PROCESS_TITLE: 'Bewerbungsprozess',
    CP_BADGE_NEW: 'NEU',
    CP_BEST_COMPANIES_BY_CITY_TITLE:
      'Arbeitgeber mit den besten Bewertungen in',
    CP_BRANDMANAGER: 'BrandManager',
    CP_CANNOT_CHANGE_LAST_ADMIN:
      'Sie können sich als Haupt-Editor nicht löschen. Bitte bestimmen Sie erst einen Nachfolger als Haupt-Editor, bevor Sie Ihren Zugang löschen.',
    CP_CANNOT_CHANGE_ROLE: 'Leider kann die Rolle nicht geändert werden.',
    CP_CANNOT_DELETE_LAST_EDITOR:
      'Wenn es nur einen Editor gibt, kann dieser nicht entfernt werden.',
    CP_CANNOT_TRANSFER_OWNERSHIP_TO_SAME_USER:
      'Bitte übertragen Sie diese Seite einer anderen Person.',
    CP_CARD_CONTACT_INFO: 'Kontaktdetails',
    CP_CLAIM_COMPANY_LINK: 'Ist dies Dein Unternehmen?',
    CP_COMPANY_ABOUT_META_DESCRIPTION:
      'Erfahre, welche Vorteile {company_name} als Arbeitgeber auszeichnen.',
    CP_COMPANY_ABOUT_PAGE_TITLE: '{company_name} als Arbeitgeber',
    CP_COMPANY_EMPLOYEES_META_DESCRIPTION:
      'Alle XING Mitglieder, die bei {company_name} arbeiten, auf einen Blick',
    CP_COMPANY_EMPLOYEES_PAGE_TITLE: 'Mitarbeitende von {company_name}',
    CP_COMPANY_FACTS: 'Steckbrief',
    CP_COMPANY_FOLLOWERS_META_DESCRIPTION:
      'Auf einen Blick sehen, wer {company_name} folgt.',
    CP_COMPANY_FOLLOWERS_PAGE_TITLE: 'Follower von {company_name}',
    CP_COMPANY_JOBS_META_DESCRIPTION:
      'Auf Job-Suche? Hier siehst Du aktuelle Stellenangebote von {company_name}.',
    CP_COMPANY_JOBS_PAGE_TITLE: 'Offene Stellen bei {company_name}',
    CP_COMPANY_LOGO_LABEL: 'Unternehmenslogo',
    CP_COMPANY_LOGO_MANDATORY:
      'Bitte fügen Sie noch Ihr Unternehmenslogo hinzu.',
    CP_COMPANY_NOT_FOUND: 'Dieses Unternehmen haben wir leider nicht gefunden.',
    CP_COMPANY_PRODUCTS_AND_SERVICES_META_DESCRIPTION:
      'Alle Produkte & Services von {company_name} auf einen Blick',
    CP_COMPANY_PRODUCTS_AND_SERVICES_PAGE_TITLE:
      '{company_name}: Alle Produkte & Services',
    CP_COMPANY_REVIEWS_META_DESCRIPTION:
      'Wie bewerten Mitarbeiter von {company_name} ihren Arbeitgeber? Das erfährst Du hier im Detail.',
    CP_COMPANY_REVIEWS_PAGE_TITLE:
      '{company_name}: Erfahrungsberichte von Mitarbeitenden',
    CP_COMPANY_UPDATES_META_DESCRIPTION:
      "Was gibt's Neues bei {company_name}? Hier erfährst Du's.",
    CP_COMPANY_UPDATES_PAGE_TITLE: 'Neuigkeiten von {company_name}',
    CP_CONTACT_DELETE_CONFIRM:
      'Möchten Sie diese Person wirklich als Ansprechperson entfernen?',
    CP_CONTACT_INFO_PLACEHOLDER:
      'Informieren Sie hier Interessenten darüber, wie man Sie kontaktieren kann.',
    CP_CONTACT_INFO_PLACEHOLDER_TITLE: 'Kontaktdaten hinzufügen',
    CP_CONTACT_INFO_TITLE: 'Kontakt',
    CP_CONTACT_OPTIONS: 'Kontaktmöglichkeiten',
    CP_CONTACT_OPTIONS_ERROR:
      'Bitte wählen Sie mindestens eine Kontaktmöglichkeit aus.',
    CP_CONTACT_PEOPLE_TITLE: 'Ansprechperson',
    CP_CONTACT_PERSON_XING_MESSAGE: 'XING Nachricht',
    CP_CONTACTS_DESCRIPTION_PLACEHOLDER:
      'Sie können hier kurz (max. {chars} Zeichen) beschreiben, bei welchen Anliegen diese Person kontaktiert werden kann (z. B. bei Bewerbungen).',
    CP_CONTACTS_FOLLOWING_COMPANY: 'Diese Kontakte folgen der Seite:',
    CP_CONTACTS_NAME_HINT:
      'Bitte informieren Sie diese Person über ihre neue Rolle als offizieller Ansprechperson Ihres Unternehmens. Offizielle Kontakte sollten zudem in ihren Einstellungen die Option "Alle Mitglieder" für den Erhalt von Nachrichten wählen.',
    CP_CONTACTS_PLACEHOLDER:
      'Fügen Sie hier Kollegen hinzu, die als offizielle Ansprechpersonen für bestimmte Anliegen zur Verfügung stehen.',
    CP_CONTACTS_PLACEHOLDER_TITLE: 'Ansprechpersonen',
    CP_CONTACTS_TITLE: 'Ansprechpersonen',
    CP_CONTRACT_DOES_NOT_ALLOW_RSS_FEEDS:
      'Leider sind RSS-Feeds nicht Teil Ihres Vertrages.',
    CP_CONTRACT_DOES_NOT_ALLOW_TWITTER_FEEDS:
      'Leider sind Twitter-Feeds nicht Teil Ihres Vertrages.',
    CP_CREATE_FREE_PROFILE: 'Kostenloses Unternehmensprofil anlegen',
    CP_DIRECT_TRAFFIC_LABEL: 'Direkt',
    CP_DIRECT_TRAFFIC_SUBTITLE: 'Direkt',
    CP_DOES_NOT_HAVE_VALID_CONTRACT:
      'Dieses Unternehmen hat leider keinen gültigen Vertrag.',
    CP_DRAFT_COMPANY_BUTTON_FINISH: 'Weiter bearbeiten',
    CP_DRAFT_COMPANY_FLAG_WARNING: 'Entwurf',
    CP_DRAFT_COMPANY_WAITING_APPROVAL: 'Noch nicht freigeschaltet',
    CP_DUPLICATED_UPDATE:
      'Sie haben bereits eine Neuigkeit mit genau diesem Text veröffentlicht.',
    CP_EBP_ADD_PDF: 'PDF hinzufügen',
    CP_EBP_ADD_PDF_REQUIREMENTS: 'Ihr PDF darf max. 5 MB groß sein.',
    CP_EBP_ADD_PICTURE: 'Bild hinzufügen',
    CP_EBP_ADD_PICTURE_REQUIREMENTS: 'Bildgröße max. 5 MB (JPG, PNG, BMP, GIF)',
    CP_EBP_ADD_PRESENTATION: 'Präsentation hinzufügen',
    CP_EBP_ADD_VIDEO: 'Video hinzufügen',
    CP_EBP_ASSET_CAPTION_PLACEHOLDER:
      'Hier können Sie optional eine Beschreibung hinzufügen (max. 200 Zeichen).',
    CP_EBP_ASSET_CAPTION_TITLE: 'Beschreibung',
    CP_EBP_BENEFITS_CONFIRMED: 'bestätigte Vorteile für Mitarbeitende',
    CP_EBP_COMPANY_PUBLISHED_BANNER:
      'Ihr Arbeitgeberprofil wurde veröffentlicht!',
    CP_EBP_CROP_HELP:
      'Sie können die Auswahl bewegen, vergrößern und verkleinern, um den erwünschten Bildausschnitt zu wählen.',
    CP_EBP_EMPLOYEES_COUNT: 'davon bei XING',
    CP_EBP_GALLERY_ADD: 'Etwas hinzufügen',
    CP_EBP_GALLERY_ADD_MAXIMUM_TOOLTIP:
      'Alle verfügbaren Module sind jetzt belegt.',
    CP_EBP_GALLERY_EMPTY_PDF: 'PDF',
    CP_EBP_GALLERY_EMPTY_PDF_TEXT:
      'Laden Sie hier PDF-Dokumente hoch, z. B. interessante Artikel, Erfahrungsberichte Ihrer Mitarbeiter etc.',
    CP_EBP_GALLERY_EMPTY_PICTURE: 'Bild',
    CP_EBP_GALLERY_EMPTY_PICTURE_TEXT:
      'Laden Sie hier Bilder hoch, die Interessenten z. B. Einblicke in den Arbeitsalltag gewähren.',
    CP_EBP_GALLERY_EMPTY_PRESENTATION: 'Präsentation',
    CP_EBP_GALLERY_EMPTY_PRESENTATION_TEXT:
      'Haben Sie Präsentationen Ihres Unternehmens bei SlideShare hochgeladen? Dann können Sie diese hier integrieren.',
    CP_EBP_GALLERY_EMPTY_VIDEO: 'Video',
    CP_EBP_GALLERY_EMPTY_VIDEO_TEXT:
      'Videos zu Ihrem Unternehmen, die Sie bei YouTube oder Vimeo hochgeladen haben, können Sie hier integrieren.',
    CP_EBP_JOB_VACANCIES: 'Jobs',
    CP_EBP_NPO_LABEL: 'Gemeinnützige Organisation',
    CP_EBP_PRESENTATION_EMBED: 'Präsentation integrieren',
    CP_EBP_PRESENTATION_EMBED_HINT:
      'Sie können Präsentationen von SlideShare integrieren.',
    CP_EBP_PRESENTATION_EMBED_PLACEHOLDER:
      'Fügen Sie hier den Link zur Präsentation ein.',
    CP_EBP_SELECT_ASSET: 'Was möchten Sie hinzufügen?',
    CP_EBP_SELECT_ASSET_MAX:
      'Sie können max. {max} Videos, Bilder etc. hinzufügen.',
    CP_EBP_UPLOAD_TEXT: 'Video oder Bild hinzufügen',
    CP_EBP_VIDEO_CAPTION_PLACEHOLDER:
      'Hier können Sie eine optionale Beschreibung (max. 200 Zeichen) eingeben.',
    CP_EBP_VIDEO_EMBED: 'Video integrieren',
    CP_EBP_VIDEO_EMBED_HINT:
      'Sie können Videos von YouTube und Vimeo integrieren.',
    CP_EBP_VIDEO_EMBED_PLACEHOLDER: 'Fügen Sie hier den Link zum Video ein.',
    CP_EDITOR_NOT_FOUND: 'Diesen Editor haben wir leider nicht gefunden.',
    CP_EMPLOYEE_ANONYMOUS: 'Anonym',
    CP_EMPLOYEES_LIST_ALPHABETICAL: 'Employees in alphabetical order',
    CP_EMPLOYEES_LIST_HEADLINE: 'Diese Mitarbeitenden sind bei XING:',
    CP_EMPTY_STATE_MANAGED_BUTTON: 'Jetzt Unternehmensprofil erstellen',
    CP_EMPTY_STATE_MANAGED_HEADER: 'Den Top-Talenten schneller auffallen?',
    CP_EMPTY_STATE_MANAGED_SUBHEADER:
      'Das geht mit einem XING Unternehmensprofil: Kultur und Werte teilen und so nachhaltig das eigene Employer Branding stärken.',
    CP_ERROR_ON_SEARCH:
      'Das hat leider nicht geklappt. Versuch es bitte nochmal.',
    CP_EXECUTIVES_DESCRIPTION:
      'Diese Top-Führungskräfte wurden von uns verifiziert und tragen daher die XING Executive-Auszeichnung.',
    CP_EXECUTIVES_DESCRIPTION_LINK: 'Weitere Informationen zu XING Executives',
    CP_EXECUTIVES_TITLE: 'Top-Führungskräfte',
    CP_FACTS_PLACEHOLDER:
      'Geben Sie hier Zahlen und Daten zu Ihrem Unternehmen an.',
    CP_FACTS_PLACEHOLDER_TITLE: 'Unternehmensdaten hinzufügen',
    CP_FOLLOW_COMPANY_FAILURE:
      'Das hat leider nicht geklappt ... kannst Du es bitte nochmal versuchen?',
    CP_FOLLOW_COMPANY_SUCCESS: 'Du folgst nun diesem Arbeitgeber.',
    CP_FOLLOWED_EMPTY_STATE_BUTTON: 'Weitere beliebte Arbeitgeber',
    CP_FOLLOWED_EMPTY_STATE_HEADER:
      'Folge Arbeitgebern, die Dich interessieren.',
    CP_FOLLOWED_EMPTY_STATE_SUBHEADER:
      'Dann erfährst Du automatisch, wenn es offene Stellen oder andere Neuigkeiten von ihnen gibt. Als Inspiration sind hier die meistbesuchten Arbeitgeber-Seiten auf XING:',
    CP_FOLLOWING_COMPANIES: 'Wem Du folgst',
    CP_GENERIC_COMMENT_LENGTH_ERROR:
      'Sie können bis zu {max} Zeichen eingeben.',
    CP_HEADLINE_PRODUCT_INFORMATIONS: 'Produktinformationen',
    CP_HIRING: 'Offene Jobs',
    CP_IDEAL_EMPLOYER_BANNER_ADD_BTN: 'Als Wunsch-Arbeitgeber eintragen',
    CP_IDEAL_EMPLOYER_BANNER_HEADLINE:
      'Ist dies ein Wunsch-Arbeitgeber für Dich?',
    CP_IDEAL_EMPLOYER_BANNER_REMOVE_BTN: 'Als Wunsch-Arbeitgeber entfernen',
    CP_IDEAL_EMPLOYER_BANNER_TEXT:
      'Dann kannst Du das bei Deinen Job-Wünschen angeben – so erhöhst Du Deine Chance auf spannende Job-Angebote. Deine Kontakte erfahren davon selbstverständlich nichts.',
    CP_IDEAL_EMPLOYER_BASIC_UPSELL_LIGHTBOX_CALLOUT:
      'Alle Premium-Vorteile entdecken',
    CP_IDEAL_EMPLOYER_BASIC_UPSELL_LIGHTBOX_DETAILS:
      'Die Anzahl der Wunsch-Arbeitgeber ist für Basis-Mitglied begrenzt. Mit XING Premium hingegen kannst Du bis zu 30 eintragen – <a href="{link}"><strong>und das ist nur einer von zahlreichen Premium-Vorteilen!</strong></a>',
    CP_IDEAL_EMPLOYER_BASIC_UPSELL_LIGHTBOX_GO_PREMIUM:
      'Leider kannst Du als Basis-Mitglied keine weiteren Wunsch-Arbeitgeber angeben. Mit XING Premium hingegen kannst Du bis zu 30 eintragen – {benefitsLink}',
    CP_IDEAL_EMPLOYER_BASIC_UPSELL_LIGHTBOX_GO_PREMIUM_INNER:
      'und das ist nur einer von zahlreichen Premium-Vorteilen!',
    CP_IDEAL_EMPLOYER_BASIC_UPSELL_LIGHTBOX_HEADLINE:
      'Du kannst keine weiteren Wunsch-Arbeitgeber hinzufügen.',
    CP_IDEAL_EMPLOYER_BASIC_UPSELL_LIGHTBOX_SUBHEADLINE:
      'Mehr Wunsch-Arbeitgeber angeben: mit XING Premium',
    CP_IDEAL_EMPLOYER_BASIC_UPSELL_LIGHTBOX_TEXT:
      'Du kannst nur 3 Wunsch-Arbeitgeber eintragen. Welche das sind, kannst Du in Deinen Profil-Einstellungen jederzeit ändern.',
    CP_IDEAL_EMPLOYER_LIGHTBOX_CANCEL_BUTTON: 'Abbrechen',
    CP_IDEAL_EMPLOYER_LIGHTBOX_EDIT_BUTTON: 'Wunsch-Arbeitgeber bearbeiten',
    CP_IDEAL_EMPLOYER_LIGHTBOX_EDIT_BUTTON_MOBILE: 'Alle Einträge ansehen',
    CP_IDEAL_EMPLOYER_LIST: 'Deine Wunsch-Arbeitgeber',
    CP_IDEAL_EMPLOYER_PREMIUM_LIMIT_LIGHTBOX_CONTENT:
      'Mehr als 30 Wunsch-Arbeitgeber kannst Du leider nicht eintragen. Du kannst Deine Wunsch-Arbeitgeber in Deinen Profil-Einstellungen aber jederzeit ändern.',
    CP_IDEAL_EMPLOYER_PREMIUM_LIMIT_LIGHTBOX_HEADLINE:
      'Du kannst keine weiteren Wunsch-Arbeitgeber hinzufügen.',
    CP_INDUSTRIES_DESCRIPTION: 'Alle XING Seiten, nach Branchen kategorisiert',
    CP_INDUSTRIES_SECTION_SUBLINE:
      'Hier findest Du Unternehmen nach Branchen gelistet.',
    CP_INDUSTRIES_SECTION_TITLE: 'Unternehmen nach Branchen',
    CP_INSIGHTS_SECTION_SUBLINE:
      'Das XING News-Team ermöglicht Dir einen Blick hinter die Kulissen',
    CP_INSIGHTS_SECTION_TITLE: 'Spannende Artikel rund um Unternehmen',
    CP_INVALID_ROLE: "Diese Rolle gibt's leider nicht.",
    CP_JOB_BOOKMARK_FAILURE:
      'Das hat leider nicht geklappt ... kannst Du es bitte noch einmal versuchen?',
    CP_JOB_BOOKMARK_SUCCESS: 'Job gemerkt',
    CP_JOB_FILTER_DISCIPLINE: 'Tätigkeitsfeld',
    CP_JOB_FILTER_LEVEL: 'Karriere-Stufe',
    CP_JOB_FILTER_LOCATION: 'Arbeitsorte',
    CP_JOB_SEARCH_PLACEHOLDER: 'Job-Titel oder Stichwort eingeben',
    CP_JOB_SEARCH_SUBMIT: 'Suchen',
    CP_JOBBOX_BUTTON: 'Gemerkte Jobs ansehen',
    CP_JOBS_APPLICATION_PROCESS_HEADLIN: 'Bewertung des Bewerbungsprozesses',
    CP_JOBS_APPLICATION_PROCESS_HEADLINE: 'Bewertung des Bewerbungsprozesses',
    CP_JOBS_APPLICATION_PROCESS_RATING_0:
      'Von <b>{num_ratings}</b> Bewerbern bewertet.',
    CP_JOBS_APPLICATION_PROCESS_RATING_1:
      'Die Reaktion auf meine Bewerbung war zufriedenstellend.',
    CP_JOBS_APPLICATION_PROCESS_RATING_10:
      'Ich bekam zeitgerecht eine endgültige Ab-/Zusage.',
    CP_JOBS_APPLICATION_PROCESS_RATING_11:
      'Ich konnte Feedback über den Grund der Absage einholen.',
    CP_JOBS_APPLICATION_PROCESS_RATING_2:
      'Ich bekam eine schnelle Antwort auf meine Bewerbung.',
    CP_JOBS_APPLICATION_PROCESS_RATING_3: 'Ich wusste, was auf mich zukommt.',
    CP_JOBS_APPLICATION_PROCESS_RATING_4:
      'Das Gespräch war professionell und gut vorbereitet.',
    CP_JOBS_APPLICATION_PROCESS_RATING_5:
      'Die Informationen über die Stelle waren umfassend.',
    CP_JOBS_APPLICATION_PROCESS_RATING_6:
      'Die Gesprächsatmosphäre habe ich als angenehm empfunden.',
    CP_JOBS_APPLICATION_PROCESS_RATING_7:
      'Ich fühlte mich wertschätzend behandelt.',
    CP_JOBS_APPLICATION_PROCESS_RATING_8:
      'Es wurde zufriedenstellend auf meine Fragen eingegangen.',
    CP_JOBS_APPLICATION_PROCESS_RATING_9:
      'Ich wurde über die weitere Vorgehensweise informiert.',
    CP_JOBS_EMPTY_ACTION: 'Job-Vorschläge ansehen',
    CP_JOBS_EMPTY_EDITOR_ACTION: 'Stellenanzeige erstellen',
    CP_JOBS_EMPTY_EDITOR_HEADLINE:
      'Hier sehen XING Mitglieder Ihre Stellenangebote.',
    CP_JOBS_EMPTY_EDITOR_TEXT:
      'Suchst Du nach einem passenden Job? Dann schau Dir gern unsere Job-Vorschläge für Dich an:',
    CP_JOBS_EMPTY_HEADLINE:
      'Dieser Arbeitgeber hat gerade keine offenen Stellen.',
    CP_JOBS_EMPTY_TEXT:
      'Suchst Du nach einem passenden Job? Dann schau Dir gern unsere Job-Vorschläge für Dich an:',
    CP_JOBS_ERROR_ACTION: 'Erneut versuchen',
    CP_JOBS_ERROR_HEADLINE: 'Nichts zu sehen?',
    CP_JOBS_ERROR_TEXT:
      "Wahrscheinlich konnten wir gerade nicht auf die Stellenangebote zugreifen. Probier's einfach noch einmal:",
    CP_JOBS_NO_RESULTS_ACTION: 'Filter entfernen',
    CP_JOBS_NO_RESULTS_HEADLINE:
      'Für diese Suchkriterien haben wir keine Jobs gefunden.',
    CP_JOBS_NO_RESULTS_TEXT:
      'Entfern einfach die Suchfilter, um alle freien Jobs bei diesem Arbeitgebers zu sehen.',
    CP_JOBS_PLACEHOLDER_TEXT: 'Dann sind Sie hier richtig:',
    CP_JOBS_PLACEHOLDER_TITLE: 'Suchen Sie neue Fachkräfte?',
    CP_JOBS_SEARCH_JOBS_TITLE: 'Aktuelle Jobs',
    'CP_LANDING_FOLLOWED_COMPANIES_DESCRIPTION.one':
      'Du folgst derzeit einem Arbeitgeber.',
    'CP_LANDING_FOLLOWED_COMPANIES_DESCRIPTION.other':
      'Du folgst derzeit {count} Arbeitgebern.',
    'CP_LANDING_FOLLOWED_COMPANIES_DESCRIPTION.zero':
      'Tipp: Folge allen Arbeitgebern, die Dich interessieren!',
    CP_LANDING_FOLLOWED_COMPANIES_HEADLINE: 'Deine Arbeitgeber-News',
    CP_LANDING_FOR_EMPLOYERS_TEASER: 'Für Arbeitgeber',
    'CP_LANDING_IDEAL_EMPLOYERS_DESCRIPTION.one':
      'Du hast bei einem Arbeitgeber Dein Interesse bekundet.',
    'CP_LANDING_IDEAL_EMPLOYERS_DESCRIPTION.other':
      'Du hast bei {count} Arbeitgebern Dein Interesse bekundet.',
    'CP_LANDING_IDEAL_EMPLOYERS_DESCRIPTION.zero':
      'Tipp: Hast Du Wunsch-Arbeitgeber? Dann lass es sie wissen!',
    CP_LANDING_IDEAL_EMPLOYERS_HEADLINE: 'Deine Wunsch-Arbeitgeber',
    CP_LANDING_LOGGED_OUT_EMPLOYEE_REVIEWS:
      '<strong>Bewertungen von Mitarbeitenden</strong> des Unternehmens: Sieh auf einen Blick, wie derzeitige und ehemalige Mitarbeitende ihren Arbeitgeber einschätzen.',
    CP_LANDING_LOGGED_OUT_HEADLINE:
      'Finde einen Arbeitgeber, der zu Dir passt.',
    CP_LANDING_LOGGED_OUT_INFORMATION_AND_UPDATES:
      '<strong>Infos & Neuigkeiten</strong> zu allen Vorteilen und Leistungen, die Arbeitgeber Dir zu bieten haben',
    CP_LANDING_LOGGED_OUT_INTRO_CAREER_OPORTUNITIES:
      '<strong>Karrierechancen:</strong> Auf Job-Suche? Wir zeigen Dir, welche Stellenangebote Dein Wunsch-Arbeitgeber gerade ausgeschrieben hat.',
    CP_LANDING_MANAGE_COMPANIES_HEADLINE: 'Deine Arbeitgeberprofile',
    CP_LANDING_MOBILE_BANNER:
      'Um ein Unternehmensprofil zu erstellen, auf den XING BrandManager zuzugreifen oder Team-Berechtigungen zu verwalten, <strong>wechsle bitte zu einem größeren Bildschirm.</strong>',
    CP_LANDING_PAGE_RECOMMENDED_LINK: 'Empfehlungen',
    CP_LANDING_SEARCH_HEADLINE: 'Nach welchem Arbeitgeber suchst Du?',
    CP_LANDING_SEARCH_PLACEHOLDER: 'Unternehmensnamen eingeben',
    CP_LATEST_UPDATE_ADVERTISMENT: 'Letzte Neuigkeit',
    CP_LATEST_VACANCY_ADVERTISMENT: 'Letzte Stellenausschreibung',
    CP_LINKS_TRAFFIC_LABEL: 'Website-Links',
    CP_LINKS_TRAFFIC_SUBTITLE: 'Websites',
    CP_LO_INDUSTRY_COMPANIES_DESCRIPTION:
      'Alle Arbeitgeber der {industry}-Branche auf einen Blick: hier siehst Du, welche Unternehmen gerade offene Stellen haben, welche XING Mitglieder dort arbeiten, wie die Unternehmenskultur ist und was Mitarbeitenden geboten wird.',
    CP_LO_INDUSTRY_COMPANIES_DESCRIPTION_120000:
      'Rechne mit Deinem Erfolg: Vernetz Dich mit renommierten Banken, FinTechs und Investmentfirmen, die die Finanzwelt prägen und Dir spannende Karrierewege in der Welt der Zahlen eröffnen.',
    CP_LO_INDUSTRY_COMPANIES_DESCRIPTION_160000:
      'Entdeck Deine Möglichkeiten in der Beratung: Hier erhältst Du exklusive Einblicke in die Expertise führender Beratungsfirmen und findest Deinen Platz in einer Welt, die von strategischem Denken und Lösungsfindung lebt.',
    CP_LO_INDUSTRY_COMPANIES_DESCRIPTION_170000:
      'Lass Deiner Kreativität freien Lauf: bei Unternehmen und Agenturen bei denen Kreativität, Analytisches Denken und Vermarktungsstrategien zusammenkommen und Produktideen geboren werden.',
    CP_LO_INDUSTRY_COMPANIES_DESCRIPTION_20000:
      'Handle Dir die besten Karrierechancen ein: Entdeck Unternehmen und innovative Startups, die den Handel revolutionieren und Deine Ideen schätzen.',
    CP_LO_INDUSTRY_COMPANIES_DESCRIPTION_210000:
      'Setz auf das Zwischenmenschliche: das Gesundheitswesen bietet mehr als nur Jobs – sondern auch eine Bestimmung. Finde Arbeitgeber, die Wert auf ein gutes Arbeitsklima legen und zu Deiner persönlichen Weiterentwicklung beitragen möchten.',
    CP_LO_INDUSTRY_COMPANIES_DESCRIPTION_30000:
      'Fahr auf der Überholspur Deiner Karriere: Hier findest Du die Vordenker und Wegbereiter der Automobilbranche und siehst, wie die Mobilität von morgen gestaltet wird.',
    CP_LO_INDUSTRY_COMPANIES_DESCRIPTION_40000:
      'Bau auf Deinen beruflichen Erfolg: Hier findest Du die Welt des Maschinenbaus, in der präzise Ingenieurskunst auf innovative Fertigungstechnologien trifft und herausfordernde Projekte auf Dich warten.',
    CP_LO_INDUSTRY_COMPANIES_DESCRIPTION_90000:
      'Programmier Deine Zukunft: Finde auf XING IT-Firmen, bei denen Du Dich entwickeln kannst. Hier findest Du Innovation und technische Exzellenz.',
    CP_LO_INDUSTRY_COMPANIES_HEADER:
      'Alle Unternehmen aus der Branche {industry}',
    CP_LO_INDUSTRY_COMPANIES_LIST_TITLE: 'Unternehmen der Kategorie {section}',
    CP_LO_INDUSTRY_COMPANIES_META_DESCRIPTION:
      'Finde Arbeitgeber, die zu Dir passen, Jobs, die Spaß machen und Unternehmen, die Dich weiterbringen | Starte Deine Jobsuche auf XING',
    CP_LO_INDUSTRY_COMPANIES_META_TITLE:
      'Arbeitgeber auf XING | Jobs & Neuigkeiten | Kultur & Gehalt',
    CP_LO_INDUSTRY_COMPANIES_SEGMENTS_TITLE:
      'Welche Kategorie spricht Dich an?',
    CP_LOGGEDOUT_METADESCRIPTION:
      'Entdecke Arbeitgeber verschiedener Branchen und informier Dich über aktuelle Jobs, Leistungen für Mitarbeiter und Neuigkeiten der Unternehmen.',
    CP_MANAGED_COMPANIES_HEADER: 'Unternehmen, die Du verwaltest',
    'CP_MATCHING_JOB_ADS.one': '{count} Stellenangebot gefunden',
    'CP_MATCHING_JOB_ADS.other': '{count} Stellenangebote gefunden',
    'CP_MATCHING_JOB_ADS.zero': 'No job ads found',
    CP_MAXIMUM_FILE_SIZE_IMAGE_UPDATES:
      'Die maximale Größe für Bilder ist 10 MB. Am besten nutzen Sie als Format  jpg, jpeg oder png. Das ideale Seitenverhältnis ist 16:10, z. B. 720 x 450 Pixel.',
    CP_MAXIMUM_FILE_SIZE_TITLE_IMAGE_UPDATES: 'Bilder',
    CP_MAXIMUM_FILE_SIZE_TITLE_VIDEO_UPDATES: 'Videos',
    CP_MAXIMUM_FILE_SIZE_UPDATES_INFO_HINT: 'Info zu Bild- und Videoformaten',
    CP_MAXIMUM_FILE_SIZE_VIDEO_UPDATES:
      'Sie können Videos bis zu einer Größe von 5 GB hinzufügen. Akzeptierte Formate: .3gp, .avi, .flv, .m4v, .mkv, .mov, .mp4, .mpeg, .mpg, .mts, .vob, .webm, .wmv',
    CP_MORE_ABOUT_COMPANY: 'Weitere Infos zu diesem Arbeitgeber',
    CP_MORE_DETAILS: 'Weitere Arbeitgeber-Details',
    CP_MOST_VISITED_COMPANIES_CAPTION:
      'Schau Dir an, wer kürzlich das <span>Interesse der Nutzer·innen</span> geweckt hat',
    CP_MOST_VISITED_COMPANIES_SUBLINE:
      'Diese Arbeitgeber wurden in den letzten 24 Stunden am häufigsten besucht.',
    CP_MOST_VISITED_COMPANIES_TITLE: 'Meistbesuchte Arbeitgeber auf XING',
    CP_MY_COMPANIES_HOME: 'Zurück',
    CP_NEW_EMPLOYERS: 'Neue XING Seiten',
    CP_NEWSFEED_COMMENT: 'Kommentieren',
    CP_NEWSFEED_COMMENT_FAKE: 'Kommentieren ...',
    CP_NEWSFEED_COMMENT_LENGTH_ERROR:
      'Sie können maximal 600 Zeichen eingeben.',
    CP_NEWSFEED_LIKE: 'Gefällt mir',
    CP_NEWSFEED_LIKE_MORE: '{likers} gefällt das.',
    CP_NEWSFEED_LIKE_MORE_MYSELF: 'Dir und {other_likers} gefällt das.',
    CP_NEWSFEED_LIKE_ONE: '{liker} gefällt das.',
    CP_NEWSFEED_LIKE_ONE_MYSELF: 'Dir gefällt das.',
    CP_NEWSFEED_LIKE_OTHER: 'ein weiteres Mitglied',
    CP_NEWSFEED_LIKE_OTHERS: '{no_of_likers} weitere Mitglieder',
    CP_NEWSFEED_LIKE_PEOPLE: '{no_of_likers} Mitglieder',
    CP_NEWSFEED_REMOVE: 'Entfernen',
    CP_NEWSFEED_SHOW_ALL_COMMENTS: 'Alle #{count} Kommentare anzeigen',
    CP_NEWSFEED_SHOW_LESS_COMMENTS: '<span>Weniger</span>',
    CP_NEWSFEED_UNDO_LIKE: 'Gefällt Dir doch nicht?',
    CP_NEWSFEED_UNLIKE: 'Gefällt mir nicht mehr',
    CP_NO_MORE_EDITORS_ALLOWED:
      'Leider können keine weiteren Editoren hinzugefügt werden.',
    CP_NUM_JOB_OFFERS: '{num} Stellenangebote',
    CP_OPEN_PRESENTATION_HINT: 'Folien ansehen (in neuem Tab)',
    CP_OPEN_VIDEO_HINT: 'Video ansehen (in neuem Tab)',
    CP_OPTIONS_DELETE: 'Löschen',
    CP_OPTIONS_EDIT: 'Bearbeiten',
    CP_OTHER_COMPANIES_FOLLOW: 'Weitere Unternehmen, denen Du folgst',
    CP_OTHER_COMPANIES_MANAGE: 'Mehr Unternehmen, die Du verwaltest',
    CP_OTHER_INTERESTING_COMPANIES: 'Weitere interessante Unternehmen',
    'CP_OVERVIEW_BRANDMANAGER_SECTION_BOX.CREATE':
      'Dein Unternehmen ist noch nicht auf XING? Macht nichts. Erstell kostenlos ein Profil!',
    'CP_OVERVIEW_BRANDMANAGER_SECTION_BOX.FINALIZE':
      'Fast fertig! Füg noch die letzten Details für Dein kostenloses Unternehmensprofil ein.',
    'CP_OVERVIEW_BRANDMANAGER_SECTION_BOX.MANAGE':
      'Dein Unternehmen auf XING: Bearbeite und verwalte hier alle Details.',
    'CP_OVERVIEW_BRANDMANAGER_SECTION_BUTTON.CREATE':
      'Unternehmensprofil anlegen',
    'CP_OVERVIEW_BRANDMANAGER_SECTION_BUTTON.FINALIZE':
      'Unternehmensprofil fertigstellen',
    'CP_OVERVIEW_BRANDMANAGER_SECTION_BUTTON.MANAGE': 'Zum Unternehmensprofil',
    CP_OVERVIEW_RECOMMENDATIONS_DESCRIPTION:
      'Empfehlungen passend zu Deinem Profil, Deinen Suchen und Deinen Job-Wünschen.',
    CP_OVERVIEW_RECOMMENDATIONS_LOAD_MORE_CTA: 'Mehr davon',
    CP_OVERVIEW_RECOMMENDATIONS_TITLE: 'Arbeitgeber, die zu Dir passen',
    CP_PAGE_CREATION_GENERIC_ERROR:
      'Das hat gerade leider nicht geklappt ... versuchen Sie es bitte nochmal.',
    CP_PAGE_CREATION_INDUSTRY_ID_INVALID:
      'Bitte wähl eine der vorgegebenen Branchen aus.',
    CP_PAGE_CREATION_NAME_ALREADY_USED:
      "Eine XING Seite mit diesem Namen gibt's schon. Hat vielleicht jemand anders Ihre Seite bereits erstellt?",
    CP_PAGE_CREATION_NAME_INVALID_CHARACTERS:
      'Bitte verwenden Sie hier nur Buchstaben und Ziffern, keine Sonderzeichen.',
    CP_PAGE_CREATION_NAME_ONLY_NUMBERS:
      'Ihr Name darf nicht nur Ziffern enthalten. Bitte geben Sie auch Buchstaben ein.',
    CP_PAGE_CREATION_NAME_TOO_LONG:
      'Dieser Name ist leider zu lang: Bis zu 80 Zeichen sind möglich.',
    CP_PAGE_CREATION_NAME_TOO_SHORT:
      'Dieser Name ist leider zu kurz: Mindestens zwei Zeichen sollten es sein.',
    CP_PAGE_CREATION_PARAMETER_REQUIRED: 'Pflichtfeld',
    CP_PAGE_CREATION_SIZE_ID_INVALID:
      'Bitte wähl eine der vorgegebenen Unternehmensgrößen aus.',
    CP_PAGINATION_LEFT: 'Vorherige Seite',
    CP_PAGINATION_RIGHT: 'Nächste Seite',
    CP_PDF_DOWNLOAD_INFO_TEXT:
      'Nützliche Informationen und Anleitungen zu Unternehmensprofilen als PDF',
    CP_PMBX_CLAIMER_SINCE: 'Editor seit',
    CP_PMBX_CLAIMERS_TITLE: 'Arbeitgeberprofile, deren Editor Sie sind',
    CP_PMBX_COMPANY_NAME: 'Unternehmen',
    CP_PMBX_CONTACT_DESCRIPTION: 'Beschreibung',
    CP_PMBX_CONTACT_EMAIL: 'E-Mail',
    CP_PMBX_CONTACT_PHONE: 'Telefon',
    CP_PMBX_CONTACT_SINCE: 'Kontakt seit',
    CP_PMBX_CONTACTS_TITLE:
      'Arbeitgeberprofile, in denen Sie als Kontaktperson eingetragen sind',
    CP_PMBX_EMPLOYMENTS_TITLE:
      'XING Seiten, auf denen Du unter den Mitarbeitenden erscheinst',
    CP_PMBX_FEED_URL: 'Link (URL) des XML-Feeds',
    CP_PMBX_FEEDS_TITLE: 'Ihre Einträge von XML-Feeds für Arbeitgeberprofile',
    CP_PMBX_FOLLOWERS_TITLE: 'Arbeitgeberprofile, denen Du folgst',
    CP_PMBX_FOLLOWING_SINCE: 'Follower seit',
    CP_PMBX_NO_DATA_REASON:
      'Im Bereich Arbeitgeberprofile haben wir keine Daten über Sie gespeichert.',
    CP_PMBX_TEMPORARY_CLAIMER_CREATED_AT: 'Erstellt am',
    CP_PMBX_TEMPORARY_CLAIMER_EXPIRED_AT: 'Abgelaufen am',
    CP_PMBX_TEMPORARY_CLAIMER_SUBTITLE:
      'Unternehmensprofile, für die Sie zeitweise Antragsteller waren',
    CP_PMBX_TITLE: 'Arbeitgeberprofile',
    CP_PMBX_UPDATE_HEADLINE: 'Überschrift',
    CP_PMBX_UPDATE_POSTED_ON: 'Veröffentlicht am',
    CP_PMBX_UPDATES_BODY: 'Text',
    CP_PMBX_UPDATES_IMAGE: 'Bild',
    CP_PMBX_UPDATES_TITLE: 'Unternehmens-Neuigkeiten, die Sie erstellt haben',
    CP_POSITION_IN_USE_ERROR:
      'Dieses Modul ist gerade erst geändert worden. Aktualisieren Sie diese Seite, um die Änderung zu sehen.',
    CP_PRODUCTS_AND_SERVICES_TITLE: 'Produkte und Services',
    CP_PRODUCTS_GALLERY_PLACEHOLDER:
      'Veranschaulichen Sie Ihr Angebot mit Bildern, Videos und PDF-Dokumenten.',
    CP_PRODUCTS_GALLERY_PLACEHOLDER_TITLE:
      'Zeigen Sie, was Sie Kunden zu bieten haben.',
    CP_PRODUCTS_PLACEHOLDER:
      'Präsentieren Sie hier Ihr Produktportfolio bzw. Ihr Dienstleistungsangebot.',
    CP_PRODUCTS_PLACEHOLDER_TITLE:
      'Erzählen Sie, was Sie Kunden zu bieten haben.',
    CP_QUOTE_PLACEHOLDER:
      'Ihr Selbstverständnis als Arbeitgeber: Was macht Sie einzigartig?',
    CP_RECENTLY_CLAIMED_COMPANIES_CAPTION:
      'Schau Dir an, welche Unternehmen <span>neuerdings</span> auf der Plattform sind',
    CP_RECENTLY_CLAIMED_COMPANIES_TITLE:
      'Diese Arbeitgeber sind jetzt auch bei XING',
    CP_RECOMMENDED_COMPANIES_HEADER:
      "Welcher Arbeitgeber bietet was? Wer ist schon dort? Und was gibt's Neues? Hier erfährst Du's:",
    CP_RECOMMENDS_ADVERTISEMENT_ABOUT_US:
      'XING empfiehlt folgende Unternehmen:',
    CP_RECOMMENDS_ADVERTISMENT: 'XING empfiehlt:',
    CP_RECOVER_PROFILE_ACTION_BUTTON: 'Freischaltung beantragen',
    CP_RECOVER_PROFILE_BODY:
      'Auf dieser Seite präsentiert sich Dein Unternehmen auf XING als Arbeitgeber. Leider ist für die Seite derzeit kein Editor eingetragen. Du kannst jetzt aber für Dich die Freischaltung als Editor beantragen.',
    CP_RECOVER_PROFILE_HEADLINE:
      'Dies ist die Seite Deines Unternehmens ... und sie hat derzeit keinen Editor!',
    CP_REDIRECT_PERMISSIONS_DIALOG_BUTTON: 'Alles klar',
    CP_REDIRECT_PERMISSIONS_DIALOG_MESSAGE:
      'Bitte kontaktieren Sie Ihre·n Admin, um Editier-Rechte für dieses Unternehmensprofil zu erhalten.',
    CP_REDIRECT_PERMISSIONS_DIALOG_TITLE:
      'Sie können dieses Profil nicht bearbeiten.',
    CP_REMOVE_IDEAL_EMPLOYER_FAILURE:
      'Das hat leider nicht geklappt ... kannst Du es bitte nochmal versuchen?',
    CP_REMOVE_IDEAL_EMPLOYER_SUCCESS: 'Wunsch-Arbeitgeber entfernt',
    CP_REMOVE_JOB_BOOKMARK_FAILURE:
      'Das hat leider nicht geklappt ... Kannst Du es bitte nochmal versuchen?',
    CP_REMOVE_JOB_BOOKMARK_SUCCESS: 'Aus Merkliste entfernt',
    CP_REQUEST_APPROVAL: 'Veröffentlichung beantragen',
    CP_REQUEST_EBP_PUBLICATION_BANNER_CONTENT:
      'Wir haben Ihnen ein paar Tipps an <span>{email_address}</span> geschickt, die Ihnen dabei helfen. Sobald Sie alle Pflichtfelder ausgefüllt haben, können Sie Ihr Arbeitgeberprofil mit Klick auf "Veröffentlichen" für andere sichtbar machen.',
    CP_REQUEST_EBP_PUBLICATION_BANNER_HEADLINE:
      'Erfüllen Sie Ihr Arbeitgeberprofil jetzt mit Leben.',
    CP_REQUEST_PUBLICATION_BANNER_CONTENT:
      'Bitte füllen Sie Ihr Arbeitgeberprofil ausführlich aus. Achten Sie dabei bitte auf die gekennzeichneten Pflichtangaben. Für eine professionelle Darstellung im XING Netzwerk empfehlen wir Ihnen auch die Verwendung Ihres aktuellen Logos. \n<span>Klicken Sie abschließend auf „Veröffentlichung beantragen“</span>, um die Richtigkeit Ihrer Angaben zu bestätigen. Erst dann können wir Ihr Profil prüfen und werden es in der Regel innerhalb von 72 Stunden freigeben. \n\nWeitere nützliche Tipps zu Ihrem XING Arbeitgeberprofil haben wir soeben an Ihre E-Mail-Adresse <span>{email_address}</span> gesendet.\n',
    CP_REQUEST_PUBLICATION_BANNER_HEADLINE:
      'Willkommen! Ihr Arbeitgeberprofil ist nur ein paar Schritte entfernt.',
    CP_REQUEST_PUBLICATION_SENT_CONTENT:
      'Ihr XING Arbeitgeberprofil wird nun von uns geprüft. Wir benachrichtigen Sie innerhalb von 72 Stunden per E-Mail an <span>{email_address}</span>, sobald Ihr Profil für alle XING Mitglieder sichtbar ist.   ',
    CP_REQUEST_PUBLICATION_SENT_HEADLINE:
      'Vielen Dank! Ihre Anfrage wurde gesendet.',
    CP_REQUESTER_NOT_AUTHORIZED:
      'Leider hat der Antragsteller hierfür nicht die notwendige Berechtigung.',
    CP_REVIEWS_BADGES_OPEN_LINK_TITLE: 'Mehr Infos zum Siegel "Open company"',
    CP_REVIEWS_BADGES_TOP_LINK_TITLE: 'Mehr Infos zum Siegel "Top company"',
    CP_REVIEWS_BADGES_WIDGET_TITLE: 'Auszeichnungen',
    CP_REVIEWS_BENEFITS_1: 'Flexible Arbeitszeiten',
    CP_REVIEWS_BENEFITS_10: 'Coaching',
    CP_REVIEWS_BENEFITS_11: 'Parkplatz',
    CP_REVIEWS_BENEFITS_12: 'Günstige Anbindung',
    CP_REVIEWS_BENEFITS_13: 'Spezielle Rabatte',
    CP_REVIEWS_BENEFITS_14: 'Firmenwagen',
    CP_REVIEWS_BENEFITS_15: 'Eigenes Handy',
    CP_REVIEWS_BENEFITS_16: 'Gewinnbeteiligung',
    CP_REVIEWS_BENEFITS_17: 'Interne Events',
    CP_REVIEWS_BENEFITS_18: 'Internetnutzung',
    CP_REVIEWS_BENEFITS_19: 'Hunde willkommen',
    CP_REVIEWS_BENEFITS_2: 'Home-Office',
    CP_REVIEWS_BENEFITS_3: 'Kantine',
    CP_REVIEWS_BENEFITS_4: 'Essenszulagen',
    CP_REVIEWS_BENEFITS_5: 'Kinderbetreuung',
    CP_REVIEWS_BENEFITS_6: 'Betr. Altersversorgung',
    CP_REVIEWS_BENEFITS_7: 'Barrierefreiheit',
    CP_REVIEWS_BENEFITS_8: 'Gesundheitsmaßnahmen',
    CP_REVIEWS_BENEFITS_9: 'Betriebsarzt',
    CP_REVIEWS_BENEFITS_HEADLINE: 'Besondere Vorteile',
    CP_REVIEWS_BENEFITS_NO_TITLE: '{rating_avg} von 5',
    CP_REVIEWS_BENEFITS_PLACEHOLDER_BUTTON: 'Arbeitgeber bewerten',
    CP_REVIEWS_BENEFITS_PLACEHOLDER_TEXT:
      'Bisher wurden noch keine Vorteile für Mitarbeiter angegeben. Das kannst Du jetzt ändern, mit Deiner Bewertung.',
    CP_REVIEWS_BENEFITS_TOOLTIP: 'Von {employees} Mitarbeitenden bestätigt',
    CP_REVIEWS_RATINGS_1: 'Vorgesetztenverhalten',
    CP_REVIEWS_RATINGS_10: 'Einklang von Berufs- & Privatleben',
    CP_REVIEWS_RATINGS_11: 'Image',
    CP_REVIEWS_RATINGS_12: 'Umgang mit Kolleg·innen 45+',
    CP_REVIEWS_RATINGS_13: 'Umwelt- & soziales Bewusstsein',
    CP_REVIEWS_RATINGS_2: 'Kollegialer Zusammenhalt',
    CP_REVIEWS_RATINGS_3: 'Interessante Aufgaben',
    CP_REVIEWS_RATINGS_4: 'Arbeitsatmosphäre',
    CP_REVIEWS_RATINGS_5: 'Interne Kommunikation',
    CP_REVIEWS_RATINGS_6: 'Gleichberechtigung',
    CP_REVIEWS_RATINGS_7: 'Karriere & Weiterbildung',
    CP_REVIEWS_RATINGS_8: 'Gehalt & Zulagen',
    CP_REVIEWS_RATINGS_9: 'Räume, Ausstattung, Arbeitsmaterial',
    CP_REVIEWS_RATINGS_HEADING: 'Die Arbeitgeber-Bewertung im Detail',
    CP_REVIEWS_RATINGS_STANDARD: 'Mittelwert dieser Branche: <b>{rating}</b>',
    CP_REVIEWS_REPORTS_CURRENT_JOB:
      'Derzeit als {title} im Bereich {department} tätig',
    CP_REVIEWS_REPORTS_PAST_JOB:
      'War bis zum {date} als {title} im Bereich {department} tätig',
    CP_REVIEWS_REPORTS_REPORT_LINK: 'Weiterlesen ...',
    CP_REVIEWS_REPORTS_STATEMENT_LINK: 'Antwort des Arbeitgebers',
    CP_REVIEWS_REVIEW_ORDER_BY: 'Sortieren:',
    CP_REVIEWS_REVIEWS_CRITICAL_ONES: 'Negative zuerst',
    CP_REVIEWS_REVIEWS_HEADING: 'Erfahrungsberichte von Mitarbeitenden',
    CP_REVIEWS_REVIEWS_NEWEST: 'Neueste zuerst',
    CP_REVIEWS_REVIEWS_NO_TITLE: '{rating_avg} von 5',
    CP_REVIEWS_REVIEWS_POSITIVE_ONES: 'Positive zuerst',
    CP_ROLLOUT_BANNER_DRAFT_CONTENT:
      'Vervollständigen Sie alle relevanten Informationen Ihres Unternehmens, damit die Umstellung auf Ihr neues Arbeitgeberprofil optimal verläuft.',
    CP_ROLLOUT_BANNER_DRAFT_HEADER:
      'Schließen Sie die Bearbeitung Ihres neuen Arbeitgeberprofils ab',
    CP_ROLLOUT_BANNER_DRAFT_REDIRECT: 'Arbeitgeberprofil fertigstellen',
    CP_ROLLOUT_BANNER_LEGEND_INFO:
      'Bitte beachten Sie, dass Sie nicht mehr in das alte Design wechseln können.',
    CP_ROLLOUT_BANNER_MOBILE:
      '<p><strong>Frischer Wind für Ihr Arbeitgeberprofil!</strong> Verwenden Sie bitte einen größeren Bildschirm, um zum neuen Design zu wechseln.</p>',
    CP_ROLLOUT_BANNER_SWITCH_NEW_DESIGN: 'Zum neuen Design wechseln',
    CP_ROLLOUT_INFOTEXT_FIRST:
      'In Kürze werden alle Arbeitgeberprofile automatisch ins neue Design konvertiert.<br /><br /> Ergreifen Sie bereits jetzt die Chance, Ihre Inhalte zu überprüfen und anzupassen. So stellen Sie sicher, dass Ihr Arbeitgeberprofil für den Wechsel gut gerüstet ist und alle essenziellen Informationen verfügbar sind.',
    CP_ROLLOUT_INFOTEXT_SECOND:
      'Ermöglichen Sie Ihrer Zielgruppe, Sie direkt über Ihr Arbeitgeberprofil zu kontaktieren.',
    CP_ROLLOUT_INFOTEXT_THIRD:
      'Steigern Sie Ihren Wiedererkennungswert mithilfe von individuelleren Anpassungsmöglichkeiten.',
    CP_ROLLOUT_POPUP_BUTTON: 'Im Entwurfsmodus öffnen',
    CP_ROLLOUT_POPUP_FOOTER_NOTE:
      'Bei dieser Umstellung übernehmen wir all Ihre bisherigen Daten.',
    CP_ROLLOUT_POPUP_HEADER: 'Frischer Wind für Ihr Arbeitgeberprofil!',
    CP_ROLLOUT_POPUP_HEADER_BANNER:
      'Rüsten Sie Ihr Arbeitgeberprofil für das neue Design!',
    CP_ROLLOUT_POPUP_INFOTEXT_PRINCIPAL:
      'Sind Sie bereit, alle Vorzüge Ihres neuen Arbeitgeberprofils zu nutzen?',
    CP_SALES_PAGE_COMMUNICATION_TITLE:
      'Kommunizieren Sie mit Ihrer Zielgruppe.',
    CP_SALES_PAGE_EBP_INFO_TITLE: 'Für Profis: Das Employer Branding-Profil',
    CP_SALES_PAGE_EBP_PRICE: 'Ab {price} pro Monat',
    CP_SALES_PAGE_EBP_TEXT:
      '<p>Was zeichnet Sie als Arbeitgeber aus? Moderne Büroräume? Flexible Arbeitszeiten? Kinderbetreuung?</p>\n<p>Zeigen Sie Ihre Vorteile auf Ihrem <strong>Employer Branding-Profil</strong> und präsentieren Sie sich so als Wunsch-Arbeitgeber.</p>',
    CP_SALES_PAGE_EBP_TITLE: 'Zeigen Sie, was Sie zu bieten haben.',
    CP_SALES_PAGE_FREE_TEXT:
      '<p>Steht Ihnen derzeit kein Budget für Employer Branding zur Verfügung? Dann können Sie auf XING zunächst ein <strong>Gratisprofil</strong> anlegen, das einige der Grundfunktionen des Employer Branding-Profils bietet.</p>',
    CP_SALES_PAGE_FREE_TITLE: 'Für Minimalisten: Das Gratisprofil',
    CP_SALES_PAGE_HEADER_NEW: 'Zeigen Sie Ihre Stärken als Arbeitgeber.',
    CP_SALES_PAGE_HEADER_SCREENSHOT:
      'Zeigen Sie, was Sie als Arbeitgeber auszeichnet.',
    CP_SALES_PAGE_HEADER_SCREENSHOT_BOTTOM:
      'Stellen Sie Ihre Vorteile für Mitarbeitende heraus.',
    CP_SALES_PAGE_MORE_TEXT:
      'Eine Übersicht zum Employer Branding-Profil können Sie auch als PDF herunterladen:',
    CP_SALES_PAGE_STAGE_SCREENSHOT_1:
      'Gewähren Sie Einblicke in den Arbeitsalltag.',
    CP_SALES_PAGE_STAGE_SCREENSHOT_2:
      'Erfahren Sie, wie Sie als Arbeitgeber bewertet werden.',
    CP_SALES_PAGE_STAGE_SCREENSHOT_3:
      'Präsentieren Sie Daten und Fakten übersichtlich und ansprechend.',
    CP_SALES_PAGE_STAGE_SUBTITLE:
      'Erzählen Sie, warum Ihre Mitarbeiter gern bei Ihnen arbeiten –<br>\nmit Bildern, Videos und Texten.',
    CP_SALES_PAGE_STAGE_TITLE: 'Machen Sie Ihr Unternehmen erlebbar.',
    CP_SALES_PAGE_STEPS_MODULE_1:
      'Fragen Sie bei uns ein Employer Branding Profil an.',
    CP_SALES_PAGE_STEPS_MODULE_3:
      'Präsentieren Sie sich als Wunsch-Arbeitgeber.',
    CP_SALES_PAGE_STEPS_MODULE_TITLE: "Und so funktioniert's:",
    CP_SALES_PAGE_SUBHEADER: 'Das Employer Branding-Profil für Ihr Unternehmen',
    CP_SALES_PAGE_VISIBILITY_TITLE:
      'Steigern Sie Ihre Sichtbarkeit im Internet.',
    CP_SEARCH_ENGINES_TRAFFIC_LABEL: 'Suchmaschinen',
    CP_SEARCH_ENGINES_TRAFFIC_SUBTITLE: 'Suchbegriffe',
    CP_SEE_ALL_INDUSTRIES: 'Alle Branchen im Überblick',
    CP_SHOW_ALL: 'Alle anzeigen',
    CP_SHOW_MORE_COMPANIES: 'Mehr interessante Unternehmen',
    CP_SOCIAL_TRAFFIC_LABEL: 'Soziale Netzwerke',
    CP_SOCIAL_TRAFFIC_SUBTITLE: 'Soziale Netzwerke',
    CP_STATISTICS_ALL_FACTS_FIGURES: 'Alle Zahlen & Daten',
    CP_TEAMPERMISSIONS: 'Team verwalten',
    CP_TEMPORARY_CLAIMER_BUTTON_ENABLE: 'Unternehmen freischalten',
    CP_TEMPORARY_CLAIMER_BUTTON_OPEN: 'Im BrandManager öffnen',
    CP_TEMPORARY_CLAIMER_CHECKBOX: 'Ich habe alle Infos gelesen:',
    CP_TEMPORARY_CLAIMER_CREATED:
      'Das Unternehmen "{company_name}" wurde für Dich für die nächsten 30 Minuten freigeschaltet.',
    CP_TEMPORARY_CLAIMER_CREATION_FAILED:
      'Das hat leider nicht geklappt: {message}',
    CP_TEMPORARY_CLAIMER_CREATION_FAILED_TOS:
      'Bitte akzeptiere noch die Nutzungsbedingungen.',
    CP_TEMPORARY_CLAIMER_HEADLINE: 'Zugang für Kundenpräsentation freischalten',
    CP_TEMPORARY_CLAIMER_INFO:
      'Du bist jetzt für 30 Minuten Administrator für das Unternehmensprofil "{company_name}". Deine Änderungen sind live auf dem Unternehmensprofil zu sehen und können nachverfolgt werden.',
    CP_TEMPORARY_CLAIMER_SUBHEADLINE:
      'Setz Dich als Unternehmens-Editor von "{company_name}" ein. Dann kannst Du Deinem Kunden unseren BrandManager zeigen.',
    'CP_TOP_COMPANIES_CARD_BUTTON.one': '{value} Job ansehen',
    'CP_TOP_COMPANIES_CARD_BUTTON.other': '{value} Jobs ansehen',
    CP_TOP_COMPANIES_SECTION_SUBTITLE:
      'Entdecke Arbeitgeber, die zu Dir passen.',
    CP_TOP_COMPANIES_SECTION_TITLE: 'Beliebte Arbeitgeber auf XING',
    CP_TOTAL_COMPANIES: '{total} Unternehmen',
    CP_UNFOLLOW_COMPANY_FAILURE:
      'Das hat leider nicht geklappt ... kannst Du es bitte nochmal versuchen?',
    CP_UNFOLLOW_COMPANY_SUCCESS:
      'Du folgst diesem Arbeitgeber jetzt nicht mehr.',
    CP_UNKNOWN_XING_USER: 'Dieses Mitglied haben wir nicht erkannt.',
    CP_UPDATES_PROMOTE_ARTICLE: 'Neuigkeit bewerben',
    CP_UPDATES_SHOW_STATISTICS: 'Statistiken anzeigen',
    CP_UPDATES_UPLOADING_ASSET_DESCRIPTION:
      'Einen Moment bitte ... Ihre Datei wird gerade hochgeladen.',
    CP_UPDATES_UPLOADING_IMAGE: 'Bild wird hochgeladen ...',
    CP_UPLOAD_IMAGE_ERROR:
      'Das hat gerade leider nicht geklappt. Können Sie es bitte noch einmal probieren?',
    CP_UPLOAD_RESTRICTIONS:
      '<span class="{block}">JPG, GIF, BMP, PNG, max. <strong>{weight} MB</strong></span>\nRGB (kein CMYK), Idealgröße: <strong>{dimensions}</strong>',
    CP_UPLOAD_VIDEO_ERROR:
      'Das Video konnte gerade leider nicht hochgeladen werden. Können Sie es noch einmal versuchen?',
    CP_UPSELL_HINT:
      'Diese Information ist nur für Editoren des Unternehmensprofils sichtbar.',
    CP_UPSELL_LINK_TITLE: 'Mehr Infos zum Employer Branding-Profil',
    CP_USER_IS_NOT_PAYING_EDITOR:
      'Diese Person ist nicht der zahlungsberechtigte Editor dieser XING Seite.',
    CP_VIDEO_UPDATE_PLACEHOLDER_BODY:
      'Das kann einen kleinen Moment dauern – vielleicht die ideale Gelegenheit für eine kurze Kaffeepause? Laden Sie dann einfach diese Seite neu, um zu schauen, ob das Video fertig aufbereitet ist.',
    CP_VIDEO_UPDATE_PLACEHOLDER_TITLE: 'Wir bereiten gerade Ihr Video auf ...',
    CP_VISIT_COMPANY_ADVERTISMENT: 'Zum Unternehmen',
    CP_WANT_TO_CONNECT: 'Arbeitet hier:',
    CP_WORKING_HERE: 'Diese Kontakte arbeiten hier:',
    CP_XING_TRAFFIC_LABEL: 'XING',
    CP_XING_TRAFFIC_SUBTITLE: 'XING-Bereiche',
    CP_XTP_IDEAL_EMPLOYER_CONFIRM_LANDING_BODY:
      'Wir behandeln Dein Interesse streng vertraulich und geben es nicht an Dritte weiter.',
    CP_XTP_IDEAL_EMPLOYER_CONFIRM_LANDING_HEADER:
      'Danke, dass Du {company_name} als Deinen Wunsch-Arbeitgeber angegeben hast.',
    CP_XTP_SURVEY_LANDING_CONTENT:
      'Die Wunsch-Arbeitgeber-Funktion ist neu auf XING. Und Du kannst dabei helfen, sie weiter zu verbessern, indem Du uns ein paar einfache Fragen beantwortest. Wir freuen uns, wenn Du Dir dafür fünf Minuten Zeit nimmst. Vielen Dank im Voraus.',
    CP_XTP_SURVEY_LANDING_CTA: 'Weiter zur Umfrage',
    CP_XTP_SURVEY_LANDING_FEEDBACK_BODY:
      'Wir haben die Personalabteilung von {company_name} über Dein Interesse informiert.',
    CP_XTP_SURVEY_LANDING_FEEDBACK_HEADER:
      'Danke, dass Du {company_name} als Deinen Wunsch-Arbeitgeber angegeben hast.',
    CP_XTP_SURVEY_LANDING_HEADLINE: 'Deine Meinung ist uns wichtig!',
    CP_XTP_SURVEY_LANDING_SEARCH_HEADER:
      'Manchmal kommt das Beste erst zum Schluss.',
    CP_XTP_SURVEY_LANDING_SEARCH_PLACEHOLDER:
      'Position oder Stichwort eingeben',
    CP_XTP_SURVEY_LANDING_SEARCH_SUBHEADER: 'Zum Beispiel Dein neuer Traumjob.',
    CP_XTP_SURVEY_LANDING_UNSUBSCRIBE_CONTENT:
      'Entdecke jetzt weitere spannende Arbeitgeber direkt <a href="{jobs_link}">bei XING Jobs</a>.',
    CP_XTP_SURVEY_LANDING_UNSUBSCRIBE_HEADLINE:
      'Deine Wunsch-Arbeitgeber-Einstellung wurde gelöscht.',
    CP_XTP_SURVEY_SHOW_INTEREST_LIGHTBOX_COPY:
      '<p>für Dein Interesse an {company_name} als Wunsch-Arbeitgeber.</p>\n<p>Wir haben Dein Interesse an die Personalabteilung von {company_name} weitergeleitet.</p>\n <p>Hinweis: Die Wunsch-Arbeitgeber-Funktion ist noch recht neu auf XING. Du kannst dabei helfen, sie weiter zu verbessern, indem Du uns ein paar einfache Fragen beantwortest. Wir freuen uns, wenn Du Dir dafür fünf Minuten Zeit nimmst. Vielen Dank im Voraus.</p>',
    CP_XTP_SURVEY_SHOW_INTEREST_LIGHTBOX_CTA1: 'Zur Umfrage',
    CP_XTP_SURVEY_SHOW_INTEREST_LIGHTBOX_CTA2: 'Zurück',
    CP_XTP_SURVEY_SHOW_INTEREST_LIGHTBOX_HEADLINE: 'Vielen Dank',
    CREATE_ACCOUNT_HINT: 'Verwalte hier Dein XING Benutzerkonto.',
    CROSSPOST_SHARE_ERROR:
      'Bitte nicht übertreiben. Du hast den Beitrag schon in 3 Gruppen geteilt.',
    DATA_PROTECTION: 'Datenfreigabe bearbeiten',
    DAY_NAMES: 'Montag,Dienstag,Mittwoch,Donnerstag,Freitag,Samstag,Sonntag',
    DAY_NAMES_SHORT: 'Mo,Di,Mi,Do,Fr,Sa,So',
    DEGREE: 'Abschluss',
    DESC_POS: 'Beschreibe Deine Position',
    DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_CONFIRM: 'Ja, deaktivieren',
    DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_HEADLINE: '@-Erwähnung deaktivieren?',
    DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_TEXT:
      'Dein Name wird hier dann nicht mehr mit Deinem Profil verlinkt.',
    DONT_REMIND: 'Bitte nicht mehr erinnern.',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_COMPANIES: 'Ein Unternehmen',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_EVENTS: 'Ein Event',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_GROUPS: 'Eine Gruppe',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_JOBS: 'Einen Job',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_MEMBERS: 'Eine Person',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_NEWS: 'Einen Artikel',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_TOPICS: 'Ein Thema',
    DS_PREDICTIVE_SEARCH_QUERY_SUGGESTIONS_JOBS: 'Entdecke {keyword}-Jobs.',
    DS_PREDICTIVE_SEARCH_QUERY_SUGGESTIONS_JOBS_SHORT:
      '{keyword}-Jobs entdecken',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_INCREMENTAL_SEARCH: 'Suchvorschläge',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_NAVIGATION_SUGGESTIONS: 'Was suchst Du?',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_QUERY_SUGGESTION: 'Suchvorschläge',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_RECENT_INTERACTIONS:
      'Profile, die Du besucht hast',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_RECENT_SEARCHES:
      'Deine letzten Job-Suchen',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_RECOMMENDATION: 'Empfehlungen',
    DUPLICATE_SHARE_ERROR:
      'Du hast dies schon geteilt – Dein Netzwerk ist also bestens informiert.',
    EBP_HEADERGRAPHIC_LINK: 'Link der Headergrafik',
    EBP_HEADERGRAPHIC_LINK_PLACEHOLDER:
      'Fügen Sie hier den Link für Ihr Titelbild ein.',
    EBP_UPLOAD_HEADERGRAPHIC: 'Headergrafik hochladen',
    EDIT_JOB_COMPANY: 'Tätigkeit bei &quot;{-company}&quot; bearbeiten',
    EDIT_JOB_HEADER: 'Tätigkeit bei &quot;{-company}&quot; bearbeiten',
    EDIT_MOTIVATIONS: 'Gründe bearbeiten',
    EDIT_SCHOOL: 'Hochschule &quot;{-name}&quot; bearbeiten',
    EDIT_SCHOOL_HEADER: 'Hochschule "{-name}" bearbeiten',
    EDIT_WIDGET_EMAILS_LABEL_ADDITIONAL: 'Sonstige',
    EDIT_WIDGET_EMAILS_LABEL_BUSINESS: 'Geschäftlich',
    EDIT_WIDGET_EMAILS_LABEL_PRIVATE: 'Privat',
    EDIT_WIDGET_UNSAVED_CHANGES: 'ungespeicherte Änderung(en)',
    EDUCATION: 'Ausbildung',
    EMAIL_PREFS: 'E-Mail-Einstellungen',
    EMAILS_ACTIVATE: 'Für Benachrichtigungen aktivieren',
    EMAILS_ACTIVATED_BODY:
      'Die E-Mail-Adresse <strong>&quot;{-email_for_flash}&quot;</strong> wurde erfolgreich aktiviert.',
    EMAILS_ACTIVATED_HEADER: 'Aktivierung erfolgreich',
    EMAILS_ACTIVATION_EMAIL_BODY:
      'Die E-Mail-Adresse <strong>&quot;{-email_for_flash}&quot;</strong> konnte nicht als Benachrichtigungs-Adresse übernommen werden, da sie noch nicht bestätigt wurde. Wir haben jedoch eine Bestätigungs-Mail an diese Adresse gesendet. Bitte ruf die E-Mail ab und klick auf den Bestätigungs-Link. Nach erfolgreicher Bestätigung der neuen Adresse wird diese als Benachrichtigungs-Adresse aktiviert.<br/>\nDiese Maßnahme dient Deiner Sicherheit und verhindert Spam.',
    EMAILS_ACTIVATION_EMAIL_HEADER: 'Du hast Post',
    EMAILS_ACTIVE: 'aktive Benachrichtigungs-Adresse',
    EMAILS_ADDITONAL_INFO:
      '<strong>Hinweis:</strong> Deine zusätzlichen E-Mail-Adressen sind für andere XING Mitglieder nicht sichtbar. Du kannst sie jedoch als Deine Benachrichtigungs-Adresse verwenden. Deine zusätzlichen E-Mail-Adressen werden außerdem bei Adressbuch-Abgleichen berücksichtigt, d. h., Du kannst leichter auf XING gefunden werden.',
    EMAILS_CHANGE_ACTIVE_BODY:
      'Um Deine aktive Benachrichtigungs-Adresse in\n<strong>&quot;{-email_for_flash}&quot;</strong> zu ändern, haben wir Dir eine E-Mail mit einem Bestätigungs-Link geschickt. Die Änderung wird übernommen, sobald Du auf diesen Link klickst!',
    EMAILS_CONFIRM: 'Bestätigen',
    EMAILS_CONFIRMATION_EMAIL_BODY:
      'Wir haben Dir eine E-Mail an <strong>&quot;{-email_for_flash}&quot;</strong> geschickt. Bitte klick auf den Link in dieser E-Mail, um Deine neue E-Mail-Adresse zu aktivieren.',
    EMAILS_CONFIRMED: 'bestätigt',
    EMAILS_CONFIRMED_BODY:
      'Die E-Mail-Adresse <strong>&quot;{-email_for_flash}&quot;</strong> wurde bestätigt.',
    EMAILS_DELIVERY_EMAIL_INFO:
      '<strong>Hinweis</strong>: Bitte beachte, dass die Zustellung der Bestätigungs-E-Mail je nach E-Mail-Provider mehrere Minuten dauern kann. XING hat hierauf keinen Einfluss.',
    EMAILS_NOT_VISIBLE: 'nicht sichtbar für andere',
    EMAILS_UNCONFIRMED: 'nicht bestätigt',
    ENTER_BIRTHDAY_HINT:
      'Gib Deinen Geburtstag an, damit Deine Kontakte Dir gratulieren können.',
    ENTER_COMPANY: 'Bitte gib den Namen der Firma an.',
    ENTER_PREV_COMPANIES_HINT:
      'Ehemalige Kollegen und Geschäftspartner finden Dich leichter, wenn Du Deine vorherigen Firmen einträgst.',
    ENTER_SCHOOL_NAME: 'Bitte gib den Namen der Hochschule an.',
    ENTER_TITLE: 'Bitte gib eine Position an.',
    ENTER_UNIVERSITY_HINT:
      'Triff alte Studienfreunde auf XING wieder und trage Deine Hochschulen ein.',
    ENTER_URL: 'Bitte gib eine gültige URL an.',
    'EP_COMPANY_SOCIAL_PROOF.one': '{username} arbeitet hier.',
    'EP_COMPANY_SOCIAL_PROOF.other':
      '{numberOfContacts} Deiner Kontakte arbeiten hier.',
    EP_ROLLOUT_BANNER_MOBILE:
      '<p><strong>Fast geschafft!</strong> Verwenden Sie bitte einen größeren Bildschirm, um zum neuen Design zu wechseln.</p>',
    ERROR_DUPLICATE_SERVICE:
      'Du kannst nur ein Benutzerkonto pro Anbieter angeben.',
    ERROR_ENDDATE_INVALID: 'Bitte wähle ein korrektes Enddatum aus.',
    ERROR_INDUSTRY: 'Bitte wähle eine Branche aus.',
    ERROR_INVALID_COMPANY: 'Bitte wähle eine Firma aus.',
    ERROR_INVALID_SCHOOL: 'Bitte wähle eine Hochschule aus.',
    ERROR_INVALID_SERVICE: 'Bitte wähle einen Anbieter aus.',
    ERROR_INVALID_STATUS: 'Bitte wähle Deinen Status aus.',
    ERROR_SOMETHING_WENT_WRONG:
      'Da ist leider etwas schiefgelaufen. Probiere es bitte später noch einmal.',
    ERROR_STATUS_CHANGE_COMPANY_MISS:
      'Um Deinen Status zu ändern, gib bitte mindestens eine Tätigkeit an.',
    ERROR_STATUS_CHANGE_SCHOOL_MISS:
      'Um Deinen Status zu ändern, gib bitte mindestens eine Hochschule und eine Fachrichtung an.',
    ERROR_STATUS_CHANGE_SUBJECT_MISS:
      'Um Deinen Status zu ändern, gib bitte eine Fachrichtung zu Deiner Hochschule an.',
    ERROR_WIDGET_SAVE: 'Fehler beim Speichern',
    ERROR_WIDGET_SAVE_MSG:
      'Deine Änderungen konnten nicht übernommen werden, da die Daten sich inzwischen geändert haben. Bitte bestätige mit "{\'BUTTON_OK}" und bearbeite die Daten erneut.',
    EV_000_MORE_EVENTS_LINK: 'Weitere Events',
    EV_000_WIDGET_COMPANY_HEADLINE: 'Nächste Events von {company}',
    EV_400_EVENT_ENDDATE_LABEL: 'Ende:',
    EV_400_EVENT_STARTDATE_LABEL: 'Beginn:',
    EXECUTIVES_CV_COMPETENCES_HEADER: 'Führungsverantwortung',
    FAX: 'Fax',
    FOOTER_LANGUAGES: 'Sprache',
    FRAME_HEADER_SEARCH: 'Suche',
    FRAME_HEADER_UPSELL_DISCOUNT: '{percentage} % Rabatt',
    FRAME_HEADER_UPSELL_PREMIUM: 'Premium werden',
    FRAME_HEADER_UPSELL_PROJOBS: 'ProJobs entdecken',
    FRAME_NAVIGATION_DISCO: 'Entdecken',
    FRAME_NAVIGATION_FEEDBACK_AND_HELP_SUBTITLE:
      ' Was denkst Du über die neue App?',
    FRAME_NAVIGATION_FEEDBACK_AND_HELP_TITLE: 'Dein Feedback',
    FRAME_NAVIGATION_JOBS: 'Jobs',
    FRAME_NAVIGATION_ME_HUB: 'Deins',
    FRAME_NAVIGATION_NETWORKING_ICON_TEXT: 'Netzwerken',
    FRAME_NAVIGATION_PROJOBS_UPSELL: 'ProJobs werden',
    FRAME_NAVIGATION_SUPI: 'Start',
    FRAME_NAVIGATION_UPSELL_HEADLINE: 'Angebote für Dich',
    FRAME_NAVIGATION_YOUR_PREMIUM: 'Dein Premium',
    FRAME_NAVIGATION_YOUR_PROJOBS: 'Dein ProJobs',
    FROM: 'Von',
    GIVE_WORK_DETAILS_HINT:
      'Mach auf Dich aufmerksam und trage nähere Angaben zu Deiner aktuellen Firma und Deinem Aufgabengebiet ein.',
    GOOGLE_TRANSLATION_BUTTON: 'Übersetzen',
    GOOGLE_TRANSLATION_ERROR: 'Text konnte nicht übersetzt werden.',
    GOOGLE_TRANSLATION_ERROR_NO_TEXT: 'Kein Text zum Übersetzen vorhanden',
    GOOGLE_TRANSLATION_LABEL: 'powered by Google',
    GOOGLE_TRANSLATION_SELECT_FROM: 'Sprachkombination wählen:',
    GOOGLE_TRANSLATION_SELECT_TO: 'in',
    GROUP_NEWSLETTER: 'Gruppen-Newsletter',
    GROUP_VISIBILITY: 'Sichtbarkeit von Gruppen',
    HEADER_SKIP_NAVIGATION: 'Navigation überspringen',
    IM: 'Chat-Dienste',
    IM_PROFILES_EMPTY:
      'Gib hier Deine Benutzernamen für den Chat-Dienst (z. B. Skype oder MSN) an. Du kannst später jeweils einzeln entscheiden, welche Kontakte diese Angaben sehen dürfen.',
    IM_PROFILES_SERVICE: 'Anbieter',
    IM_PROFILES_USERNAME: 'Benutzername',
    IMAGE_SIZE_ERROR_BODY: 'Bitte wähl eine Datei, die kleiner als 10 MB ist.',
    IMAGE_SIZE_ERROR_CHOOSE_ANOTHER: 'Bitte wähl eine andere Datei.',
    IMAGE_SIZE_ERROR_HEADLINE: 'Diese Datei ist leider zu groß.',
    INDIVIDUAL_GROUP_VISIBILITY: 'Sichtbarkeit von neuen Gruppen',
    INDUSTRY: 'Branche',
    INDUSTRY_10000: 'Architektur, Bauwesen',
    INDUSTRY_100000: 'Telekommunikation',
    INDUSTRY_10100: 'Bauingenieurwesen',
    INDUSTRY_10200: 'Baugewerbe',
    INDUSTRY_10300: 'Baustoffe',
    INDUSTRY_10400: 'Architektur',
    INDUSTRY_10500: 'Garten- und Landschaftsbau',
    INDUSTRY_110000: 'Medien, Verlage',
    INDUSTRY_110100: 'Informationsdienste',
    INDUSTRY_110200: 'Rundfunk, Fernsehen',
    INDUSTRY_110300: 'Verlagswesen',
    INDUSTRY_110400: 'Film, Musik',
    INDUSTRY_110500: 'Journalismus',
    INDUSTRY_110600: 'Übersetzen, Dolmetschen',
    INDUSTRY_110700: 'Text, Lektorat',
    INDUSTRY_120000: 'Banken, Finanzdienstleistungen',
    INDUSTRY_120100: 'Finanzdienstleistungen',
    INDUSTRY_120200: 'Bankwesen',
    INDUSTRY_120300: 'Investmentbanken',
    INDUSTRY_120400: 'Risikokapital, Private Equity',
    INDUSTRY_130000: 'Versicherungen',
    INDUSTRY_140000: 'Immobilien',
    INDUSTRY_140100: 'Facility Management',
    INDUSTRY_140200: 'Immobilienverwaltung',
    INDUSTRY_140300: 'Immobilienvermittlung',
    INDUSTRY_150000: 'Wirtschaftsprüfung, Steuern, Recht',
    INDUSTRY_150100: 'Rechtsberatung',
    INDUSTRY_150200: 'Wirtschaftsprüfung',
    INDUSTRY_150300: 'Steuerberatung',
    INDUSTRY_160000: 'Beratung, Consulting',
    INDUSTRY_170000: 'Marketing, PR und Design',
    INDUSTRY_170100: 'Marketing, Werbung',
    INDUSTRY_170200: 'Markt- und Meinungsforschung',
    INDUSTRY_170300: 'Design, Grafik',
    INDUSTRY_170400: 'Messe, Ausstellungen, Kongresse',
    INDUSTRY_170500: 'PR',
    INDUSTRY_180000: 'Personaldienstleistungen',
    INDUSTRY_180100: 'Personaldienstleistungen und -beratung',
    INDUSTRY_180200: 'Outsourcing, Offshoring',
    INDUSTRY_190000: 'Öffentlicher Dienst, Verbände und Einrichtungen',
    INDUSTRY_190100: 'Gemeinnützige Einrichtungen und Vereine',
    INDUSTRY_190200: 'Religiöse Einrichtungen',
    INDUSTRY_190300: 'Öffentliche Verwaltung',
    INDUSTRY_190400: 'Politik, Verbände',
    INDUSTRY_190500: 'Verteidigung, Justiz, Polizei',
    INDUSTRY_190600: 'Internationale Angelegenheiten',
    INDUSTRY_20000: 'Konsumgüter, Handel',
    INDUSTRY_200000: 'Erziehung, Bildung, Wissenschaft',
    INDUSTRY_200100: 'Forschung',
    INDUSTRY_200200: 'Schulen, Kindergärten',
    INDUSTRY_200300: 'Fach- und Hochschulen',
    INDUSTRY_200400: 'Kinderbetreuung',
    INDUSTRY_200500: 'Coaching, Fortbildung',
    INDUSTRY_200600: 'E-Learning',
    INDUSTRY_20100: 'Lebensmittel',
    INDUSTRY_20200: 'Getränke',
    INDUSTRY_20300: 'Tabakwaren',
    INDUSTRY_20400: 'Mode, Textilien',
    INDUSTRY_20500: 'Schmuck, Luxusgüter',
    INDUSTRY_20600: 'Möbel, Holzwaren',
    INDUSTRY_20700: 'Papierwaren',
    INDUSTRY_20800: 'Kosmetik, Körperpflege',
    INDUSTRY_20900: 'Glas, Keramik',
    INDUSTRY_21000: 'Import, Export',
    INDUSTRY_210000: 'Gesundheit, Soziales',
    INDUSTRY_210100: 'Krankenhäuser',
    INDUSTRY_210200: 'Tiermedizin',
    INDUSTRY_210300: 'Arztpraxen',
    INDUSTRY_210400: 'Alternative Medizin',
    INDUSTRY_210500: 'Psychologie, Psychotherapie',
    INDUSTRY_210600: 'Medizinische Dienste',
    INDUSTRY_210700: 'Pflegeberufe',
    INDUSTRY_210800: 'Sozialwesen',
    INDUSTRY_21100: 'Großhandel',
    INDUSTRY_21200: 'Einzelhandel',
    INDUSTRY_220000: 'Kunst, Kultur, Sport',
    INDUSTRY_220100: 'Darstellende Kunst',
    INDUSTRY_220200: 'Fotografie',
    INDUSTRY_220300: 'Musik',
    INDUSTRY_220400: 'Kunst, Kunsthandwerk',
    INDUSTRY_220500: 'Museen, Kultureinrichtungen',
    INDUSTRY_220600: 'Bibliotheken',
    INDUSTRY_220700: 'Fitness-Studios, Sportvereine und -anlagen',
    INDUSTRY_220800: 'Sporttreibende, Veranstalter, Verbände',
    INDUSTRY_230000: 'Sonstige Branchen',
    INDUSTRY_230100: 'Spiel-, Wett- und Lotteriewesen',
    INDUSTRY_230200: 'Landwirtschaft',
    INDUSTRY_230300: 'Forstwirtschaft, Jagd',
    INDUSTRY_230400: 'Fischerei',
    INDUSTRY_230500: 'Sonstige Dienstleistungen',
    INDUSTRY_230600: 'Bergbau, Metalle',
    INDUSTRY_230700: 'Geologie',
    INDUSTRY_230800: 'Sicherheit, Ermittlungen',
    INDUSTRY_30000: 'Automobil- und Fahrzeugbau',
    INDUSTRY_30100: 'Automobile und Zweiräder',
    INDUSTRY_30200: 'Schiffbau',
    INDUSTRY_30300: 'Schienenfahrzeugbau',
    INDUSTRY_30400: 'Verkehrstechnik',
    INDUSTRY_30500: 'Luft- und Raumfahrzeugbau',
    INDUSTRY_30600: 'Fahrzeugvermietung',
    INDUSTRY_40000: 'Industrie und Maschinenbau',
    INDUSTRY_40100: 'Mess-, Steuer- und Regelungstechnik',
    INDUSTRY_40200: 'Halbleiter, elektronische Bauteile',
    INDUSTRY_40300: 'Druckwesen',
    INDUSTRY_40400: 'Verbundwerkstoffe',
    INDUSTRY_40500: 'Chemie',
    INDUSTRY_40600: 'Mineralöl-Verarbeitung',
    INDUSTRY_40700: 'Metallindustrie und -verarbeitung',
    INDUSTRY_40800: 'Bio- und Nanotechnologie',
    INDUSTRY_40900: 'Kunststoff- und Gummiwaren',
    INDUSTRY_41000: 'Rüstung',
    INDUSTRY_41100: 'Maschinenbau, Betriebstechnik',
    INDUSTRY_41200: 'Elektrotechnik',
    INDUSTRY_41300: 'Optische und fotografische Geräte',
    INDUSTRY_50000: 'Pharma, Medizintechnik',
    INDUSTRY_50100: 'Medizintechnik',
    INDUSTRY_50200: 'Pharmazeutische Produkte, Arzneimittel',
    INDUSTRY_60000: 'Energie, Wasser, Umwelt',
    INDUSTRY_60100: 'Erneuerbare Energien',
    INDUSTRY_60200: 'Energiewirtschaft',
    INDUSTRY_60300: 'Wasserversorgung und -entsorgung',
    INDUSTRY_60400: 'Abfälle, Recycling',
    INDUSTRY_60500: 'Umweltschutz',
    INDUSTRY_70000: 'Transport, Logistik',
    INDUSTRY_70100: 'Personenverkehr',
    INDUSTRY_70200: 'Bahnverkehr',
    INDUSTRY_70300: 'Schifffahrt',
    INDUSTRY_70400: 'Luftverkehr',
    INDUSTRY_70500: 'Lagerhaltung',
    INDUSTRY_70600: 'Post, Spedition',
    INDUSTRY_80000: 'Tourismus, Gastronomie',
    INDUSTRY_80100: 'Hotelgewerbe',
    INDUSTRY_80200: 'Gastronomie',
    INDUSTRY_80300: 'Reisebüros und -veranstalter',
    INDUSTRY_80400: 'Freizeiteinrichtungen',
    INDUSTRY_90000: 'Internet, IT',
    INDUSTRY_90100: 'Computer-Software',
    INDUSTRY_90200: 'IT-Dienstleister',
    INDUSTRY_90300: 'IT-Sicherheit',
    INDUSTRY_90400: 'Computernetzwerke',
    INDUSTRY_90500: 'Computer-Hardware',
    INDUSTRY_90600: 'Unterhaltungselektronik',
    INDUSTRY_90700: 'Internet, Onlinemedien',
    INDUSTRY_90800: 'Computerspiele',
    INDUSTRY_CARD_TOTAL_COMPANIES: '{totalCompanies} Unternehmen',
    'INDUSTRY_CARD_TOTAL_COMPANIES.one': 'Ein Unternehmen',
    'INDUSTRY_CARD_TOTAL_COMPANIES.other': '{amount} Unternehmen',
    INSIDER_FOLLOWED_BY: 'Abonniert von',
    INSIDER_FOLLOWED_BY_AND: 'und',
    INSIDER_FOLLOWED_BY_AND_MORE: 'weiteren',
    INVISIBLE_ON_PROFILE: 'sichtbar für Recruiter',
    INVISIBLE_TO_OTHERS: 'nicht sichtbar für andere',
    JOB_SEARCH_ALERTS_ALERT_NAME_ALL: 'Alle Jobs',
    JS_REALLY: 'Willst Du das wirklich?',
    JS_REALLY_DELETE: 'Wirklich löschen?',
    JS_REALLY_DONT_REMIND: 'Wirklich nicht mehr erinnern?',
    LANG_NOT_AVAIL: 'Deine Sprache steht nicht zur Auswahl?',
    LANG_PREFS: 'Spracheinstellungen',
    LANGUAGE: 'Sprache',
    LANGUAGE_SKILL_LEVEL_0: '- Sprachkenntnisse -',
    LANGUAGE_SKILL_LEVEL_1: 'Grundkenntnisse',
    LANGUAGE_SKILL_LEVEL_2: 'Gut',
    LANGUAGE_SKILL_LEVEL_3: 'Fließend',
    LANGUAGE_SKILL_LEVEL_4: 'Muttersprache',
    LANGUAGE_SKILLS_NOT_AVAILABLE: 'Deine Sprache steht nicht zur Auswahl?',
    LANGUAGE_SKILLS_SELECT_LANGUAGE: '- Sprache -',
    LANGUAGES: 'Sprachen',
    LEVEL: 'Karriere-Stufe',
    LIKE_BUTTON_LABEL: 'Gefällt mir',
    LIKERS_LIST_HEADLINE: 'Diesen Mitgliedern gefällt das:',
    LINKCAP_LIST: 'Liste',
    LOGGEDOUT_ABOUT_ME: '{-display_name} über sich',
    LOGGEDOUT_BUTTON_ADDCONTACT: '{-display_name} als Kontakt hinzufügen',
    LOGGEDOUT_EDUCATION: 'Ausbildung von {-display_name}',
    LOGGEDOUT_PERSONAL: 'Persönliches über {-display_name}',
    LOGGEDOUT_WORK_EXPERIENCE: 'Berufserfahrung von {-display_name}',
    MAIL_EMAIL_LOGINABLE_SUBJECT:
      '{EMAIL_SUBJ}: Wichtig - Deine Zugangsdaten bei XING',
    MAIL_NOT_CONFIRMED:
      'Die E-Mail-Adresse konnte nicht bestätigt werden, da Du Deine E-Mail-Daten inzwischen geändert hast. Bitte versuche es erneut.',
    MAIL_WAS_CONFIRMED: 'Die E-Mail-Adresse wurde bestätigt.',
    MALT_FILE_UPLOAD_ERROR_MESSAGE:
      'Die Datei "{filesTooBig}" ist leider zu groß: Bis zu {maxSize} MB sind erlaubt.',
    MALT_FILE_UPLOAD_ERROR_MESSAGE_PLURAL:
      'Du kannst Dateien von bis zu {maxSize} MB hochladen. Diese Dateien sind daher leider zu groß: {filesTooBig}',
    MALT_FILE_UPLOAD_NO_FILE: 'Noch keine Datei ausgewählt',
    MALT_FILE_UPLOAD_NUMBER_OF_FILES: '{numberOfFiles} Dateien',
    MALT_FOOTER_COPYRIGHT_API: '© {siteoperator} | Alle Rechte vorbehalten',
    MALT_IMAGE_UPLOAD_BROWSE_BUTTON: 'Datei auswählen',
    MALT_TEST_RUBY_STYLE_TRANSLATION: 'Mein Name ist {name}.',
    MEMBERSHIP_MOTIVATION: 'Warum ich auf {-SITENAME} bin',
    MEMENU_FOLLOWING_LABEL: 'Folgst Du',
    MEMENU_HELP_LABEL: 'Hilfe',
    MEMENU_JOB_ADS_LABEL: 'Stellenanzeigen verwalten',
    MEMENU_JOB_PREFERENCES_LABEL: 'Job-Wünsche',
    MEMENU_MY_POSTS_LABEL: 'Deine Beiträge',
    MEMENU_PREMIUM_FOR_BASIC_USER_LABEL: 'Premium werden',
    MEMENU_PREMIUM_LABEL: 'Premium',
    MEMENU_PROBUSINESS_LABEL: 'ProBusiness',
    MEMENU_PROFILE_LABEL: 'Profil',
    MEMENU_PROFILE_VISITORS:
      '{total, plural,\n    =0 {Keine Besuche}\n    one {Ein Besuch}\n    other {# Besuche}\n}',
    MEMENU_PROJOBS_FOR_BASIC_USER_LABEL: 'ProJobs werden',
    MEMENU_PROJOBS_LABEL: 'ProJobs',
    MEMENU_SETTINGS_LABEL: 'Einstellungen',
    MESSENGER_SHARE_COMMENT_PLACEHOLDER:
      'Hier kannst Du Deinen Link kommentieren.',
    MESSENGER_SHARE_RECEIPENT_SELECTION_FORM_LABEL: 'Empfänger:',
    MESSENGER_SHARE_RECEIPENT_SELECTION_PLACEHOLDER: 'Empfänger eingeben',
    MESSENGER_SHARE_TARGET_LABEL: 'Deine Nachricht:',
    MONTH_NAMES:
      'Januar,Februar,März,April,Mai,Juni,Juli,August,September,Oktober,November,Dezember',
    MONTH_NAMES_SHORT: 'Jan,Feb,Mär,Apr,Mai,Jun,Jul,Aug,Sep,Okt,Nov,Dez',
    MORE_PROFILES: 'Weitere Profile von mir im Web',
    MOTIVATIONS_EMPTY:
      'Teile Mitgliedern mit, wie Du XING nutzen möchtest - so optimierst Du Dein Networking.',
    MP_700_INFOBOX_EDIT_PROFILE_LINK: 'Profil bearbeiten',
    MY_NOTIFICATION_PREFS: 'Benachrichtigungs-Einstellungen',
    MY_NOTIFICATIONS: 'Benachrichtigungen',
    MY_PERSONAL_INFO: 'Meine persönlichen Daten',
    MY_PRIVACY_SETTINGS: 'Deine Privatsphäre',
    MY_PROFILE_SETTINGS: 'Meine Profileinstellungen',
    MY_SETTINGS: 'Einstellungen',
    MY_USERNAME_PASSWORD: 'Meine Zugangsdaten',
    MYXING_LOADING_ALERT_MESSAGE:
      'Das hat leider nicht geklappt. Bitte aktualisiere diese Seite noch einmal.',
    NAVIGATION_EXPAND_NETWORK_ADDITION: 'Jetzt ausprobieren!',
    NBA_BUTTON_CANCEL: 'Abbrechen',
    NBA_BUTTON_CHANGE_IMAGE: 'Bild ändern',
    NBA_BUTTON_CONTINUE: 'Weiter',
    NBA_CREATE_PHOTO_CARD_BENEFIT_TEXT:
      'Ein gutes Profilbild unterstreicht Dein professionelles Auftreten und erhöht die Anzahl Deiner Profilbesuche.',
    NBA_CREATE_PHOTO_CARD_GENERIC_ERROR:
      "Das hat leider nicht geklappt – kannst Du's nochmal versuchen?",
    NBA_CREATE_PHOTO_CARD_IMAGE_UPLOAD_REJECTED_MIME_TYPE:
      'Bitte wähl eines dieser Bildformate: JPG, PNG oder BMP',
    NBA_CREATE_PHOTO_CARD_IMAGE_UPLOAD_REJECTED_SIZE:
      'Bitte wähl ein Bild mit weniger als 20 MB Dateigröße.',
    NBA_CREATE_PHOTO_CARD_IMAGE_ZOOM_MAX: 'Max.',
    NBA_CREATE_PHOTO_CARD_IMAGE_ZOOM_MIN: 'Min.',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_HEADLINE: 'Profilbild',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_HINT_FILE_SIZES:
      'Empfohlene Auflösung: 1024 x 1024 px',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_HINT_FILE_TYPES:
      'JPG, BMP, PNG (max. 20 MB)',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_TEXT_OPTION_CLICK: 'Bild hochladen',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_TEXT_OPTION_DRAG_N_DROP:
      'Bild hierhin ziehen',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_TEXT_OR: 'oder',
    NBA_CREATE_PHOTO_CARD_SUCCESS_BENEFIT_TEXT:
      'Du kannst dieses Bild jederzeit in Deiner Visitenkarte ändern.',
    NBA_CREATE_PHOTO_CARD_SUCCESS_HEADLINE:
      'Prima, Du hast nun ein neues Profilbild!',
    NEW_JOB: 'Weiterer Beruf',
    NEW_SCHOOL: 'Weitere Hochschule',
    NEWLETTER_AND_MAIL_TIPS:
      'XING Newsletter, E-Mail-Tipps und Angebote per Post',
    NEWSFEED_PROFILE_PREVIEW_AWARDS: 'Auszeichnungen',
    NEWSFEED_PROFILE_PREVIEW_AWARDS_MORE:
      '{?IF:awards_sg}\n{.awards_more_entries} weitere Auszeichnung\n{?ELSE:awards_sg}\n{.awards_more_entries} weitere Auszeichnungen\n{?END:awards_sg}',
    NEWSFEED_PROFILE_PREVIEW_BUSINESS: 'Geschäftlich',
    NEWSFEED_PROFILE_PREVIEW_DOCUMENTS: 'Dateianhänge',
    NEWSFEED_PROFILE_PREVIEW_DOCUMENTS_MORE:
      '{?IF:certificates_sg}\n{.certificates_more_entries} weiterer Dateianhang\n{?ELSE:certificates_sg} \n{.certificates_more_entries} weitere Dateianhänge\n{?END:certificates_sg}',
    NEWSFEED_PROFILE_PREVIEW_HAVES: 'Fähigkeiten & Kenntnisse',
    NEWSFEED_PROFILE_PREVIEW_INTERESTS: 'Interessen',
    NEWSFEED_PROFILE_PREVIEW_MOBILE: 'Handy',
    NEWSFEED_PROFILE_PREVIEW_ORGANISATIONS: 'Organisationen',
    NEWSFEED_PROFILE_PREVIEW_PRIVATE: 'Privat',
    NEWSFEED_PROFILE_PREVIEW_QUALIFICATIONS: 'Qualifikationen',
    NEWSFEED_PROFILE_PREVIEW_QUALIFICATIONS_MORE:
      '{?IF:qualifications_sg}\n{qualifications_more_entries} weiterer Eintrag\n{?ELSE:qualifications_sg}\n{qualifications_more_entries} weitere Einträge\n{?END:qualifications_sg}',
    NEWSFEED_PROFILE_PREVIEW_SCHOOLS_MORE:
      '{?IF:schools_sg}\n{schools_more_entries} weiterer Eintrag\n{?ELSE:schools_sg}\n{schools_more_entries} weitere Einträge\n{?END:schools_sg}',
    NEWSFEED_PROFILE_PREVIEW_WANTS: 'Ich suche',
    NEWSFEED_PROFILE_PREVIEW_WORKEXP_MORE:
      '{?IF:sg}\n{more_entries} weiterer Eintrag\n{?ELSE:sg}\n{more_entries} weitere Einträge\n{?END:sg}',
    NEWSFEED_RECOMMEND: 'Teilen',
    NO_END_DATE_HINT:
      'Du hast kein Enddatum angegeben und auch nicht "bis heute" ausgewählt.',
    NO_PRIV_ADD_HINT: 'Du hast noch keine Daten zur Privatadresse angegeben.',
    NOTES: 'Schwerpunkte',
    NOTIFICATION_CENTER_LINK: 'Mitteilungen',
    NOTIFICATIONS: 'Benachrichtigungen',
    OBCPAGEHTML_DETAILS_NOTAPPROVED: '(nicht freigegeben)',
    OBCPAGEHTML_LANGUAGES: 'Sprachkenntnisse',
    OBCPAGEHTML_PERIOD: 'Zeitraum',
    OBCPAGEHTML_SHOW_SHARED_CONTACTS: 'Gemeinsame Kontakte anzeigen',
    OBCPAGEHTML_TAB5: 'Applikationen',
    OPENSOCIAL_REFERENCES_NEW: 'NEU',
    OPENSOCIAL_REFERENCES_TEXT:
      '{-DISPLAY_NAME} verwendet die Applikation XING Referenzen. <a href="{-LINK}">Referenzen ansehen</a>',
    OPENSOCIAL_REFERENCES_TITLE: 'Referenzen',
    OPTIMIZEPROFILE_ADVANTAGES_1:
      'Von <b>über 75.000 Personalern</b> sofort gefunden werden',
    OPTIMIZEPROFILE_ADVANTAGES_2:
      'Mit optimal ausgefülltem Profil <b>zum neuen Job</b>',
    OPTIMIZEPROFILE_ADVANTAGES_3:
      '<b>Diskret gefunden werden</b>, z. B. für Personen in Arbeitsverhältnissen',
    OPTIMIZEPROFILE_BTN: 'Jetzt Profil optimieren',
    OPTIMIZEPROFILE_CHECK_1: 'Wirst Du als Erstes gefunden?',
    OPTIMIZEPROFILE_CHECK_1_MORE_1:
      'Dein Profil ist nicht nur Deine Visitenkarte, sondern entscheidet auch darüber, an welcher Stelle Du von Personalern in den Suchergebnissen gefunden wirst. Denn: Vollständig ausgefüllte Profile werden als Erstes angezeigt!',
    OPTIMIZEPROFILE_CHECK_1_MORE_2:
      'Überlasse Dein berufliches Schicksal nicht dem Zufall: Mit einem vollständig ausgefüllten Profil erscheinst Du in der Ergebnisliste ganz oben!',
    OPTIMIZEPROFILE_CHECK_1_MORE_3:
      'Nutze die Tipps, die Dir auf Deiner Profilseite zur Vervollständigung Deines Profils angezeigt werden.',
    OPTIMIZEPROFILE_CHECK_2: 'Weist Du auf Deine Job-Suche hin?',
    OPTIMIZEPROFILE_CHECK_2_MORE_1:
      'Stelle die Weichen für Deinen Erfolg: Auf XING kannst Du von über 75.000 Personalern gefunden werden. Gib also in Deinem Profil an, dass Du eine neue Herausforderung suchst.',
    OPTIMIZEPROFILE_CHECK_2_MORE_2:
      'Trage im Bereich „Warum ich auf XING bin“ ein, dass Du auf Job-Suche bist.',
    OPTIMIZEPROFILE_CHECK_2_MORE_3:
      'Wenn Du Dich in einer Anstellung befindest und diskret einen Job suchst, wähle die Option „Nur Recruiter“. So wird Deine Suche nur für ausgewiesene Personalentscheider sichtbar.',
    OPTIMIZEPROFILE_CHECK_3:
      'Ist Deine Berufserfahrung detailliert genug aufgelistet?',
    OPTIMIZEPROFILE_CHECK_3_MORE_1:
      'Personaler sind besonders an Deinem beruflichen Werdegang interessiert. Gib diesen im Bereich „Berufserfahrung“ genau an.',
    OPTIMIZEPROFILE_CHECK_3_MORE_2:
      'Mache bei jetzigen und früheren Stationen auch Angaben zur Dauer der Beschäftigung, am besten durch Monats- und Jahresangabe. Nutze das Feld „Karriere-Stufe“, um Deine Erfahrung zu dokumentieren.',
    OPTIMIZEPROFILE_CHECK_3_MORE_3:
      'Biete Futter: Zähle nicht nur Deine Stationen auf. Lass im Feld „Beschreibe Deine Position“ Deine Erfolge oder spezifische Kompetenzen erkennen.',
    OPTIMIZEPROFILE_CHECK_4: 'Hast Du Deine Qualifikationen genau beschrieben?',
    OPTIMIZEPROFILE_CHECK_4_MORE_1:
      'Überzeuge mit Kompetenz: Zähle im Bereich "Fähigkeiten & Kenntnisse" auf, was Du kannst.',
    OPTIMIZEPROFILE_CHECK_4_MORE_2:
      'Orientiere Dich auch an Schlagwörtern, die Personalverantwortliche auf ihren Profilseiten benutzen. Sucht ein Personaler beispielsweise nicht nach “Webdesign”, sondern nach “XHTML”, “HTML 4″ und “CSS 3″, solltest Du darauf vorbereitet sein.',
    OPTIMIZEPROFILE_CHECK_5: 'Teilst Du bereits mit, was Du suchst?',
    OPTIMIZEPROFILE_CHECK_5_MORE_1:
      'Warte nicht, bis ein Personaler Dich über Deine Qualifikationen entdeckt – kommuniziere auch, was Du suchst. So wirst Du leichter gefunden!',
    OPTIMIZEPROFILE_CHECK_5_MORE_2:
      'Trage unter „Ich suche“ Schlagwörter wie „Herausforderung“, „Veränderung“ oder „Job“ ein.',
    OPTIMIZEPROFILE_CHECK_5_MORE_3:
      'Sei kreativ: Hier könnte z. B. Deine Wunsch-Stellenbezeichnung stehen.',
    OPTIMIZEPROFILE_CHECK_6: 'Was sagt Dein Foto über Dich aus?',
    OPTIMIZEPROFILE_CHECK_6_MORE_1:
      'Bei Deinem Profilbild gelten dieselben Regeln wie für Bewerbungsfotos: keine Urlaubsschnappschüsse, sondern ein professionell aufgenommenes Porträt.',
    OPTIMIZEPROFILE_CHECK_7: 'Hältst Du Dich regelmäßig auf dem Laufenden?',
    OPTIMIZEPROFILE_CHECK_7_MORE_1:
      'Wenn Du mit einem Personaler in Kontakt trittst, sorge für eine transparente und zügige Kommunikation – Personalmanagement ist ein schnelles Geschäft.',
    OPTIMIZEPROFILE_CHECK_7_MORE_2:
      'Bleib am Ball: Checke regelmäßig Deine Nachrichten, da Personalverantwortliche zeitnah Antworten benötigen.',
    OPTIMIZEPROFILE_CHECK_7_MORE_3:
      'Halte Deine Benachrichtigungsadresse auf XING aktuell: Per E-Mail wirst Du über neue XING-Nachrichten sofort informiert.',
    OPTIMIZEPROFILE_CHECK_8: 'Nutze die Felder “Firma” und „Status“ effizient?',
    OPTIMIZEPROFILE_CHECK_8_MORE_1:
      'Überrasche Deinen zukünftigen Arbeitgeber mit einer Kostprobe Deiner Kreativität: Wenn Du Arbeit suchst, trage ins Feld „Firma“ statt Deines Namens lieber Bezeichnungen wie „Freelancer“, „Auf Suche“ oder etwas Originelles wie „Hier könnte Ihr Firmenname stehen!“ ein.',
    OPTIMIZEPROFILE_CHECK_8_MORE_2:
      'Ändere Deinen Status in “Arbeit suchend“, Personaler suchen oft mit diesem Begriff.',
    OPTIMIZEPROFILE_CHECK_8_MORE_3:
      'Es ist auch legitim, ein „(Ex-)“ vor die letzte Firma zu setzen.',
    OPTIMIZEPROFILE_CHECKLIST_TITLE:
      'Profil-Checkliste: Ist Dein Profil komplett?',
    OPTIMIZEPROFILE_DESCRIPTION:
      'Mit einem optimal ausgefüllten Profil wird Deine Suche noch effektiver! Schließe jetzt die Lücken in Deinem XING Profil und steigere die Chancen auf Deinen Traumjob.',
    OPTIMIZEPROFILE_INFO:
      'Klicke auf die einzelnen Punkte unserer Profil-Checkliste auf der rechten Seite und informiere Dich, wie Du Dein Profil am besten optimierst.',
    OPTIMIZEPROFILE_SUBTITLE_1: 'Du bist auf der Suche nach einem neuen Job?',
    OPTIMIZEPROFILE_TIP: 'Wichtiger Tipp: Einstellungen zur Privatsphäre',
    OPTIMIZEPROFILE_TIP_MORE_1:
      'Falls Du angestellt bist, ist es ratsam, Deine Job-Suche diskret zu halten. Bedenke, dass alle Profiländerungen auch im Feed "Neues aus Deinem Netzwerk“ Deiner direkten Kontakte erscheinen! So beugst Du eventuellen Irritationen vor:',
    OPTIMIZEPROFILE_TIP_MORE_2:
      'Geh auf Nummer sicher: Passe vor dem Verändern Deines Profils Deine Privatsphäre an. Entferne im Bereich „Einstellungen/Meine Privatsphäre/Neues aus Deinem Netzwerk“ die Haken bei „Persönliches“ und „Berufserfahrung, Anhänge und Ausbildung“. Deine Änderungen werden dann nicht auf der Startseite und im Newsletter Deiner Kontakte angezeigt.',
    OPTIMIZEPROFILE_TIP_MORE_3:
      'Setze das Häkchen nach Deinen Änderungen wieder. So wird Dein Netzwerk wieder über Deine Neuigkeiten informiert.',
    OPTIMIZEPROFILE_TITLE: 'Mach Dein Profil fit für Deinen Traumjob!',
    OPTIONS: 'Optionen',
    OPTIONS_DELETE: 'Ja, bitte löschen.',
    OPTIONS_SEND_MESSAGE: 'Nachricht schreiben',
    ORG_TYPE: 'Art der Organisation',
    PERSONAL: 'Persönliches',
    PERSONAL_INFO: 'Persönliche Daten',
    PHONE: 'Telefon',
    PHOTOBOX_LOCAL_TIME: 'Ortszeit:',
    'POLLS_TIME_REMAINING_DAYS_WEB.one': 'Endet morgen',
    'POLLS_TIME_REMAINING_DAYS_WEB.other': 'Endet in {days} Tagen',
    'POLLS_TIME_REMAINING_DAYS_WEB.zero': 'Endet heute',
    POLLS_VOTE_ERROR:
      'Das hat leider nicht geklappt. Bitte versuch es noch einmal.',
    'POLLS_VOTES_NUMBER_WEB.one': '1 Stimme',
    'POLLS_VOTES_NUMBER_WEB.other': '{votes} Stimmen',
    'POLLS_VOTES_NUMBER_WEB.zero': 'Keine Stimmen',
    PORTFOLIO_CHOICE_HINT_VIDEO_UPSELL:
      'Max. 15 Videos<br>\n<a {href}>(Nur Premium)</a>',
    PORTFOLIO_DESCRIPTION_VIDEO_UPSELL:
      'Präsentiere Deine Arbeit mit einem Video.<br><br>Möchtest Du diese Funktion nutzen? Dann werde jetzt einfach Premium-Mitglied: <a {href}>Zur Premium-Mitgliedschaft</a>',
    PORTFOLIO_UPGRADE_MESSAGE_WITH_NO_VIDEO:
      'Bis zu {max_file_number} Bilder oder PDF-Dokumente hinzufügen<br>\nBis zu {max_video_number} Videos einbinden<br>\nUnbegrenzt Textmodule verwenden',
    PRESENT: 'heute',
    PREVIEW: 'Vorschau',
    PRIMARY_JOB:
      'Diese Tätigkeit neben meinem Namen und oben auf meiner Profilseite anzeigen',
    PRIMARY_SCHOOL:
      'Diese Hochschule neben meinem Namen und oben auf meiner Profilseite anzeigen.',
    PRIVATE: 'Privat',
    PROBUSINESS_BANNER_EVENTS_GUESTLIST_BODY:
      'Schau Dir alle Event-Teilnehmenden direkt in ProBusiness an, verfeinere die Liste mit zahlreichen Filtern und speicher relevante Leads gleich ab.',
    PROBUSINESS_BANNER_EVENTS_GUESTLIST_BUTTON:
      'Teilnahmeliste in ProBusiness ansehen',
    PROBUSINESS_BANNER_EVENTS_GUESTLIST_HEADLINE:
      'Du möchtest Leads aufgabeln?',
    PROBUSINESS_BANNER_SEARCH_BODY:
      'Sieh Dir diese Ergebnisse direkt in ProBusiness an, nutz die effizienten Filtermöglichkeiten und speicher gefundene Kontakte gleich als relevante Leads ab.',
    PROBUSINESS_BANNER_SEARCH_BUTTON: 'Ergebnisse in ProBusiness anzeigen',
    PROBUSINESS_BANNER_SEARCH_HEADLINE:
      'Vertriebsgeheimnis: Verfeinere Deine Ergebnisse!',
    PROBUSINESS_DROPDOWN_SHOW_RESULT: 'In ProBusiness ansehen',
    PROBUSINESS_NO_STATUS_AVAILABLE: 'Lead-Status derzeit unbekannt',
    PROBUSINESS_SAVE_AS_LEAD: 'Lead merken',
    PROFILE_ABOUT_PREVIEW_CREATE: '"Über mich"-Seite anlegen',
    PROFILE_ABOUT_PREVIEW_EDIT: 'Den Bereich "Über mich" editieren',
    PROFILE_ABOUT_PREVIEW_EMPTY_TEXT:
      '<strong>Willkommen auf Deiner persönlichen "Über mich"-Seite!</strong><br><br>\nXING-Mitglieder, die Dein Profil besuchen, möchten hier mehr über Dich erfahren als es der Lebenslauf hergibt.<br><br>\n\nNutze daher diese Seite, um Dich bei Interessenten im besten Licht zu präsentieren. Stelle Dich also persönlich vor, gehe genauer auf Deine Qualifikationen, Erfahrungen und beruflichen Ambitionen ein oder &ndash; wenn Du Freiberufler bist &ndash; nutze diese Seite für die Präsentation Deiner Dienstleistungen und Produkte.',
    PROFILE_ABOUT_PREVIEW_MORE: 'Mehr',
    PROFILE_ACTIONS_HEADLINE: 'Optionen',
    PROFILE_ACTIONS_MORE_TRIGGER: 'Mehr',
    PROFILE_BACKEND_PMBX_INQUIRY_PAYLOAD_SETTINGS_ACTIVITY_TAB_VISIBILITY:
      'Aktivitäten sichtbar?',
    PROFILE_BACKEND_PMBX_INQUIRY_PAYLOAD_SETTINGS_PORTFOLIO_TAB_VISIBILITY:
      'Portfolio sichtbar?',
    PROFILE_BADGES_LAYER_AMBASSADOR_COMMON_HEADLINE: 'Ambassador·innen',
    PROFILE_BADGES_LAYER_AMBASSADOR_COMMON_TEXT:
      'Ambassador·innen moderieren die offiziellen XING Gruppen und\norganisieren die offiziellen XING Events. Sie haben dabei einen von drei verschiedenen Schwerpunkten:',
    PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_HEADLINE:
      'Branchen-Ambassador·innen',
    PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_LINK: 'Branchen-Gruppen ansehen',
    PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_SUB:
      'Moderator·innen und ausgewiesene Fachleute ihrer Branche',
    PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_TEXT:
      'Branchen-Ambassador·innen sind\nengagierte XING Mitglieder mit einer spezielle Lizenz im\nRahmen unseres Ambassador-Programms. \nSie moderieren jeweils eine große Branchen-Gruppe, verfügen\nüber Fachwissen und Anerkennung in ihrem Fachgebiet\nund unterstützten die Aktivitäten der Mitglieder ihrer Gruppe\nsowohl online als auch durch offizielle Events.',
    PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_HEADLINE:
      'Regional-Ambassador·innen',
    PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_LINK: 'Regional-Gruppen ansehen',
    PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_SUB:
      'Offizieller Event-Veranstalter und Vertrauensperson vor Ort',
    PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_TEXT:
      'Regional-Ambassador·innen sind Markenbotschafter·innen und regionaler Anlaufpunkt für XING Mitglieder und Interessierte. Sie moderieren jeweils eine offizielle Regional-Gruppe, veranstalten regelmäßig Events in ihrer\nRegion und unterstützen den Austausch der Gruppen-Mitglieder untereinander.',
    PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_HEADLINE: 'Themen-Ambassador·innen ',
    PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_LINK: 'Themen-Gruppen ansehen',
    PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_SUB:
      'Expert·innen für Themen rund um die moderne Arbeitswelt',
    PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_TEXT:
      'Dies sind Spezialisten für die moderne\nArbeitswelt. In ihren Gruppen begleiten sie Diskussionen rund\num das Thema "Arbeit der Zukunft". Sie organisieren\nVeranstaltungen, in denen es um neue Trends, Erkenntnisse\nund Meinungen zur Arbeitswelt von heute und morgen geht.',
    PROFILE_BADGES_LAYER_MODERATOR_SUB:
      'Ansprechperson und Konfliktlöser einer Gruppe',
    PROFILE_BADGES_LAYER_PREMIUM_LINK: 'Alle Premium-Vorteile im Überblick',
    PROFILE_BADGES_LAYER_PREMIUM_SUB:
      'Hilfreiche Zusatzfunktionen für Beruf, Karriere und Geschäft',
    PROFILE_BUSINESS_ANCHOR_PRIVATE:
      'Gib hier Deine <a href="#contact_details">private Adresse</a> an.',
    PROFILE_BUSINESS_ANCHOR_WEB:
      'Gib auch <a href="#web-profiles">Deine anderen Profile im Web</a> an (z. B. von Facebook oder Twitter etc.).',
    PROFILE_BUSINESS_CARD_BADGE_AMBASSADOR: 'Ambassador',
    PROFILE_BUSINESS_CARD_BADGE_AMBASSADOR_TEXT: 'Was ist ein Ambassador?',
    PROFILE_BUSINESS_CARD_BADGE_BASIC: 'Basis',
    PROFILE_BUSINESS_CARD_BADGE_BASIC_TOOLTIP: 'Premium kennenlernen',
    PROFILE_BUSINESS_CARD_BADGE_EXECUTIVE: 'Executive',
    PROFILE_BUSINESS_CARD_BADGE_INDUSTRY_AMBASSADOR: 'Branchen-Ambassador',
    PROFILE_BUSINESS_CARD_BADGE_MODERATOR: 'Moderator',
    PROFILE_BUSINESS_CARD_BADGE_MODERATOR_TEXT: 'Was ist ein Moderator?',
    PROFILE_BUSINESS_CARD_BADGE_PREMIUM: 'Premium',
    PROFILE_BUSINESS_CARD_BADGE_PREMIUM_TEXT:
      'Welche Vorteile hat die<br>Premium-Mitgliedschaft?',
    PROFILE_BUSINESS_CARD_BADGE_PREMIUM_TOOLTIP: 'Premium-Mitglied',
    PROFILE_BUSINESS_CARD_BADGE_REGIONAL_AMBASSADOR: 'Ambassador',
    PROFILE_BUSINESS_CARD_BADGE_TOPIC_AMBASSADOR: 'Themen-Ambassador',
    PROFILE_BUSINESS_CARD_BADGE_XPERT: 'Xpert',
    PROFILE_BUSINESS_CARD_BADGE_XPERT_TEXT: 'Was ist ein Xpert?',
    PROFILE_BUSINESS_CARD_BUSINESS_ADDRESS: 'Geschäftlich',
    PROFILE_BUSINESS_CARD_PRIVATE_ADDRESS: 'Privat',
    PROFILE_BUSINESS_CARD_ROUTE: 'Kartenansicht',
    PROFILE_BUSINESS_CARD_STATUS_UPSELL_BANNER_BUTTON: 'Mehr dazu',
    PROFILE_BUSINESS_CARD_STATUS_UPSELL_BANNER_DESCRIPTION:
      'Premium-Mitglieder können ihren Status selbst verfassen und die Vorschläge anpassen.',
    PROFILE_BUSINESS_CARD_STATUS_UPSELL_BANNER_TITLE:
      'Du brauchst mehr Individualität?',
    PROFILE_BUSINESS_CARD_WEB_PROFILES: 'Profile im Web',
    PROFILE_COMPLETE_WITH:
      'Mit diesen Angaben wird Dein Profil vervollständigt:',
    PROFILE_COMPLETION_TEXT: 'Vollständigkeit des Profils',
    PROFILE_CONTACTS_MORE: 'Weitere Kontakte',
    PROFILE_GROUPS_BOX_HEADER_OTHER: 'Gruppen von {-ONAME}',
    PROFILE_GROUPS_BOX_NO_GROUPS_VISIBLE:
      'Auf Deinem Profil sind keine Gruppen sichtbar.',
    PROFILE_GROUPS_SHOW_ALL_LINK: 'Alle anzeigen',
    PROFILE_GUESTBOOK_BOX_MORE: 'Weitere Einträge',
    PROFILE_HEAD_MESSAGE: 'Nachricht schreiben',
    PROFILE_INLINETEASER_HEADER_MULTI_ENTRIES:
      'Es gibt {num_past_workentries} weitere Einträge.',
    PROFILE_INLINETEASER_HEADER_NO_ENTRIES:
      'Möchtest Du mehr über {-ONAME} wissen?',
    PROFILE_INLINETEASER_HEADER_SINGLE_ENTRY: 'Es gibt einen weiteren Eintrag.',
    PROFILE_INLINETEASER_TEXT:
      'Registriere Dich dazu kostenlos. Als XING-Mitglied kannst Du {-ONAME} auch direkt kontaktieren.',
    PROFILE_INLINETEASER_TEXT_MULTIPLE:
      'Registriere Dich kostenlos, um die gesamte Berufserfahrung von {-ONAME} zu sehen.',
    PROFILE_LATEST_ACTIVITIES_HEADLINE: 'Letzte Aktivitäten',
    PROFILE_LATEST_ACTIVITIES_MORE: 'Mehr',
    PROFILE_LIGHTBOX_SIGNUP_HEADLINE:
      '{-ONAME} ist eines von über 21 Mio. XING Mitgliedern.',
    PROFILE_LIGHTBOX_SIGNUP_TEXT:
      'Registriere Dich kostenlos, um alte Kontakte wiederzufinden und neue interessante Menschen zu entdecken.',
    PROFILE_LOGGED_OUT_JOIN_NOW: 'Kostenlos registrieren',
    PROFILE_LOGGEDOUT_RIGHTBOX_1: 'Bist Du schon dabei?',
    PROFILE_LOGGEDOUT_RIGHTBOX_2:
      'XING ist ein Business-Netzwerk für Geschäftsleute und verbindet Know-how mit Know-who.',
    PROFILE_LOGGEDOUT_RIGHTBOX_3: 'Nutze die Vorteile von XING:',
    PROFILE_LOGGEDOUT_RIGHTBOX_4:
      'Finde neue Vertriebskanäle, Fachkräfte und Jobs',
    PROFILE_LOGGEDOUT_RIGHTBOX_5: 'Finde Kolleg·innen und Bekannte wieder',
    PROFILE_LOGGEDOUT_RIGHTBOX_6: 'Erreiche Experten per Mausklick',
    PROFILE_LOGGEDOUT_RIGHTBOX_7: 'Kostenlos registrieren',
    PROFILE_LOGGEDOUT_SEACRHBOX_1: 'Suche im XING-Netzwerk',
    PROFILE_LOGGEDOUT_SEACRHBOX_2:
      'Finde neue Business-Kontakte auf XING\nund treffe alte Kontakte wieder!',
    PROFILE_LOGGEDOUT_TOPBOX_BUTTON:
      'Kostenlos registrieren und {ONAME} kontaktieren',
    PROFILE_LOGGEDOUT_TOPBOX_HEADER: 'Kontaktiere {-ONAME}!',
    PROFILE_LOGGEDOUT_TOPBOX_HEADER_2: 'Möchtest Du mehr über {-ONAME} wissen?',
    PROFILE_LOGGEDOUT_TOPBOX_TEXT1: 'Registriere Dich dazu kostenlos bei XING.',
    PROFILE_LOGGEDOUT_TOPBOX_TEXT2:
      'Schon Mitglied? <a href="/profile/{+obcpage_name}">Einloggen</a> und {-ONAME} als Kontakt hinzufügen.',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_ACTIVE: 'Aktiv',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_ACTIVE_FALSE: 'Nein',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_ACTIVE_TRUE: 'Ja',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_CAREER_SETTINGS:
      'Job-Wünsche',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_CONTENT_INSIDER:
      'Artikel',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_MODULE_NAME: 'Name',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_PATTERNS_SHOWCASE:
      'Patterns showcase',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_PERSONAL_DETAILS:
      'Persönliches',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_TIMELINE:
      'Werdegang',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_MODULE_STORE_ITEM_TITLE:
      'Profilbereiche',
    PROFILE_MODULES_PMBX_INQUIRY_PAYLOAD_TITLE: 'Sichtbarkeit der Profildaten',
    PROFILE_MORE_DETAILS_NOTES_CATS: 'Meine Anmerkungen zu {-ONAME}',
    PROFILE_MORE_DETAILS_TOGGLE_LESS: 'Weniger',
    PROFILE_MORE_DETAILS_TOGGLE_MORE: 'Mehr',
    PROFILE_OTHER_EXPERIENCE_HEADLINE:
      'Andere Besucher haben sich auch folgende Profile angesehen:',
    PROFILE_OTHER_EXPERIENCE_LINK: 'Weitere Profile',
    PROFILE_PMBX_INQUIRY_PAYLOAD_CONTENT: 'Inhalt',
    PROFILE_PMBX_INQUIRY_PAYLOAD_CREATED_AT: 'Erstellt am',
    PROFILE_PMBX_INQUIRY_PAYLOAD_FEED_URL: 'Feed URL',
    PROFILE_PMBX_INQUIRY_PAYLOAD_LEGAL_INFORMATION_CONTENT: 'Inhalt',
    PROFILE_PMBX_INQUIRY_PAYLOAD_LEGAL_INFORMATION_DISPLAY_CONTENT:
      'Angezeigter Inhalt',
    PROFILE_PMBX_INQUIRY_PAYLOAD_LEGAL_INFORMATION_TITLE:
      'Rechtliche Informationen',
    PROFILE_PMBX_INQUIRY_PAYLOAD_NO_DATA_REASON: 'Keine Daten vorhanden',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_IMAGETILE_HEADER:
      'Portfolio: Bilder',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_PDFTILE_HEADER:
      'Portfolio: PDF-Dateien',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_TEXTTILE_HEADER:
      'Portfolio: Textmodule',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_TILE_CONTENT: 'Beschreibung',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_TILE_FILE: 'PDF',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_TILE_IMAGE: 'Bild',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_TILE_LINK: 'Link',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_TILE_TITLE: 'Überschrift',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PORTFOLIO_VIDEOTILE_HEADER:
      'Portfolio: Videos',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_ACCURACY: 'Genauigkeit',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_ADMIN_AREA: 'Region',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_CITY: 'Ort',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_FORMATTED_COUNTRY: 'Land',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_JSON_ATTRIBUTES:
      'Lokale Angaben',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_LATITUDE: 'Breitengrad',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_LOCATION_TYPE: 'Typ',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_LONGITUDE: 'Längengrad',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_POSTAL_CODE: 'Postleitzahl',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_STREET: 'Straße und Hausnr.',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_TITLE: 'Ermittelter Standort',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_LOCATION_UPDATE_FAILED:
      'Die Ortsdaten konnten leider nicht aktualisiert werden.',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_PHOTO_ORIGINAL_PICTURE: 'Profilbild',
    PROFILE_PMBX_INQUIRY_PAYLOAD_PROFILE_PHOTO_ORIGINAL_TITLE: 'Profilbild',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_GIVEN_AT: 'Erteilt am',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_GIVEN_TO: 'Für',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_POSITION: 'Für die Position',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_RECIEVED_FROM: 'Von',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_GIVEN:
      'Referenzen gegeben',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_GIVEN_TEXT:
      'Am {given_at} an {referee_id} | ({referee_position}). {testimonial}',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_GIVEN_TITLE:
      'Erteilte Referenzen',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_POSITON: 'Position',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_RECEIVED:
      'Referenzen erhalten',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_RECEIVED_TEXT:
      'Am {given_at} von {referrer_id} | ({referrer_position}). {testimonial}',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_RECIEVED_TITLE:
      'Erhaltene Referenzen',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_REFERENCE_TITLE: 'Referenzen',
    PROFILE_PMBX_INQUIRY_PAYLOAD_REFERENCES_TESTIMONIAL: 'Inhalt',
    PROFILE_PMBX_INQUIRY_PAYLOAD_RSS_PROFILE_TITLE: 'RSS Feeds',
    PROFILE_PMBX_INQUIRY_PAYLOAD_TITLE: 'Standortdaten',
    PROFILE_PMBX_INQUIRY_PAYLOAD_UPDATED_AT: 'Aktualisiert am',
    PROFILE_POWERSEARCHES_HEADER: 'Suchen rund um mein Profil',
    PROFILE_PREVIEW_HEADER: 'So sieht Dein Profil für Nicht-Kontakte aus.',
    PROFILE_PREVIEW_INFO_BUTTON_BACK: 'Zur normalen Ansicht',
    PROFILE_PREVIEW_INFO_HEADLINE: 'So wird Dein Profil Besuchern angezeigt',
    PROFILE_PREVIEW_INFO_TEXT:
      'Bitte wechsel zurück in den Editier-Modus, um Dein Profil zu bearbeiten.',
    PROFILE_PREVIEW_OFF: 'Zur normalen Ansicht',
    PROFILE_PREVIEW_ON: 'Dein Profil aus der Sicht anderer',
    PROFILE_PROMOTE_HEADLINE: 'Dein persönlicher Profil-Button',
    PROFILE_PROMOTE_MORE: 'Quelltext anzeigen',
    PROFILE_PROMOTE_TEXT:
      'Der Button für Deine Website oder Deinen Blog: Wer darauf klickt, landet automatisch auf Deinem XING Profil. Um ihn zu integrieren, musst Du lediglich den unten stehenden Quelltext in Deine Website einfügen.',
    PROFILE_SECTIONS_GROUPS_TITLE: 'Gruppen',
    PROFILE_SETTINGS: 'Einstellungen',
    PROFILE_SEVERAL_GROUPS_COUNT: '({-count} von {-total})',
    PROFILE_SEVERAL_GROUPS_TITLE: 'Einige Gruppen von {-ONAME}',
    PROFILE_SEVERAL_OF_MY_GROUPS_TITLE: 'Einige meiner Gruppen',
    PROFILE_TIMELINE_MODULE_ACTION_ADD_ENTRY: 'Etwas anderes',
    PROFILE_TIMELINE_MODULE_ACTION_ADD_PROMOTION: 'Beförderung',
    PROFILE_TIMELINE_MODULE_ACTION_CHANGE_ORGANIZATION: 'Neue Stelle',
    PROFILE_TIMELINE_MODULE_ACTION_EDIT_ENTRY: 'Interner Wechsel',
    PROFILE_TIMELINE_MODULE_BUCKET_PROFESSIONAL_AND_ENTRY_LEVEL_TITLE:
      'Berufserfahrung',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_DURATION:
      '{years} und {months}',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_DURATION_AND_FROM:
      '{duration}, ab {since}',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_DURATION_AND_SINCE:
      '{duration}, seit {since}',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_DURATION_AND_SINCE_YEAR:
      '{duration}, seit {since}',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_ONLY_FROM: 'ab {date}',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_ONLY_SINCE:
      'seit {date}',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_PERIOD: '{from} - {to}',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_TO_PRESENT_ONLY:
      '**Bis heute**',
    PROFILE_TIMELINE_MODULE_ENTRY_LOCALIZED_TIME_STRING_WITH_DURATION_AND_PERIOD:
      '{duration}, {period}',
    PROFILEPAGE_MSG_INV_ALREADY_MEMBER:
      '<b>Achtung:</b> Deine Einladung wurde NICHT versandt, da die ausgewählte Person bereits Mitglied in der Gruppe ist.',
    PROFILEPAGE_MSG_INV_TOO_EARLY:
      '<b>Achtung:</b> Deine Einladung wurde NICHT versandt, da die ausgewählte Person bereits von Dir in die Gruppe eingeladen wurde.',
    PROFILERAILS_BLOG_PREPARE_INFO:
      'Die Beiträge des Blogs stehen gleich zur Verfügung.',
    PROFILERAILS_BLOG_PREPARE_INFO_ERROR:
      'Dieser Link reagiert gerade nicht  ... vielleicht vertippt? Sonst versuche es bitte später noch einmal.',
    PROFILERAILS_EDIT_CONTACT_DETAILS_PATH_FENCED_HINT:
      'Über welche Deiner Kontakte seid ihr miteinander verbunden?',
    PROFILERAILS_EDIT_CONTACT_DETAILS_PATH_SHOW_ALL_FENCED:
      'Alle Kontaktpfade anzeigen',
    PROFILERAILS_PROFILE_VISITORS_HL_BASIC:
      '<strong>Profilbesuche</strong>  sind für Premium-Mitglieder sichtbar!',
    PROFILERAILS_PROJOBS_ONBOARDING_HEADER: 'Deine ProJobs-Profilansicht',
    PROFILERAILS_PROJOBS_ONBOARDING_TEXT:
      'Diese Ansicht ist nur für Personen verfügbar, die Du in Deinen <a href="/projobs/start?sc_o=ojm_443_settings">ProJobs Einstellungen</a> freigeschaltet hast. Mehr Informationen über die Nutzung von ProJobs bekommst Du im <a href="#" data-mypj-trigger-tour>ProJobs-Rundgang</a>.',
    PROFILERAILS_VISITORS_BUTTON_PREMIUM_UPSELL: 'Premium-Mitglied werden',
    PROGRESS_BAR_LOADING_PERCENTAGE: '{percentage} % hochgeladen',
    PW_CHANGE_SUGGESTION:
      'Um Deine Zugangsdaten vor Missbrauch zu schützen, empfehlen wir dringend, Dein Passwort mindestens zweimal jährlich zu ändern.',
    QUALIFICATIONS: 'Qualifikationen',
    QUALIFICATIONS_EMPTY:
      'Gib hier zusätzliche Qualifikationen wie z. B. Sprachdiplome oder Zertifikate an.',
    RA_1_2_years_in_pos: '1-2 Jahren',
    RA_2_5_years_in_pos: '2-5 Jahren',
    RA_5_10_years_in_pos: '5-10 Jahren',
    RA_ACTIVE: 'Besonders aktive Mitglieder',
    RA_ACTIVE_INFO:
      'Die Nutzeraktivität wird auf Basis des Aktivitätsindex des Mitglieds bemessen. Der Index wird jedoch nur einbezogen, wenn der Nutzer ihn öffentlich freigegeben hat.',
    RA_CLOSE: 'Schließen',
    RA_GIVE_FEEDBACK_ITEM:
      'Du hast Ideen oder Anregungen zur Recruiter-Mitgliedschaft?',
    RA_GIVE_FEEDBACK_LINK: 'Gib uns Dein Feedback!',
    ra_hits: 'Treffer',
    RA_JOBSEARCH: 'Mitglieder, die an Karrierechancen interessiert sind',
    RA_JOBSEARCH_INFO:
      'Hier erscheinen Mitglieder, die in ihrem Profil unter "Warum ich auf XING bin" den Punkt "An Karrierechancen interessiert" ausgewählt haben.',
    RA_SEARCH_ERROR:
      'Bitte schränke Deine Suche durch mindestens einen Suchparameter ein.',
    RA_SEARCHHITS: 'Treffer',
    RA_TEASER_GIVE_FEEDBACK_HEADLINE: 'Deine Meinung ist uns wichtig',
    RA_XING_USAGE: 'Spezielle Kandidaten-Filter',
    RECOMMENDED_COMPANY_EMPLOYER_REVIEWS:
      '{number_of_employer_reviews} Arbeitgeber-Bewertungen',
    RECOMMENDED_COMPANY_EMPLOYER_REVIEWS_EMPTY: 'Noch keine Bewertungen',
    RECOMMENDED_COMPANY_FOLLOW_UPDATES: 'Folgen',
    RECOMMENDED_COMPANY_UNFOLLOW_UPDATES: 'Nicht mehr folgen',
    RECRUITING_FOOTER_EBP_TEXT: 'Präsentiere Dich als Wunsch-Arbeitgeber.',
    RECRUITING_FOOTER_EBP_TITLE: 'Employer Branding Profil',
    RECRUITING_FOOTER_JOBS_TEXT:
      'Finde Fachkräfte, die zu Deinem Unternehmen passen.',
    RECRUITING_FOOTER_JOBS_TITLE: 'Stellenanzeigen',
    RECRUITING_FOOTER_PROJECTS_TEXT:
      'Finde schnell die richtigen Dienstleister.',
    RECRUITING_FOOTER_PROJECTS_TITLE: 'Projekte',
    RECRUITING_FOOTER_XTM_TEXT: 'Spreche aktiv Millionen von Kandidaten an.',
    RECRUITING_FOOTER_XTM_TITLE: 'TalentManager',
    REFERENCES_AWARDS: 'Referenzen & Auszeichnungen',
    REMEMBER_PASSWORD: 'Eingeloggt bleiben',
    ROFILERAILS_PORTFOLIO_ERROR_TITLE_OR_CONTENT:
      'Diese Box enthält keinen Text.',
    SCHOOL: 'Hochschulen',
    SCHOOL_UNIVERSITY: 'Hochschule',
    SCHOOLS_EMPTY:
      'Gebe hier die von Dir besuchte Hochschule ein, um wertvolle Kontakte aus Deiner Studienzeit wieder herzustellen.',
    SE_ALL_VIEW_SEARCH_RESULTS: '{max} Ergebnisse (von {total})',
    SE_ERROR_NOTIFICATION_JOIN_GROUP: 'Das hat leider nicht geklappt.',
    SE_EXTENDED_SEARCH_LIST_DESCRIPTION: 'Erweiterte Suche im Bereich ...',
    SE_FILTER_JOBS_PROJOB_LABEL: 'Jobs von Top-Recruitern',
    SE_GROUP_BOOKMARKED_LIST: 'Gemerkt: Zur Liste',
    SE_JOBS_SUGGESTED_NAME_LOCATION: 'Jobs in {location}',
    SE_LABEL_COMMUNITIES: 'Gruppen',
    SE_LABEL_COMPANIES: 'Unternehmen',
    SE_LABEL_EVENTS: 'Events',
    SE_LABEL_JOBS: 'Jobs',
    SE_LABEL_MEMBERS: 'Mitglieder',
    SE_LABEL_NEWS: 'News',
    SE_OFFICIAL_XING_GROUPS: 'Offizielle XING Gruppen',
    SE_PREMIUM_FLAG_ALTTEXT: 'Nur für Premium-Mitglieder',
    SE_SELECT_MEMBERS: 'Mitglieder',
    SE_SHOW_ALL_RESULTS: 'Alle Ergebnisse',
    SE_SUCCESS_NOTIFICATION_GROUP_JOINED:
      'Du bist jetzt ein Mitglied dieser Gruppe!',
    SE_SUCCESS_NOTIFICATION_REQUESTED_TO_JOIN_GROUP:
      'Deine Beitrittsanfrage wurde einem Moderator dieser Gruppe gesendet.',
    SEARCH_DROPDOWN_COMPANIES: 'Unternehmen',
    SEARCH_DROPDOWN_JOBS: 'Jobs',
    SEARCH_DROPDOWN_MEMBERS: 'Mitglieder',
    SEARCH_DROPDOWN_NEWS: 'News',
    SEARCH_OFFER_INTERESTED_HINT:
      'Werde von Mitgliedern gefunden, die suchen, was Du bietest, Dir interessante Angebote machen können oder Deine Interessen teilen.',
    SEARCH_OFFER_INTERESTED_IN: 'Ich suche, Fähigkeiten, Interessen',
    SEARCH_TOPICS_TAB_SEARCH_BUTTON: 'Suchen',
    SEARCH_TOPICS_TAB_TITLE: 'Themen',
    SELECT_INDUSTRY: 'Bitte wähle eine Branche aus.',
    SELECT_LANGUAGE: 'Bitte wähle eine Sprache aus.',
    SELECT_SERVICE: 'Bitte wähle einen Anbieter aus.',
    SELECT_STATUS: 'Bitte wähle einen Status aus.',
    SERVICE: 'Anbieter',
    SETTINGS_LANGUAGES_TEXT:
      'Bitte wähle die Sprache aus, in der Du {-SITENAME} benutzen möchtest.',
    SETTINGS_MOTIVATIONS:
      '1. Neugeschäft und Aufträge generieren\n2. Neue Mitarbeiter finden\n3. Interessante Personen kennenlernen\n4. Mein Netzwerk pflegen\n5. An Events teilnehmen\n6. Alte Bekannte und Kollegen wiederfinden\n7. An Karrierechancen interessiert',
    SETTINGS_USERNAME_PASSWORD_TEXT:
      'Ändere die Zugangsdaten Deines {-SITENAME}-Benutzerkontos.',
    SHARE_ACTIONSHEET_HEADER: 'Diesen Beitrag teilen',
    SHARE_BOX_DEFAULT_ERROR_MESSAGE:
      'Das hat leider nicht geklappt. Bitte versuch es noch einmal.',
    SHARE_BOX_HEADER: 'Auf XING teilen',
    SHARE_BOX_PLACEHOLDER: 'Hier kannst Du Deinen Link kommentieren.',
    SHARE_BOX_SHARE_SUCCESS: 'Vielen Dank fürs Teilen!',
    SHARE_BOX_SUBMIT_SHARE: 'Teilen',
    SHARE_BUTTON_LABEL: 'Teilen',
    SHARE_CANCEL_BUTTON: 'Abbrechen',
    SHARE_CHAT_CONTACTS: 'Kontakt auswählen',
    SHARE_CHAT_HINT: 'Die Empfänger erhalten einzelne Nachrichten.',
    SHARE_COUNTER_LABEL:
      '{counter, plural,\n    =1 {Einmal geteilt}\n    other {#-mal geteilt}\n}',
    SHARE_FEEDBACK_GROUPS_BUTTON: 'Beitrag ansehen',
    SHARE_FEEDBACK_GROUPS_MESSAGE: '{item} in der Gruppe {group} geteilt',
    SHARE_FEEDBACK_INSIDERARTICLE_LABEL: 'Artikel',
    SHARE_FEEDBACK_JOB_LABEL: 'Job',
    SHARE_FEEDBACK_KLARTEXT_LABEL: 'Beitrag',
    SHARE_FEEDBACK_LINK_LABEL: 'Link',
    SHARE_FEEDBACK_MESSENGER_BUTTON: 'Nachricht ansehen',
    SHARE_FEEDBACK_MESSENGER_MESSAGE: '{item} per XING Nachricht geteilt',
    SHARE_FEEDBACK_NEWS_LABEL: 'Artikel',
    SHARE_FEEDBACK_PICTURE_LABEL: 'Bild',
    SHARE_FEEDBACK_POST_LABEL: 'Beitrag',
    SHARE_FEEDBACK_STARTPAGE_BUTTON: 'Beitrag ansehen',
    SHARE_FEEDBACK_STARTPAGE_MESSAGE: '{item} auf der Startseite geteilt',
    SHARE_FEEDBACK_VIDEO_LABEL: 'Video',
    SHARE_FETCH_ERROR: 'Das hat leider nicht geklappt.',
    SHARE_FETCH_ERROR_COUNTDOWN:
      "Wir versuchen's in {countdown} Sekunden noch einmal.",
    SHARE_FETCH_ERROR_RETRY: 'Jetzt erneut versuchen',
    SHARE_MOST_RECENT_CHATS: 'Unterhaltungen',
    SHARE_PREVIEW_ERROR_HEADLINE:
      'Wir können gerade leider keine Vorschau zeigen.',
    SHARE_QUICKSHARE_TO_STARTPAGE: 'Direkt auf der Startseite',
    SHARE_TEXT_BOX_LENGTH_ERROR:
      '{delta, plural, \none {Bitte gib ein Zeichen weniger ein.} \nother {Bitte gib # Zeichen weniger ein.}\n}',
    SHARE_TO_GROUPS: 'In einer Gruppe',
    SHARE_TO_GROUPS_AUTOCOMPLETE_FORUMS: 'Forum',
    SHARE_TO_GROUPS_AUTOCOMPLETE_GROUPS: 'Gruppe',
    SHARE_TO_GROUPS_SELECTION_LABEL: 'Gruppe auswählen:',
    SHARE_TO_GROUPS_TEXT_PLACEHOLDER:
      'Hier kannst Du Deinen Link kommentieren.',
    SHARE_TO_GROUPS_THREAD_LABEL: 'Dein Gruppen-Beitrag:',
    SHARE_TO_GROUPS_TITLE_PLACEHOLDER: 'Beitragstitel',
    SHARE_TO_MESSENGER: 'Als private Nachricht',
    SHARE_TO_MESSENGER_EMPTY_STATE:
      'Wir haben leider keinen "{query}" gefunden.',
    SHARE_TO_STARTPAGE: 'Mit Anmerkung auf der Startseite',
    SHARE_USER_SUBTEXT_GROUPS: 'In einer Gruppe teilen',
    SHARE_USER_SUBTEXT_MESSAGE: 'Als private Nachricht teilen',
    SHARE_USER_SUBTEXT_STARTPAGE: 'Auf der Startseite teilen',
    SHARER_LIST_HEADLINE_MEMBERS: '{total} Mitglieder haben dies geteilt.',
    SHARER_LIST_HEADLINE_MULTIPLE_MEMBERS:
      '{total} Mitglieder haben dies geteilt.',
    SHARER_LIST_HEADLINE_ONE_MEMBER: 'Ein Mitglied hat dies geteilt.',
    SHARER_LIST_ITEM_GO_TO_POST_LINK: 'Beitrag ansehen',
    SHARER_LIST_POST_NOTIFICATION:
      'Du kannst hier nicht alle Beiträge sehen, weil einige Mitglieder das in ihren Privatphäre-Einstellungen so festgelegt haben.',
    SHARERS_BACK_TO_POST_LINK: 'Zurück',
    SHARERS_LIST_BACK_LINK: 'Zurück',
    SHOW_OLD_PROFILE_INDUSTRY: 'Branche aus altem Profil anzeigen',
    SOCIAL_ADD_CONTACT: 'Kontakt-Anfrage schicken',
    SOCIAL_BAR_VIEW_COUNTER_DESCRIPTION:
      'Das zeigt Dir ab sofort immer der Zähler neben dem Augen-Symbol.',
    SOCIAL_BAR_VIEW_COUNTER_HEADING:
      'Wie oft wurde Dein Beitrag auf XING gesehen?',
    SOCIAL_BAR_VIEW_COUNTER_SEEN:
      'Dieser Beitrag von Dir wurde z. B. schon <strong>{views}-mal</strong> gesehen.',
    SOCIAL_BAR_VIEW_COUNTER_TIP:
      '<strong>Tipp:</strong> Mit ein paar Kniffen kannst Du <a>Deine Sichtbarkeit auf XING erhöhen</a>.',
    SOCIAL_COMMENT_BUTTON_LABEL: 'Kommentieren',
    SOCIAL_COMMENT_COUNTER_LABEL: '{amount} Kommentare',
    SOCIAL_COMMENT_CREATE_BUTTON_LABEL: 'Kommentieren',
    SOCIAL_COMMENT_DELETE_LABEL: 'Kommentar löschen',
    SOCIAL_COMMENT_DELETED_MESSAGE: 'Dieser Kommentar wurde gelöscht.',
    SOCIAL_COMMENT_EDIT_LABEL: 'Kommentar bearbeiten',
    SOCIAL_COMMENT_ERROR_TOO_LARGE:
      'Dieser Kommentar ist leider zu lang: Bis zu 20 Tsd. Zeichen sind erlaubt.',
    SOCIAL_COMMENT_LIST_EMPTY_HEADLINE: 'Und was meinst Du dazu?',
    SOCIAL_COMMENT_LIST_EMPTY_SUBLINE: 'Verrate uns Deine Meinung.',
    SOCIAL_COMMENT_OVERFLOW_ERROR: '{amount} Zeichen',
    SOCIAL_COMMENT_REPORT_LABEL: 'Kommentar melden',
    SOCIAL_COMMENT_WAS_EDITED: 'Bearbeitet',
    SOCIAL_COMMENTS_COUNTER_LABEL:
      "{counter, plural,\n    =0 {Kommentier's als erstes:}\n    =1 {1 Kommentar} \n    other {# Kommentare}\n}",
    SOCIAL_COMMENTS_CREATE_MENTION_PLACEHOLDER:
      'Etwas schreiben (andere mit "@" erwähnen) …',
    SOCIAL_COMMENTS_CREATE_PLACEHOLDER: 'Schreibe einen Kommentar …',
    SOCIAL_COMMENTS_DELETE_DIALOG_CANCEL: 'Abbrechen',
    SOCIAL_COMMENTS_DELETE_DIALOG_CONFIRM: 'Löschen',
    SOCIAL_COMMENTS_DELETE_DIALOG_CREATOR_TEXT:
      'Nicht zufrieden mit Deinem Kommentar? Dann kannst Du ihn einfach löschen.',
    SOCIAL_COMMENTS_DELETE_DIALOG_HEADLINE: 'Kommentar löschen?',
    SOCIAL_COMMENTS_DELETE_DIALOG_TEXT:
      'Dies kann nicht mehr rückgängig gemacht werden.',
    SOCIAL_COMMENTS_DELETE_MENTION_LABEL: 'Nicht erwähnt werden',
    SOCIAL_COMMENTS_FORM_PLACEHOLDER: 'Etwas schreiben ( mit "@" erwähnen) …',
    SOCIAL_COMMENTS_LOAD_MORE: 'Weitere Kommentare',
    SOCIAL_COMMENTS_MORE_REPLIES: 'Weitere Antworten ansehen',
    SOCIAL_COMMENTS_PREVIOUS_COMMENTS: 'Vorherige Kommentare ansehen',
    SOCIAL_COMMENTS_PREVIOUS_REPLIES: 'Vorherige Antworten ansehen',
    SOCIAL_COMMENTS_REPLY_PLACEHOLDER: 'Deine Antwort an {authorName}',
    SOCIAL_GENERIC_REPORT: 'Melden',
    SOCIAL_LIKERS_LIST_HEADLINE: 'Diesen Mitgliedern gefällt das:',
    SOCIAL_LIKERS_LIST_POST_NOTIFICATION:
      'Du kannst hier nicht alle "Gefällt mir"-Angaben sehen, weil einige Mitglieder das in ihren Privatsphäre-Einstellungen so festgelegt haben.',
    SOCIAL_PMBX_COMMENT_CONTENT_URL: 'Inhalt',
    SOCIAL_PMBX_COMMENT_DATE: 'Datum',
    SOCIAL_PMBX_COMMENT_HEADING: 'Deine Kommentare und Antworten',
    SOCIAL_PMBX_COMMENT_MESSAGE: 'Dein Kommentar',
    SOCIAL_PMBX_COMMENT_ORIGIN: 'Wo hast Du kommentiert?',
    SOCIAL_PMBX_COMMENT_TITLE: 'Deine Kommentare und Antworten',
    SOCIAL_PMBX_COMMENT_USER_AGENT: 'System-Info',
    SOCIAL_PMBX_DESCRIPTION:
      'Beiträge auf XING, die Du geteilt, kommentiert, erwähnt oder mit "Gefällt mir" markiert hast',
    SOCIAL_PMBX_REACTION_CONTENT_URL: 'Inhalt',
    SOCIAL_PMBX_REACTION_DATE: 'Datum',
    SOCIAL_PMBX_REACTION_LIKE: 'Beiträge, die Dir gefallen.',
    SOCIAL_PMBX_REACTION_ORIGIN: 'Wo hast Du auf den Beitrag reagiert?',
    SOCIAL_PMBX_REACTION_TITLE: 'Beiträge, auf die Du reagiert hast',
    SOCIAL_PMBX_REACTION_USER_AGENT: 'User Agent',
    SOCIAL_PMBX_SHARE_CONTENT_URL: 'Inhalt',
    SOCIAL_PMBX_SHARE_DATE: 'Datum',
    SOCIAL_PMBX_SHARE_GROUPS: 'Beiträge, die Du in einer Gruppe geteilt hast',
    SOCIAL_PMBX_SHARE_MESSAGE: 'Deine Anmerkung',
    SOCIAL_PMBX_SHARE_MESSENGER:
      'Beiträge, die Du als private Nachricht geteilt hast',
    SOCIAL_PMBX_SHARE_ORIGIN: 'Wo hast Du den Beitrag geteilt?',
    SOCIAL_PMBX_SHARE_STARTPAGE:
      'Beiträge, die Du auf der XING Startseite geteilt hast',
    SOCIAL_PMBX_SHARE_TITLE: 'Beiträge, die Du geteilt hast',
    SOCIAL_PMBX_SHARE_USER_AGENT: 'User Agent',
    SOCIAL_PMBX_TITLE: 'Interaktionen',
    SOCIAL_REPLIES_LOAD_MORE: 'Weitere Antworten ansehen',
    SOCIAL_REPLY_BUTTON: 'Antworten',
    SOCIAL_REPLY_DISCARD_MESSAGE:
      'Dann kannst Du ihn löschen. Vielleicht schreibst Du ja beim nächsten Mal was.',
    SOCIAL_REPLY_LOAD_MORE: 'Weitere Antwort ansehen',
    SOCIAL_REPLY_LOAD_MULTIPLE: 'Weitere Kommentare ansehen',
    SOCIAL_REPLY_POST_BUTTON: 'Antworten',
    SOCIAL_SEND_MESSAGE: 'Nachricht schreiben',
    SOCIAL_SHARE_COUNTER_LABEL: '{amount}-mal geteilt',
    SOCIAL_SHARE_EXTERNAL_LINK_ERROR:
      'Dieser Link funktioniert leider nicht – deshalb kannst Du ihn nicht teilen.',
    SOCIAL_SHARERS_LIST_HEADLINE_MEMBERS: 'Diese Mitglieder haben das geteilt:',
    SOCIAL_SHARERS_LIST_ITEM_GO_TO_POST_LINK: 'Beitrag ansehen',
    SOCIAL_SHARERS_LIST_POST_NOTIFICATION:
      'Du kannst hier nicht alle Beiträge sehen, weil einige Mitglieder das in ihren Privatphäre-Einstellungen so festgelegt haben.',
    SOCIAL_SHOW_MORE: 'Weiterlesen',
    SOCIAL_SOCIAL_PROOF_LABEL:
      '{counter, plural,\n    =1 {gefällt das:}\n    other {# gefällt das:}\n}',
    SOCIAL_UPDATE_COMMENT_LABEL: 'Speichern',
    SP_101_TEASER_ENTERPRISEGROUPS_HEADLINE:
      '<a href="/app/user?op=info.partners#enterprisegroups-info">XING Enterprise Groups</a>',
    STATE: 'Bundesland',
    STATUS: 'Beschäftigungsart',
    STATUS_BUTTON_CHANGE: 'Ändern',
    STATUS_BUTTON_SEND: 'Speichern',
    STATUS_CHANGE_COMPANY_EXPL:
      'Bitte wähle das Unternehmen, das neben Deinem Namen und oben auf Deiner Profilseite angezeigt werden soll. Trage bitte zunächst Dein aktuelles Unternehmen ein, falls dieses noch nicht aufgeführt ist.',
    STATUS_CHANGE_SCHOOL_EXPL:
      'Bitte wähle eine Hochschule aus, die neben Deinem Namen und oben auf Deiner Profilseite angezeigt werden soll. Trage bitte zunächst Deine aktuelle Hochschule ein, falls diese noch nicht aufgeführt ist.',
    STATUS_CHANGE_TO_UNEMPLOYED_HINT:
      'Halte Dein Profil immer auf dem neuesten Stand! Wenn Du auch die Felder "Ich suche" und "Fähigkeiten & Kenntnisse" ausfüllst, kannst Du schneller z. B. von einem interessanten Arbeitgeber gefunden werden.',
    STATUS_CHANGE_TO_UNEMPLOYED_HINT_TITLE:
      'Finde jetzt Deinen neuen Job auf XING!',
    STATUS_MESSAGE_DELETE: 'Löschen',
    STILL_IN_POSITION: 'bis heute',
    SUBJECT: 'Fachrichtung',
    SUBJECT_HINT: '(Fachrichtung)',
    SYSTEM_LANGUAGE: 'Dies ist Deine Systemsprache.',
    SYSTEM_LANGUAGE_LABEL: 'Systemsprache',
    TARGET_DEGREE: '(Angestrebter) Abschluss',
    TEXTAREA_EMPTY: 'Du hast in dieser Kategorie noch keine Angaben gemacht.',
    TITLE: 'Position',
    TO: 'Bis',
    TO_LOWERCASE: 'bis',
    TOP_BAR_BACK_BUTTON_ARIA_LABEL: 'Zurück',
    TOP_BAR_BACK_BUTTON_ARIA_LABEL_CUSTOM: 'Zurück zu {section}',
    TOP_BAR_ME_MENU_DIMMER_ARIA_LABEL: 'MeMenü schließen',
    TOP_BAR_PROFILE_FILLING_INDICATOR_TITLE: 'Profil',
    UNIVERSAL_CAREER_LEVEL_LIST:
      '1. Student·in / Praktikant·in\n2. Berufseinsteiger·in\n3. Mit Berufserfahrung\n4. Manager (mit und ohne Personalverantwortung)\n5. Direktor·in (z. B. Bereichsleitung, VP, SVP)\n6. Geschäftsführer·in (z. B. GF, CEO)',
    UNIVERSAL_WORKEXPERIENCE_DISCIPLINE_LIST:
      '1001. Analyse und Statistik\n1002. Administration, Sachbearbeitung und Verwaltung\n1003. Beratung / Consulting\n4. Controlling und Planung\n1004. Customer Service und Kundenbetreuung\n1005. Einkauf, Materialwirtschaft und Logistik\n1006. Finanzen, Rechnungswesen und Controlling\n1007. Forschung, Lehre und Entwicklung\n1008. Gesundheit, Medizin und Soziales\n1009. Grafik, Design und Architektur\n1010. Ingenieurwesen und technische Berufe\n1011. IT und Softwareentwicklung\n1012. Management und Unternehmensentwicklung\n1013. Marketing und Werbung\n1014. Personalwesen und HR\n1015. PR, Öffentlichkeitsarbeit und Journalismus\n1016. Produktion und Handwerk\n1017. Produktmanagement\n1018. Projektmanagement\n1019. Prozessplanung und Qualitätssicherung\n1020. Recht\n1021. Vertrieb und Handel\n1022. Sonstige Tätigkeitsfelder',
    UNIVERSITY_HINT: '(Student)',
    UPLOAD_PHOTO: 'Foto hochladen',
    UPLOAD_PHOTO_HINT:
      'Lade ein Foto hoch und werde besser von Business-Kontakten und Kollegen erkannt.',
    UPLOADER_ADD_IMAGE: 'Bild hinzufügen',
    UPLOADER_ADD_VIDEO: 'Video hinzufügen',
    UPLOADER_CANCEL_UPLOAD: 'Doch nicht hochladen',
    UPLOADER_ERROR_BODY: 'Können Sie es bitte nochmal versuchen?',
    UPLOADER_ERROR_HEADLINE: 'Das hat leider nicht geklappt.',
    UPLOADER_IMAGE_LOADING_HEADLINE: 'Dein Bild wird hochgeladen ...',
    UPLOADER_TRY_AGAIN: 'Noch einmal versuchen',
    UPLOADER_VIDEO_LOADED_BODY:
      'Wir bereiten es nun auf, damit es in bestmöglicher Qualität abgespielt werden kann. Sie können es aber gerne schon veröffentlichen oder teilen.',
    UPLOADER_VIDEO_LOADED_HEADLINE: 'Ihr Video wurde hochgeladen.',
    UPLOADER_VIDEO_LOADING_HEADLINE: 'Video wird hochgeladen ...',
    URL: 'URL',
    USER_FLAG_BUTTON_ARIA_LABEL: 'Markierung für XING {type}',
    USER_FLAG_ERROR:
      "Diese Info können wir gerade leider nicht zeigen.<br>\nVersuch's bitte später nochmal.",
    USER_FLAG_ERROR_PARAGRAPH_1:
      'Diese Info können wir gerade leider nicht zeigen.',
    USER_FLAG_ERROR_PARAGRAPH_2: "Versuch's bitte später nochmal.",
    USER_FLAG_LOADING: 'Einen Moment bitte ...',
    USER_SETTINGS_TAB_PROFILE_SETTINGS: 'Profileinstellungen',
    USER_SETTINGS_TAB_USERNAME_PASSWORD: 'Zugangsdaten',
    VERTICAL_NAV_BUSINESS_SOLUTIONS_LABEL: 'Business-Lösungen',
    VERTICAL_NAV_BUSINESS_SOLUTIONS_SHORT_LABEL: 'Business',
    VERTICAL_NAV_FIND_JOBS_LABEL: 'Jobs finden',
    VERTICAL_NAV_FOLLOWING_LABEL: 'Folgst Du',
    VERTICAL_NAV_INSIGHTS_LABEL: 'Insights',
    VERTICAL_NAV_JOB_PREFERENCES_LABEL: 'Job-Wünsche',
    VERTICAL_NAV_MESSAGES_LABEL: 'Nachrichten',
    VERTICAL_NAV_MY_POSTS_LABEL: 'Deine Beiträge',
    VERTICAL_NAV_NETWORK_LABEL: 'Netzwerk',
    VERTICAL_NAV_NETWORK_SHORT_LABEL: 'Netzwerk',
    VERTICAL_NAV_PREMIUM_FOR_BASIC_USER_LABEL: 'Premium werden',
    VERTICAL_NAV_PREMIUM_LABEL: 'Premium',
    VERTICAL_NAV_PREMIUM_SHORT_LABEL: 'Premium',
    VERTICAL_NAV_PROBUSINESS_LABEL: 'ProBusiness',
    VERTICAL_NAV_PROFILE_LABEL: 'Profil',
    VERTICAL_NAV_PROJOBS_FOR_BASIC_USER_LABEL: 'ProJobs werden',
    VERTICAL_NAV_PROJOBS_LABEL: 'ProJobs',
    VERTICAL_NAV_YOUR_JOBS_LABEL: 'Deine Jobs',
    VERTICAL_NAVIGATION_BUSINESS_SOLUTIONS: 'Business-Lösungen',
    VERTICAL_NAVIGATION_BUSINESS_SOLUTIONS_SHORT: 'Business',
    VERTICAL_NAVIGATION_CAMPUS: 'Campus',
    VERTICAL_NAVIGATION_COMMUNITIES: 'Gruppen',
    VERTICAL_NAVIGATION_COMPANIES: 'Unternehmen',
    VERTICAL_NAVIGATION_CONTACTS: 'Dein Netzwerk',
    VERTICAL_NAVIGATION_CONTACTS_SHORT: 'Netzwerk',
    VERTICAL_NAVIGATION_CONTENT_PAGES: 'News',
    VERTICAL_NAVIGATION_EVENTS: 'Eventmarkt',
    VERTICAL_NAVIGATION_FEEDBACK_AND_HELP_TITLE:
      'Die neue XING App: Feedback & Hilfe',
    VERTICAL_NAVIGATION_FEEDBACK_AND_HELP_TITLE_SHORT: 'Neue App',
    VERTICAL_NAVIGATION_FOOTER_ADVERTISE: 'Werben auf XING',
    VERTICAL_NAVIGATION_FOOTER_AMIANDO: 'Ticketing und Eventvermarktung',
    VERTICAL_NAVIGATION_FOOTER_ANDROID: 'Android',
    VERTICAL_NAVIGATION_FOOTER_ANSCHREIBEN: 'Anschreiben-Editor',
    VERTICAL_NAVIGATION_FOOTER_APP_GALLERY: 'Mobile & Desktop Apps',
    VERTICAL_NAVIGATION_FOOTER_APPS: 'Apps',
    VERTICAL_NAVIGATION_FOOTER_BEWERBUNG: 'Bewerbungsratgeber',
    VERTICAL_NAVIGATION_FOOTER_BLOG: 'Blog',
    VERTICAL_NAVIGATION_FOOTER_CAMPUS: 'Campus',
    VERTICAL_NAVIGATION_FOOTER_CAREER: 'Karriere',
    VERTICAL_NAVIGATION_FOOTER_CAREER_GUIDE: 'Karriere-Ratgeber',
    VERTICAL_NAVIGATION_FOOTER_COACHES: 'Coaches + Trainer',
    VERTICAL_NAVIGATION_FOOTER_COMMUNITY: 'Community',
    VERTICAL_NAVIGATION_FOOTER_COMPANIES: 'Unternehmen',
    VERTICAL_NAVIGATION_FOOTER_COMPANY: 'Unternehmen',
    VERTICAL_NAVIGATION_FOOTER_DEVBLOG: 'Devblog',
    VERTICAL_NAVIGATION_FOOTER_DEVELOPER_PORTAL: 'Entwickler',
    VERTICAL_NAVIGATION_FOOTER_DOWNLOAD: 'Downloads',
    VERTICAL_NAVIGATION_FOOTER_EVENTS: 'Events',
    VERTICAL_NAVIGATION_FOOTER_EXECUTIVES_MEMBERSHIP: 'Executive Circles',
    VERTICAL_NAVIGATION_FOOTER_GEHALTSVERGLEICH: 'Gehaltsvergleich',
    VERTICAL_NAVIGATION_FOOTER_GROUPS: 'Gruppen',
    VERTICAL_NAVIGATION_FOOTER_HALLO_FREELANCER: 'Freelancer verwalten',
    VERTICAL_NAVIGATION_FOOTER_HELP: 'Hilfe & Kontakt',
    VERTICAL_NAVIGATION_FOOTER_IMPRINT: 'Impressum',
    VERTICAL_NAVIGATION_FOOTER_INVESTOR_RELATIONS: 'Investor Relations',
    VERTICAL_NAVIGATION_FOOTER_IPHONE_IPAD: 'iPhone & iPad',
    VERTICAL_NAVIGATION_FOOTER_JOB_MARKET: 'Jobs',
    VERTICAL_NAVIGATION_FOOTER_JOBS_DIRECTORY: 'Jobs Verzeichnis',
    VERTICAL_NAVIGATION_FOOTER_LEBENSLAUF: 'Lebenslauf-Editor',
    VERTICAL_NAVIGATION_FOOTER_LOGINWXING: 'Button "Mit XING einloggen"',
    VERTICAL_NAVIGATION_FOOTER_MEMBERSHIP_CANCELLATION:
      'Mitgliedschaft kündigen',
    VERTICAL_NAVIGATION_FOOTER_MEMBERSHIPS: 'Mitgliedschaften',
    VERTICAL_NAVIGATION_FOOTER_MOBILE: 'XING Apps',
    VERTICAL_NAVIGATION_FOOTER_NEW_WORK_EXPERIENCE:
      'NWX – Neues zur Zukunft der Arbeit',
    VERTICAL_NAVIGATION_FOOTER_NEWWORKSE: 'New Work SE',
    VERTICAL_NAVIGATION_FOOTER_PEOPLE_DIRECTORY: 'Mitgliederverzeichnis',
    VERTICAL_NAVIGATION_FOOTER_PRAKTIKUM_GUIDE: 'Praktikum-Guide',
    VERTICAL_NAVIGATION_FOOTER_PREMIUM_MEMBERSHIP: 'Premium',
    VERTICAL_NAVIGATION_FOOTER_PRESS: 'Presse',
    VERTICAL_NAVIGATION_FOOTER_PRIVACY: 'Datenschutz bei XING',
    VERTICAL_NAVIGATION_FOOTER_PRIVACY_POLICY: 'Datenschutzerklärung',
    VERTICAL_NAVIGATION_FOOTER_PRO_BUSINESS_MEMBERSHIP: 'ProBusiness',
    VERTICAL_NAVIGATION_FOOTER_PROJOBS_MEMBERSHIP: 'ProJobs',
    VERTICAL_NAVIGATION_FOOTER_RESOURCES: 'Ressourcen',
    VERTICAL_NAVIGATION_FOOTER_SERVICES: 'Weitere Angebote',
    VERTICAL_NAVIGATION_FOOTER_TALENT_MANAGER: 'Personalgewinnung mit XING',
    VERTICAL_NAVIGATION_FOOTER_TANDC: 'AGB',
    VERTICAL_NAVIGATION_FOOTER_TRACKING: 'Tracking',
    VERTICAL_NAVIGATION_FOOTER_WINDOWS_10: 'Windows 10',
    VERTICAL_NAVIGATION_FOOTER_XAS: 'Werbeanzeige erstellen',
    VERTICAL_NAVIGATION_FOOTER_XING_AG: 'New Work SE',
    VERTICAL_NAVIGATION_FOOTER_XING_NEWS: 'XING News',
    VERTICAL_NAVIGATION_FOOTER_XING_SHARE: 'Button "Auf XING teilen"',
    VERTICAL_NAVIGATION_FOOTER_YOUR_XING: 'Hauptbereiche',
    VERTICAL_NAVIGATION_HEADER_BRAND_MANAGER_EDITOR: 'BrandManager',
    VERTICAL_NAVIGATION_HEADER_HELP: 'Hilfe',
    VERTICAL_NAVIGATION_HEADER_MANAGE_JOBS: 'Stellenanzeigen',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_ADS: 'AdManager',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_COACH_PROFILE: 'Coach-Profil',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_INVOICES: 'Rechnungen & Konten',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_LOGOUT: 'Ausloggen',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_MEMBERSHIPS_INVOICES:
      'Mitgliedschaften & Rechnungen',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_PREMIUM_MEMBERSHIP: 'Premium',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_PROBUSINESS_MEMBERSHIP: 'ProBusiness',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_MEMBERSHIP: 'ProJobs',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_SETTINGS:
      'ProJobs-Einstellungen',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_SETTINGS: 'Einstellungen',
    VERTICAL_NAVIGATION_HEADER_SEARCH_ALL_RESULTS: 'Alle Ergebnisse',
    VERTICAL_NAVIGATION_HEADER_SEARCH_BUTTON: 'Suchen',
    VERTICAL_NAVIGATION_HEADER_SEARCH_COMMUNITIES: 'Gruppen',
    VERTICAL_NAVIGATION_HEADER_SEARCH_COMPANIES_PROFILE: 'Arbeitgeber',
    VERTICAL_NAVIGATION_HEADER_SEARCH_EVENTS: 'Events',
    VERTICAL_NAVIGATION_HEADER_SEARCH_JOBS: 'Jobs',
    VERTICAL_NAVIGATION_HEADER_SEARCH_MEMBERS: 'Mitglieder',
    VERTICAL_NAVIGATION_HEADER_SEARCH_NEWS: 'Branchen-News',
    VERTICAL_NAVIGATION_HEADER_SEARCH_PLACEHOLDER:
      'Job, Namen oder Stichwort eingeben',
    VERTICAL_NAVIGATION_HEADER_SEAT_MANAGER_ADMIN: 'LizenzManager',
    VERTICAL_NAVIGATION_HEADER_XTM: 'TalentManager',
    VERTICAL_NAVIGATION_MESSAGES: 'Nachrichten',
    VERTICAL_NAVIGATION_MORE: 'Mehr',
    VERTICAL_NAVIGATION_MYPROJOBS: 'ProJobs',
    VERTICAL_NAVIGATION_OTHER_SERVICES: 'Weitere Services',
    VERTICAL_NAVIGATION_PREMIUM_BENEFITS: 'Premium',
    VERTICAL_NAVIGATION_PREMIUM_BENEFITS_FOR_BASIC_USER: 'Premium werden',
    VERTICAL_NAVIGATION_PREMIUM_BENEFITS_SHORT: 'Premium',
    VERTICAL_NAVIGATION_PROBUSINESS: 'ProBusiness',
    VERTICAL_NAVIGATION_PROJOBS_BENEFITS_FOR_BASIC_USER: 'ProJobs werden',
    VERTICAL_NAVIGATION_PROJOBS_UPSELL: 'ProJobs entdecken',
    VERTICAL_NAVIGATION_PROJOBS_UPSELL_SHORT: 'ProJobs',
    VERTICAL_NAVIGATION_STARTPAGE: 'Startseite',
    VIDEO_ENCODING_HEADLINE: 'Ihr Video wird gerade aufbereitet.',
    VIDEO_ENCODING_MESSAGE:
      'Wir bereiten gerade Dein Video so auf, dass wir es in der bestmöglichen Qualität anzeigen können. Dies kann ein paar Minuten dauern.',
    VIDEOS_AUTOPLAY: 'Automatisch abspielen',
    VIDEOS_SETTINGS: 'Videos automatisch abspielen?',
    VIDEOS_WATCH_VIDEO: 'Video ansehen',
    VIEW_PAGE_IN_CHINESE: 'Diese Seite auf Chinesisch anzeigen',
    VIEW_PAGE_IN_DUTCH: 'Diese Seite auf Niederländisch anzeigen',
    VIEW_PAGE_IN_ENGLISH: 'Diese Seite auf Englisch anzeigen',
    VIEW_PAGE_IN_FINNISH: 'Diese Seite auf Finnisch anzeigen',
    VIEW_PAGE_IN_FRENCH: 'Diese Seite auf Französisch anzeigen',
    VIEW_PAGE_IN_GERMAN: 'Diese Seite auf Deutsch anzeigen',
    VIEW_PAGE_IN_HUNGARIAN: 'Diese Seite auf Ungarisch anzeigen',
    VIEW_PAGE_IN_ITALIAN: 'Diese Seite auf Italienisch anzeigen',
    VIEW_PAGE_IN_JAPANESE: 'Diese Seite auf Japanisch anzeigen',
    VIEW_PAGE_IN_KOREAN: 'Diese Seite auf Koreanisch anzeigen',
    VIEW_PAGE_IN_POLISH: 'Diese Seite auf Polnisch anzeigen',
    VIEW_PAGE_IN_PORTUGUESE: 'Diese Seite auf Portugiesisch anzeigen',
    VIEW_PAGE_IN_RUSSIAN: 'Diese Seite auf Russisch anzeigen',
    VIEW_PAGE_IN_SPANISH: 'Diese Seite auf Spanisch anzeigen',
    VIEW_PAGE_IN_SWEDISH: 'Diese Seite auf Schwedisch anzeigen',
    VIEW_PAGE_IN_TURKISH: 'Diese Seite auf Türkisch anzeigen',
    VISIBLE_ON_MY_PROFILE: 'sichtbar für Besucher meines Profils',
    VISIBLE_TO_ALL_MEMBERS: 'für alle XING Mitglieder sichtbar',
    VISIBLE_TO_RECRUITERS: 'nur für Personalentscheider sichtbar',
    WEB: 'Web',
    WEB_PROFILES_EMPTY:
      'Gib weitere Web-Profile von Dir an, um Deine Sichtbarkeit zu erhöhen und Dich auch auf anderen Webseiten mit Deinen Kontakten zu vernetzen.',
    WELCOME_BOX:
      'Willkommen <a href="/profile/my_profile" title="{\'NAVI_EDITCONTACTPAGE}">{-FULL_NAME}</a>{!USER_ICONS}',
    WORK: 'Berufe',
    WORK_EXPERIENCE: 'Berufserfahrung',
    WORKEXPERIENCE_ADDITIONAL_INDUSTRIES: 'Weitere Branchen',
    WORKEXPERIENCE_DISCIPLINE_LIST:
      '1. Administration / Sachbearbeitung\n2. Analyse und Statistik\n3. Consulting / Beratung\n4. Controlling und Planung\n5. Customer Service / Kundenbetreuung\n6. Grafik und Design\n7. Einkauf, Materialwirtschaft und Logistik\n8. Finanzen und Rechnungswesen\n9. Forschung und Lehre\n10. Unternehmensleitung, M&A und Strategisches Management\n11. Handwerk\n12. Hard-/Softwareentwicklung\n13. Journalismus\n14. Marketing / Werbung\n15. Medizinische Berufe\n16. Öffentlichkeitsarbeit / PR\n17. Organisation und Verwaltung\n18. Personal / HR\n19. Produktion und Herstellung\n20. Produktmanagement\n21. Projektmanagement\n22. Forschung und Entwicklung\n23. Recht\n24. Vertrieb',
    WORKEXPERIENCE_GET_OLD_INDUSTRIES:
      'Branchen aus altem XING Profil übernehmen',
    WORKEXPERIENCE_ORG_TYPE_LIST:
      '1. Börsennotierte AG\n2. Gesellschaft in privater Hand\n3. Gemeinnützig\n4. Personengesellschaft\n5. Einzelunternehmen\n6. Selbstständig',
    WORKEXPERIENCE_SIZE_LIST:
      '1. Nur ich\n2. 1-10 Mitarbeitende\n3. 11-50 Mitarbeitende\n4. 51-200 Mitarbeitende\n5. 201-500 Mitarbeitende\n6. 501-1.000 Mitarbeitende\n7. 1.001-5.000 Mitarbeitende\n8. 5.001-10.000 Mitarbeitende\n9. 10.001 oder mehr Mitarbeitende',
    WORKEXPERIENCE_STATUS_LIST:
      '1. Angestellt (Vollzeit)\n2. Angestellt (Teilzeit)\n3. Praktikum\n4. Selbstständig\n5. Inhaber·in\n6. Partner·in bzw. Gesellschafter·in\n7. Vorstandsmitglied\n8. Ehrenamt\n9. Selbstständig\n10. Gesellschafter·in\n11. Beamtet\n12. Personalvermittler·in\n13. Freiberuflich\n14. Partner·in\n17. In einer Ausbildung',
    WRONG_END_DATE_HINT:
      'Du hast "bis heute" ausgewählt, das Enddatum liegt jedoch in der Vergangenheit.',
    X_UI_HEADER_REGISTER: 'Registrieren',
    X_UI_NAVIGATION_LOGIN_FRAME_FALLBACK: 'Einloggen',
    XBP_NAVIGATION_ENTRY_LINK: 'Business Pages verwalten',
    XBP_TAB_COMPANIES: 'Arbeitgeber',
    XBP_TAB_PRODUCTS_AND_SERVICES: 'Produkte und Services',
    XDS_A11Y_CHARACTER_COUNTER_MAX: 'Maximum überschritten',
    XDS_A11Y_CHARACTER_COUNTER_TEXT:
      '{currentCount} von {maxCount} Zeichen verwendet',
    XDS_A11Y_LOADING: 'Wird geladen',
    XDS_BACK_TO_TOP_BUTTON: 'Nach oben',
    XDS_BREADCRUMB_HOME: 'Home',
    XDS_CAROUSEL_NEXT_BUTTON_A11Y: 'Nächste Seite',
    XDS_CAROUSEL_PREVIOUS_BUTTON_A11Y: 'Vorherige Seite',
    XDS_CLOSE_BUTTON_A11Y: 'Schließen',
    XDS_DELETE_TAG_BUTTON_A11Y: 'Löschen',
    XDS_DISCOVER_BADGE_A11Y: 'Neue Funktion',
    XDS_EMPTYSTATE_ERROR_BUTTON: 'Noch mal versuchen',
    XDS_EMPTYSTATE_ERROR_DESCRIPTION: "Bitte versuch's noch mal.",
    XDS_EMPTYSTATE_ERROR_TITLE: 'Das hat leider nicht geklappt.',
    XDS_FEEDBACK_BAR_THUMB_DOWN_A11Y: 'Daumen runter',
    XDS_FEEDBACK_BAR_THUMB_UP_A11Y: 'Daumen hoch',
    XDS_FLAG_AMBASSADOR_DIVERSE: 'Ambassadx',
    XDS_FLAG_AMBASSADOR_FEMALE: 'Ambassadorin',
    XDS_FLAG_AMBASSADOR_MALE: 'Ambassador',
    XDS_FLAG_AMBASSADOR_NEUTRAL: 'Ambassador',
    XDS_FLAG_BASIC_DIVERSE: 'Basis',
    XDS_FLAG_BASIC_FEMALE: 'Basis',
    XDS_FLAG_BASIC_MALE: 'Basis',
    XDS_FLAG_BASIC_NEUTRAL: 'Basis',
    XDS_FLAG_BETA_DIVERSE: 'Beta',
    XDS_FLAG_BETA_FEMALE: 'Beta',
    XDS_FLAG_BETA_MALE: 'Beta',
    XDS_FLAG_BETA_NEUTRAL: 'Beta',
    XDS_FLAG_INSIDER_DIVERSE: 'Insidx',
    XDS_FLAG_INSIDER_FEMALE: 'Insiderin',
    XDS_FLAG_INSIDER_MALE: 'Insider',
    XDS_FLAG_INSIDER_NEUTRAL: 'Insider',
    XDS_FLAG_MODERATOR_DIVERSE: 'Moderatx',
    XDS_FLAG_MODERATOR_FEMALE: 'Moderatorin',
    XDS_FLAG_MODERATOR_MALE: 'Moderator',
    XDS_FLAG_MODERATOR_NEUTRAL: 'Moderator',
    XDS_FLAG_NEW_DIVERSE: 'Neu',
    XDS_FLAG_NEW_FEMALE: 'Neu',
    XDS_FLAG_NEW_MALE: 'Neu',
    XDS_FLAG_NEW_NEUTRAL: 'Neu',
    XDS_FLAG_PREMIUM_DIVERSE: 'Premium',
    XDS_FLAG_PREMIUM_FEMALE: 'Premium',
    XDS_FLAG_PREMIUM_MALE: 'Premium',
    XDS_FLAG_PREMIUM_NEUTRAL: 'Premium',
    XDS_FLAG_PROBUSINESS_DIVERSE: 'ProBusiness',
    XDS_FLAG_PROBUSINESS_FEMALE: 'ProBusiness',
    XDS_FLAG_PROBUSINESS_MALE: 'ProBusiness',
    XDS_FLAG_PROBUSINESS_NEUTRAL: 'ProBusiness',
    XDS_FLAG_PROCOACH_DIVERSE: 'ProCoach',
    XDS_FLAG_PROCOACH_FEMALE: 'ProCoach',
    XDS_FLAG_PROCOACH_MALE: 'ProCoach',
    XDS_FLAG_PROCOACH_NEUTRAL: 'ProCoach',
    XDS_FLAG_PROJOBS_DIVERSE: 'ProJobs',
    XDS_FLAG_PROJOBS_FEMALE: 'ProJobs',
    XDS_FLAG_PROJOBS_MALE: 'ProJobs',
    XDS_FLAG_PROJOBS_NEUTRAL: 'ProJobs',
    XDS_FLAG_PROTRAINER_DIVERSE: 'ProTrainx',
    XDS_FLAG_PROTRAINER_FEMALE: 'ProTrainerin',
    XDS_FLAG_PROTRAINER_MALE: 'ProTrainer',
    XDS_FLAG_PROTRAINER_NEUTRAL: 'ProTrainer',
    XDS_INPUT_BAR_CLEAR_BUTTON_A11Y: 'Eingabe löschen',
    XDS_MINI_BADGE_A11Y: 'Neue Benachrichtigung',
    'XDS_NOTIFICATION_BADGE_GENERIC_A11Y.one': 'Eine neue Benachrichtigung',
    'XDS_NOTIFICATION_BADGE_GENERIC_A11Y.other':
      '{value} neue Benachrichtigungen',
    XDS_SKELETON_GENERIC_A11Y: 'Wird geladen',
    XDS_STAR_RATING_A11Y: 'Bewertung: {rating} von 5 Sternen',
    XDS_STAR_RATING_NO_RATING_A11Y: 'Keine Bewertung vorhanden',
    XING_FAQ_GUIDE_URL:
      'https://help.xing.com/hc/de/articles/33816993574801-Netzwerken-so-geht-s?segment=b2c ',
    XINGID_ADD_LEAD_SUCCESS: '{displayName} als Lead hinzugefügt',
    XINGID_REMOVE_LEAD_SUCCESS: '{displayName} als Lead entfernt',
    XTP_FOLLOW_COMPANY_SURVEY_LIGHTBOX_CANCEL: 'Jetzt nicht',
    XTP_FOLLOW_COMPANY_SURVEY_LIGHTBOX_CONTENT_1:
      'Bitte beantworte uns zwei Fragen, damit wir unser Informationsangebot noch besser auf Deine Interessen abstimmen können. Vielen Dank!',
    XTP_FOLLOW_COMPANY_SURVEY_LIGHTBOX_CTA: 'Zur Umfrage',
    XTP_FOLLOW_COMPANY_SURVEY_LIGHTBOX_TITLE:
      'Was möchtest Du über diesen Arbeitgeber erfahren?',
    XTP_IDEAL_EMPLOYER_DUPLICATED_LIGHTBOX_HEADLINE:
      'Diesem Arbeitgeber hast Du bereits Dein Interesse mitgeteilt.',
    XTP_IDEAL_EMPLOYER_LIGHTBOX_BUTTON: 'Wunsch-Arbeitgeber bearbeiten',
    XTP_IDEAL_EMPLOYER_LIGHTBOX_CONTENT:
      'In Deinen Einstellungen kannst Du jederzeit Deine Wunsch-Arbeitgeber bearbeiten.',
    XTP_IDEAL_EMPLOYER_SUCCESS_LIGHTBOX_HEADLINE:
      'Wunsch-Arbeitgeber benachrichtigt',
    XWS_100_APP_PERMISSION_VENDOR_VIDEOS:
      'Zugriff auf die Video-API für Werbetreibende',
    XWS_100_APP_PERMISSION_VENDOR_VIDEOS_HEADING: 'XING Video-API',
    XWS_100_INACTIVE_MEMBER: 'Inaktives Mitglied',
    YEAR: 'Jahr',
    YEARS: 'Jahre',
    YOUR_BIRTHDAY: 'Dein Geburtstag',
    YOUR_CURRENT_ADDRESS: 'Deine aktuelle Geschäftsadresse',
    YOUR_CURRENT_COMPANY: 'Deine aktuelle Firma',
    YOUR_LANGUAGE_NOT_AVAIL: 'Deine Sprache steht nicht zur Auswahl?',
    YOUR_PIC: 'Dein Foto',
    YOUR_PREVIOUS_COMPANIES: 'Deine vorherigen Firmen',
    YOUR_STATUS: 'Dein Status',
    YOUR_UNIVERSITY: 'Deine Hochschule',
    ZIP_CODE: 'PLZ',
  },
};
